// Perfect Plan quiz: overlay UI, persistence, and computePlan.

function stripPossessive(s) {
  if (!s) return '';
  var t = String(s).trim();
  if (t.length >= 2 && (t.slice(-2) === "'s" || t.slice(-2) === '\u2019s')) return t.slice(0, -2).trim();
  return t;
}

function displayNameFromSources(storedName, hiddenFieldValue) {
  if (storedName && String(storedName).trim()) return String(storedName).trim();
  var fromHidden = stripPossessive(hiddenFieldValue);
  return fromHidden || 'your dog';
}

function possessiveLabel(displayName) {
  if (!displayName || displayName === 'your dog') return 'your dog\u2019s'; 
  return displayName + '\u2019s';
}

// ── Pack builder: one quiz profile per dog (localStorage + artie_pets_store) ──
function normalizeDogKey(name) {
  return String(name || '')
    .trim()
    .toLowerCase()
    .replace(/['\u2019]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'dog';
}

function dogKeyFromNameAndId(name, packId) {
  return normalizeDogKey(name) + '__' + String(packId);
}

/**
 * Coalesces repeated `artie-dogs` / `artie_pets_store` reads during one synchronous run (e.g. `variant:update`).
 * @type {{ depth: number, ctx: any, ctxReady: boolean, pets: any, petsReady: boolean } | null}
 */
var artieLsReadBundle = null;

function artieBeginLsReadBundle() {
  if (!artieLsReadBundle) {
    artieLsReadBundle = { depth: 0, ctx: null, ctxReady: false, pets: null, petsReady: false };
  }
  artieLsReadBundle.depth++;
}

function artieEndLsReadBundle() {
  if (!artieLsReadBundle) return;
  artieLsReadBundle.depth--;
  if (artieLsReadBundle.depth <= 0) {
    artieLsReadBundle = null;
  }
}

/**
 * Prefer `artie_active_pack_dog_id` (set by pack-builder on pill select) over `artie-dogs-active`,
 * which can desync after pets-store → pack sync (e.g. quiz submit leaving index 0 while ddd is still the chosen id).
 * @param {any[]} dogs
 * @returns {number}
 */
function artiePackRowIndexFromLocalStorage(dogs) {
  if (!dogs || !dogs.length) return 0;
  var n = dogs.length;
  try {
    var aid = localStorage.getItem('artie_active_pack_dog_id');
    if (aid != null && String(aid).trim() !== '') {
      var want = String(aid).trim();
      for (var i = 0; i < n; i++) {
        if (dogs[i] != null && String(dogs[i].id) === want) return i;
      }
    }
  } catch (eAid) {}
  var idx = parseInt(localStorage.getItem('artie-dogs-active') || '0', 10);
  if (isNaN(idx) || idx < 0 || idx >= n) idx = 0;
  return idx;
}

function getActivePackDogContext() {
  try {
    if (artieLsReadBundle && artieLsReadBundle.ctxReady) {
      return artieLsReadBundle.ctx;
    }
    var raw = localStorage.getItem('artie-dogs');
    if (!raw) {
      if (artieLsReadBundle) {
        artieLsReadBundle.ctx = null;
        artieLsReadBundle.ctxReady = true;
      }
      return null;
    }
    var dogs = JSON.parse(raw);
    if (!Array.isArray(dogs) || !dogs.length) {
      if (artieLsReadBundle) {
        artieLsReadBundle.ctx = null;
        artieLsReadBundle.ctxReady = true;
      }
      return null;
    }
    var idx = artiePackRowIndexFromLocalStorage(dogs);
    var d = dogs[idx];
    if (!d) {
      idx = 0;
      d = dogs[0];
    }
    var out = {
      id: d.id,
      name: String(d.name == null ? '' : d.name).trim(),
      weight: d.weight != null && d.weight !== '' ? Number(d.weight) : null,
      dogKey: dogKeyFromNameAndId(d.name, d.id)
    };
    if (artieLsReadBundle) {
      artieLsReadBundle.ctx = out;
      artieLsReadBundle.ctxReady = true;
    }
    return out;
  } catch (e) {
    if (artieLsReadBundle) {
      artieLsReadBundle.ctx = null;
      artieLsReadBundle.ctxReady = true;
    }
    return null;
  }
}

function getQuizKeyBase(ctx) {
  if (ctx && ctx.id != null) return 'artie_dog_quiz_' + String(ctx.id) + '_';
  return 'artie_dog_0_';
}

function petFromStoreForPackId(store, packId) {
  if (packId == null || packId === '') return null;
  var sid = String(packId);
  for (var i = 0; i < store.pets.length; i++) {
    var p = store.pets[i];
    if (!p) continue;
    if (String(p.pack_dog_id) === sid) return p;
    var pd = String(p.pack_dog_id || '');
    var m = pd.match(/^calc_(\d+)/);
    if (m && m[1] === sid) return p;
  }
  return null;
}

/** Maps `pack_dog_id` to a stable integer for `artie-dogs` rows (pack-builder requires numeric ids). */
function artieNumericPackRowId(pid) {
  if (pid === 'solo' || pid === null || pid === undefined || pid === '') return NaN;
  if (typeof pid === 'number' && !isNaN(pid)) return pid;
  var s = String(pid);
  if (/^\d+$/.test(s)) return parseInt(s, 10);
  var m = s.match(/^calc_(\d+)/);
  if (m) return parseInt(m[1], 10);
  return NaN;
}

/** Newest row from standalone calculator submits (`quiz_source: calculator_page`). */
function newestCalculatorPagePet(store) {
  var pets = (store && store.pets) || [];
  var best = null;
  var bestT = '';
  for (var i = 0; i < pets.length; i++) {
    var p = pets[i];
    if (!p || !p.attributes) continue;
    if (String(p.attributes.quiz_source || '') !== 'calculator_page') continue;
    var t = String(p.attributes.last_quiz_at || '');
    if (!best || t >= bestT) {
      bestT = t;
      best = p;
    }
  }
  return best;
}

/**
 * PDP personalized strip + portion hint: named pack dog (artie-dogs) wins; else `is_primary` store pet;
 * else newest calculator_page pet so calculator-only sessions still show under the dog on PDP.
 * @returns {{ name: string, weight: number|null, petForStore: any|null, ctx: any|null }}
 */
function resolvePersonalizedStripContext() {
  var store = readArtiePetsStore();
  var ctx = getActivePackDogContext();
  if (ctx && String(ctx.name || '').trim()) {
    var pet = ctx.id != null ? petFromStoreForPackId(store, ctx.id) : null;
    var w =
      ctx.weight != null && ctx.weight !== '' && !isNaN(Number(ctx.weight)) && Number(ctx.weight) > 0
        ? Number(ctx.weight)
        : null;
    if (w == null && pet && pet.attributes) {
      var pw = pet.attributes.weight;
      if (pw != null && !isNaN(Number(pw))) w = Number(pw);
    }
    return { name: String(ctx.name).trim(), weight: w, petForStore: pet, ctx: ctx };
  }
  var pets = store.pets || [];
  for (var j = 0; j < pets.length; j++) {
    var pr = pets[j];
    if (pr && pr.is_primary && String(pr.name || '').trim()) {
      var a = pr.attributes || {};
      var w2 = a.weight != null && !isNaN(Number(a.weight)) ? Number(a.weight) : null;
      return { name: String(pr.name).trim(), weight: w2, petForStore: pr, ctx: null };
    }
  }
  var calc = newestCalculatorPagePet(store);
  if (calc && String(calc.name || '').trim()) {
    var ac = calc.attributes || {};
    var w3 = ac.weight != null && !isNaN(Number(ac.weight)) ? Number(ac.weight) : null;
    return { name: String(calc.name).trim(), weight: w3, petForStore: calc, ctx: null };
  }
  return { name: '', weight: null, petForStore: null, ctx: ctx };
}

function syncJsDogNameDisplays() {
  var ctx = getActivePackDogContext();
  var hidden = document.getElementById('dogName');
  var skipPackNameFill = hidden && hidden.closest && hidden.closest('[data-artie-calculator-standalone]');
  if (hidden && !skipPackNameFill) {
    if (ctx && String(ctx.name || '').trim()) {
      hidden.value = possessiveLabel(ctx.name.trim());
    } else if (ctx) {
      hidden.value = '';
    }
  }
  var plain = (ctx && ctx.name) ? ctx.name.trim() : stripPossessive(hidden && hidden.value);
  var displayPlain = plain || 'your dog';
  var possessive = possessiveLabel(displayPlain);
  document.querySelectorAll('.js-dog-name').forEach(function(el) {
    if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT') return;
    var mode = el.getAttribute('data-dog-name-mode');
    el.textContent = mode === 'possessive' ? possessive : displayPlain;
  });
  var submitName = document.getElementById('calcSubmitName');
  if (submitName) submitName.textContent = possessive;
}

/**
 * Cart drawer markup includes empty `.js-dog-name` from Liquid; `syncJsDogNameDisplays` fills it.
 * After `cart:update`, the theme morphs `data-hydration-key="cart-drawer-inner"` and replaces that node,
 * wiping the text. Section morph can finish later than a single timeout (e.g. second network pass ~2s),
 * so we re-sync on a schedule and via a MutationObserver on the drawer inner.
 */
var artieCartDogNamePostMorphTimer = null;
var artieCartDogNameResyncGeneration = 0;
var artieCartDogNameObserverTimer = null;
/** @type {MutationObserver | null} */
var artieCartDogNameObserver = null;
/** @type {Element | null} */
var artieCartDogNameObservedInner = null;

function artieCartDrawerPersonalizedDogNameDesired() {
  var ctx = getActivePackDogContext();
  var hidden = document.getElementById('dogName');
  var plain = ctx && ctx.name ? ctx.name.trim() : stripPossessive(hidden && hidden.value);
  var displayPlain = plain || 'your dog';
  var possessive = possessiveLabel(displayPlain);
  return { displayPlain: displayPlain, possessive: possessive };
}

function artieCartDrawerDogNameNeedsSync() {
  var inner = document.querySelector('[data-hydration-key="cart-drawer-inner"]');
  if (!inner) return false;
  var el = inner.querySelector('.cart-personalized-text .js-dog-name');
  if (!el || el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT') return false;
  var d = artieCartDrawerPersonalizedDogNameDesired();
  var mode = el.getAttribute('data-dog-name-mode');
  var want = mode === 'possessive' ? d.possessive : d.displayPlain;
  return String(el.textContent) !== String(want);
}

function artieOnCartDrawerInnerMutated() {
  clearTimeout(artieCartDogNameObserverTimer);
  artieCartDogNameObserverTimer = setTimeout(function() {
    artieCartDogNameObserverTimer = null;
    if (artieCartDrawerDogNameNeedsSync()) syncJsDogNameDisplays();
  }, 40);
}

function ensureArtieCartDrawerDogNameObserver() {
  var inner = document.querySelector('[data-hydration-key="cart-drawer-inner"]');
  if (!inner) return;
  if (artieCartDogNameObserver && artieCartDogNameObservedInner !== inner) {
    artieCartDogNameObserver.disconnect();
    artieCartDogNameObserver = null;
    artieCartDogNameObservedInner = null;
  }
  if (artieCartDogNameObserver) return;
  artieCartDogNameObservedInner = inner;
  artieCartDogNameObserver = new MutationObserver(artieOnCartDrawerInnerMutated);
  artieCartDogNameObserver.observe(inner, { childList: true, subtree: true });
}

var artieCartDrawerObserverBindAttempts = 0;
function tryBindArtieCartDrawerDogNameObserver() {
  ensureArtieCartDrawerDogNameObserver();
  if (artieCartDogNameObserver) return;
  if (artieCartDrawerObserverBindAttempts++ < 40) {
    setTimeout(tryBindArtieCartDrawerDogNameObserver, 150);
  }
}

function scheduleSyncJsDogNameDisplaysAfterCartDomRefresh() {
  var gen = ++artieCartDogNameResyncGeneration;
  if (artieCartDogNamePostMorphTimer) clearTimeout(artieCartDogNamePostMorphTimer);
  var run = function() {
    if (gen !== artieCartDogNameResyncGeneration) return;
    syncJsDogNameDisplays();
  };
  var runIfStillWrong = function() {
    if (gen !== artieCartDogNameResyncGeneration) return;
    if (artieCartDrawerDogNameNeedsSync()) syncJsDogNameDisplays();
  };
  queueMicrotask(run);
  requestAnimationFrame(function() {
    requestAnimationFrame(run);
  });
  var delays = [120, 350, 700, 1400, 2200, 3000];
  for (var i = 0; i < delays.length; i++) {
    (function(ms) {
      setTimeout(run, ms);
    })(delays[i]);
  }
  artieCartDogNamePostMorphTimer = setTimeout(function() {
    artieCartDogNamePostMorphTimer = null;
    runIfStillWrong();
  }, 3400);
  tryBindArtieCartDrawerDogNameObserver();
}

function renameQuizPetAfterNameChange(packDogId, newName) {
  var store = readArtiePetsStore();
  var nm = String(newName || '').trim();
  var nextKey = dogKeyFromNameAndId(nm, packDogId);
  var p = petFromStoreForPackId(store, packDogId);
  if (p) {
    if (!p.attributes) p.attributes = {};
    var prevName = String(p.name == null ? '' : p.name).trim();
    var prevKeyAttr = p.attributes.dog_key != null ? String(p.attributes.dog_key) : '';
    var prevKeyRoot = p.dog_key != null ? String(p.dog_key) : '';
    if (prevName === nm && prevKeyAttr === nextKey && prevKeyRoot === nextKey) {
      syncJsDogNameDisplays();
      syncArtiePersonalizedStrip();
      return;
    }
    p.name = nm;
    p.dog_key = nextKey;
    p.attributes.dog_key = nextKey;
    markArtieDogDataLocalDirty();
    writeArtiePetsStore(store);
    syncJsDogNameDisplays();
    syncArtiePersonalizedStrip();
    return;
  }
  syncJsDogNameDisplays();
  syncArtiePersonalizedStrip();
}

function onArtieDogNameChanged(ev) {
  var d = ev.detail || {};
  if (d.packDogId == null) return;
  renameQuizPetAfterNameChange(d.packDogId, d.newName);
  scheduleSyncMultipleDogAtcStore();
}

function mergePetWeightInArtieStore(packDogId, weight) {
  if (packDogId == null || weight == null || isNaN(weight) || !isArtieDogWeightInRange(Number(weight))) return;
  try {
    var store = readArtiePetsStore();
    var pet = petFromStoreForPackId(store, packDogId);
    if (!pet) return;
    if (!pet.attributes) pet.attributes = {};
    var prev = pet.attributes.weight;
    var prevNum = typeof prev === 'number' ? prev : parseInt(String(prev), 10);
    if (!isNaN(prevNum) && prevNum === weight) return;
    pet.attributes.weight = weight;
    markArtieDogDataLocalDirty();
    writeArtiePetsStore(store);
  } catch (e) {}
}

/** Keep `artie-dogs` (pack-builder source) in sync when weight changes from quiz overlay or metafield merge. */
function patchArtieDogsLocalStorageWeight(packDogId, weightNum) {
  if (packDogId == null || weightNum == null || isNaN(weightNum) || !isArtieDogWeightInRange(Number(weightNum))) return;
  try {
    var raw = localStorage.getItem('artie-dogs');
    if (!raw) return;
    var dogs = JSON.parse(raw);
    if (!Array.isArray(dogs)) return;
    var sid = String(packDogId);
    var w = Math.round(Number(weightNum));
    if (isNaN(w) || w <= 0) return;
    var changed = false;
    for (var i = 0; i < dogs.length; i++) {
      if (dogs[i] != null && String(dogs[i].id) === sid) {
        dogs[i].weight = w;
        changed = true;
        break;
      }
    }
    if (changed) {
      localStorage.setItem('artie-dogs', JSON.stringify(dogs));
    }
  } catch (e) {}
}

function dispatchArtiePackDogsFromStoreEvent(skipDogWeightQuizSync) {
  document.dispatchEvent(
    new CustomEvent('artie:pack-dogs-from-store', {
      bubbles: true,
      detail: { skipDogWeightQuizSync: !!skipDogWeightQuizSync }
    })
  );
}

function notifyPackBuilderReloadFromArtieDogs() {
  try {
    dispatchArtiePackDogsFromStoreEvent(true);
  } catch (e) {}
}

var artiePackWeightRecalcTimer = null;

function syncCalcOverlayWeightIfOpen(weightStr) {
  var overlay = document.querySelector('#calcOverlay[role="dialog"]');
  if (!overlay || overlay.style.display !== 'block') return;
  var weightInput = overlay.querySelector('#calcWeight');
  if (!weightInput) return;
  weightInput.value = weightStr;
  updateCalcWeight(weightStr, weightInput);
}

/** Persist quiz weight keys, pets store + portion, and sync variant after pack-builder weight edit. */
function persistQuizFromPackWeightChange(dog, reco, opts) {
  opts = opts || {};
  var ctx = getActivePackDogContext();
  if (!ctx || ctx.id == null) return;
  var keyBase = getQuizKeyBase(ctx);
  try {
    if (dog.weight != null && !isNaN(dog.weight) && isArtieDogWeightInRange(Number(dog.weight))) {
      localStorage.setItem(keyBase + 'weight', String(dog.weight));
      localStorage.setItem('artie_dog_weight', String(dog.weight));
    }
    localStorage.setItem(keyBase + 'last_updated', new Date().toISOString());
  } catch (e) {}
  try {
    saveQuizToArtiePetsStore(dog, reco, {
      preserveUserVariantSelection: !!opts.preserveUserVariantSelection
    });
  } catch (e2) {}
  if (dog.weight != null && !isNaN(dog.weight) && isArtieDogWeightInRange(Number(dog.weight))) {
    patchArtieDogsLocalStorageWeight(ctx.id, dog.weight);
    if (!opts.skipPackBuilderReload) {
      notifyPackBuilderReloadFromArtieDogs();
    }
  }
  syncJsDogNameDisplays();
  if (opts.preserveUserVariantSelection) {
    syncActiveDogVariantPickerFromStore();
  } else if (reco && reco.portion) {
    applyQuizPortionToVariantPicker(reco.portion);
  } else {
    syncVariantPickerFromQuizStore();
  }
  syncArtiePersonalizedStrip();
  scheduleArtieMealPlanContext();
}

function applyPackWeightQuizSideEffects(packDogId, weightNum, opts) {
  var ctx = getActivePackDogContext();
  var isActive = ctx && String(ctx.id) === String(packDogId);

  if (weightNum != null && !isNaN(weightNum) && isArtieDogWeightInRange(weightNum)) {
    if (!isActive) {
      mergePetWeightInArtieStore(packDogId, weightNum);
      patchArtieDogsLocalStorageWeight(packDogId, weightNum);
      notifyPackBuilderReloadFromArtieDogs();
      return;
    }
    var profile = loadQuizDogProfile();
    var dog = {
      name: profile.name || (ctx && ctx.name) || '',
      breed: profile.breed || 'Unknown / Mixed Breed',
      weight: weightNum,
      age: profile.age != null && !isNaN(profile.age) ? profile.age : 3,
      gender: profile.gender || '',
      spayed: profile.spayed || 'yes',
      activity: profile.activity || 'moderately_active',
      bcs: profile.bcs || '3',
      sensitive: profile.sensitive || 'no',
      pickiness: profile.pickiness || 'not_picky',
      treats: profile.treats || 'sometimes'
    };
    var reco = recommendPortion(dog);
    persistQuizFromPackWeightChange(dog, reco, {
      skipPackBuilderReload: true,
      preserveUserVariantSelection: !!(opts && opts.activeDogSwitch)
    });
    syncCalcOverlayWeightIfOpen(String(weightNum));
    return;
  }

  if (isActive) {
    try {
      var kb = getQuizKeyBase(ctx);
      localStorage.setItem(kb + 'weight', '');
    } catch (e3) {}
    syncCalcOverlayWeightIfOpen('');
  }
}

function onArtieDogWeightChanged(ev) {
  var d = ev.detail || {};
  if (d.packDogId == null) return;
  var wn = d.weightNum;
  var sideOpts = { activeDogSwitch: !!d.activeDogSwitch };
  if (d.immediate) {
    if (artiePackWeightRecalcTimer) clearTimeout(artiePackWeightRecalcTimer);
    artiePackWeightRecalcTimer = null;
    applyPackWeightQuizSideEffects(d.packDogId, wn, sideOpts);
    return;
  }
  if (artiePackWeightRecalcTimer) clearTimeout(artiePackWeightRecalcTimer);
  artiePackWeightRecalcTimer = setTimeout(function() {
    artiePackWeightRecalcTimer = null;
    applyPackWeightQuizSideEffects(d.packDogId, wn, sideOpts);
  }, 200);
}

/** Drop per-dog quiz keys, pets store row, and shared legacy globals if that dog was active. */
function purgeDogQuizStorage(packDogId, wasActive) {
  if (packDogId == null || packDogId === '') return;
  var sid = String(packDogId);
  var prefix = 'artie_dog_quiz_' + sid + '_';
  try {
    var toRemove = [];
    for (var i = 0; i < localStorage.length; i++) {
      var k = localStorage.key(i);
      if (k && k.indexOf(prefix) === 0) toRemove.push(k);
    }
    for (var j = 0; j < toRemove.length; j++) localStorage.removeItem(toRemove[j]);
  } catch (e) {}

  try {
    var store = readArtiePetsStore();
    store.pets = (store.pets || []).filter(function(p) {
      return !p || String(p.pack_dog_id) !== sid;
    });
    markArtieDogDataLocalDirty();
    writeArtiePetsStore(store);
  } catch (e2) {}

  if (wasActive) {
    try {
      localStorage.removeItem('artie_dog_name');
      localStorage.removeItem('artie_dog_breed');
      localStorage.removeItem('artie_dog_weight');
    } catch (e3) {}
  }
  syncJsDogNameDisplays();
  syncArtiePersonalizedStrip();
}

function onArtieDogRemoved(ev) {
  var d = ev.detail || {};
  if (d.packDogId == null) return;
  removeMultipleDogAtcEntryByDogId(artieCustomerDogIdFromPackRowId(d.packDogId));
  purgeDogQuizStorage(d.packDogId, !!d.wasActive);
  scheduleSyncMultipleDogAtcStore();
}

function onArtieActiveDogOrStorageChanged() {
  syncJsDogNameDisplays();
  // Restore artie portion blocks from the previous dog and apply the new dog’s `unavailable`
  // map *before* applying recommended portion — otherwise `findPortionRadioInput` skips radios
  // that are still aria-disabled from the prior dog and the picker never updates.
  syncArtiePortionVariantAvailabilityFromRecommendedStore();
  requestAnimationFrame(function() {
    syncActiveDogVariantPickerFromStore();
    scheduleArtiePortionVariantAvailabilitySync();
  });
  syncArtiePersonalizedStrip();
  scheduleArtieMealPlanContext();
  scheduleSyncMultipleDogAtcStore();
}

// ── Variant picker: portion from artie_pets_store → radios / selects ──
function getMainVariantPicker() {
  return (
    document.querySelector('variant-picker[data-template-product-match="true"]') ||
    document.querySelector('main variant-picker') ||
    document.querySelector('variant-picker')
  );
}

/** Last variant from `variant:update` on the main PDP picker (fallback: JSON script in picker). */
var artieLastMainVariant = null;

/** Portion label to apply after a dog-switch recipe change finishes `variant:update`. */
var artiePendingDogSwitchPortionApply = '';
var artieApplyingDogSwitchVariantSync = false;

/**
 * @param {EventTarget | null} target
 * @returns {boolean}
 */
function artieIsMainPdpVariantPickerEventTarget(target) {
  if (!(target instanceof Element)) return false;
  var picker = target.closest('variant-picker');
  if (!(picker instanceof HTMLElement)) return false;
  if (picker.dataset.templateProductMatch !== 'true') return false;
  if (picker.closest('product-card') || picker.closest('quick-add-dialog')) return false;
  return true;
}

function parseStripOptionPositionFromDataInputId(dataInputId) {
  var m = String(dataInputId || '').match(/^(\d+)/);
  if (!m) return 9999;
  var n = parseInt(m[1], 10);
  return isNaN(n) ? 9999 : n;
}

function collectStripVariantLabelsFromPicker(picker) {
  if (!picker) return '';
  var form = picker.querySelector('form');
  if (!form) return '';
  var rows = [];
  form.querySelectorAll('input.js-variant-option-input:checked').forEach(function(inp) {
    var pos = parseStripOptionPositionFromDataInputId(inp.getAttribute('data-input-id'));
    var v = (inp.getAttribute('data-js-option-value') || inp.value || '').trim();
    if (v) rows.push({ pos: pos, v: v });
  });
  form.querySelectorAll('select.variant-option__select, select.js-variant-option-input').forEach(function(sel) {
    var opt = sel.selectedOptions && sel.selectedOptions[0];
    if (!opt) return;
    var pos = parseStripOptionPositionFromDataInputId(opt.getAttribute('data-input-id'));
    var v = (opt.getAttribute('data-js-option-value') || opt.value || opt.textContent || '').trim();
    if (v) rows.push({ pos: pos, v: v });
  });
  rows.sort(function(a, b) {
    return a.pos - b.pos;
  });
  return rows
    .map(function(r) {
      return r.v;
    })
    .join(' / ');
}

/**
 * @param {HTMLElement | null} picker
 * @returns {string}
 */
function artieRecipeLineFromLiveVariantPicker(picker) {
  var line = collectStripVariantLabelsFromPicker(picker || getMainVariantPicker());
  return artieRecipeOnlyFromCartLineTitle(line) || line;
}

function getCurrentMainVariantSnapshot() {
  if (artieLastMainVariant) return artieLastMainVariant;
  var picker = getMainVariantPicker();
  if (!picker) return null;
  var script = picker.querySelector('script[type="application/json"]');
  if (!script || !script.textContent) return null;
  try {
    return JSON.parse(script.textContent);
  } catch (e) {
    return null;
  }
}

function artieVariantTitleForStrip(variant) {
  if (!variant) return '';
  if (variant.title != null && String(variant.title).trim() !== '') {
    return String(variant.title).trim().replace(/\s*\/\s*/g, ' · ');
  }
  var opts = variant.options;
  if (Array.isArray(opts) && opts.length) {
    return opts
      .map(function(o) {
        return o == null ? '' : String(o).trim();
      })
      .filter(Boolean)
      .join(' · ');
  }
  var parts = [variant.option1, variant.option2, variant.option3].filter(function(x) {
    return x != null && String(x).trim() !== '';
  });
  return parts.map(String).join(' · ');
}

/**
 * True when the option/title segment is only a portion tier (Full/Half/Topper), not recipe copy
 * like "Chicken Half Bowl" (recipe names must not match as portion-only).
 */
function artieOptionValueIsPortionOnly(val) {
  var s = String(val || '')
    .trim()
    .toLowerCase();
  if (!s) return false;
  if (/(harvest|power)\s+bowl|\bbowl\b/i.test(s)) return false;
  if (/chicken|beef|salmon|turkey|lamb|duck|fish|venison/.test(s) && /\b(bowl|stew|blend)\b/i.test(s)) return false;
  if (s === 'full' || s === 'half' || s === 'topper' || s === 'top') return true;
  if (s === 'full portions' || s === 'half portions' || s === 'full portion' || s === 'half portion') return true;
  if (/^full\s+portions?$/.test(s) || /^half\s+portions?$/.test(s)) return true;
  if (s.length > 28) return false;
  if (/^topper\b/.test(s)) return true;
  if (/^full\b/.test(s)) return true;
  if (/^half\b/.test(s)) return true;
  return false;
}

/** Recipe line only (excludes portion option) for `current_recipe` / pet.attributes. */
function artieRecipeOnlyFromVariant(variant) {
  if (!variant) return '';
  var opts = [];
  if (Array.isArray(variant.options) && variant.options.length) {
    opts = variant.options
      .map(function (o) {
        return o == null ? '' : String(o).trim();
      })
      .filter(Boolean);
  } else {
    [variant.option1, variant.option2, variant.option3].forEach(function (o) {
      if (o != null && String(o).trim() !== '') opts.push(String(o).trim());
    });
  }
  var recipeParts = opts.filter(function (v) {
    return !artieOptionValueIsPortionOnly(v);
  });
  return recipeParts.join(' · ');
}

/** Strip leading portion segments from cart `variant_title` / product title strings. */
function artieRecipeOnlyFromCartLineTitle(title) {
  var t = String(title || '').trim();
  if (!t) return '';
  var parts = t.split(/\s*[-–—/|·]\s*/).map(function (x) {
    return x.trim();
  }).filter(Boolean);
  var kept = parts.filter(function (p) {
    return !artieOptionValueIsPortionOnly(p);
  });
  if (kept.length) return kept.join(' · ');
  if (parts.length === 1 && artieOptionValueIsPortionOnly(parts[0])) return '';
  return t;
}

/**
 * Served plan calories/day for the active PDP portion tier (routing-table cal, not DER/RER).
 * @param {any} [preloadedDog]
 * @returns {number|null}
 */
function stripServedCaloriesPerDayForActiveDog(preloadedDog) {
  var resolved = resolveMealPlanForActiveShoppingContext();
  if (resolved && resolved.calories != null) {
    var fromCommerce = Number(resolved.calories);
    if (!isNaN(fromCommerce) && fromCommerce > 0) return Math.round(fromCommerce);
  }

  var tier = getActivePortionTierForMealPlanResolution();
  if (!tier) return null;

  var stripCtx = resolvePersonalizedStripContext();
  var row = stripCtx.ctx ? findRecommendedPortionRowForPackContext(stripCtx.ctx) : null;
  if (!row && stripCtx.petForStore) {
    var dk =
      stripCtx.petForStore.dog_key ||
      (stripCtx.petForStore.attributes && stripCtx.petForStore.attributes.dog_key);
    var rows = readRecommendedPortionStore();
    var ri;
    for (ri = 0; ri < rows.length; ri++) {
      if (dk && rows[ri] && String(rows[ri].dog_key || '') === String(dk)) {
        row = rows[ri];
        break;
      }
    }
  }
  if (row) {
    var calKey = tier + '_cal/day';
    var rawCal = row[calKey];
    if (rawCal != null && String(rawCal).trim() !== '' && !isNaN(parseFloat(String(rawCal)))) {
      var fromRow = parseFloat(String(rawCal));
      if (fromRow > 0) return Math.round(fromRow);
    }
  }

  var dog =
    preloadedDog != null
      ? preloadedDog
      : stripCtx.petForStore
        ? quizProfileFromStoredPet(stripCtx.petForStore)
        : loadQuizDogProfile();
  if (!dog || dog.weight == null || !isArtieDogWeightInRange(Number(dog.weight))) return null;

  var plan = computePlan(dog);
  if (!plan || plan.blocked) return null;
  var part = plan[tier];
  if (part && part.cal != null) {
    var fromPlan = Number(part.cal);
    if (!isNaN(fromPlan) && fromPlan > 0) return Math.round(fromPlan);
  }
  return null;
}

function mealsPerDayForPlan(plan) {
  if (!plan || !plan.recommended) return '—';
  return '2';
}

function daySupplyForVariant(variant) {
  var t = variant && variant.title != null ? String(variant.title) : '';
  var m = t.match(/(\d+)\s*[-–]?\s*day/i);
  if (m) return m[1];
  return '30';
}

/**
 * Personalized strip (`artie-personalized-strip`): visibility + metrics.
 * Placeholder `.js-strip__card` gets `.hidden` when we have a displayable dog (pack, primary store pet,
 * or latest standalone calculator pet). `.js-dog-details-card` mirrors that same resolution.
 */
function syncArtiePersonalizedStrip() {
  var stripCtx = resolvePersonalizedStripContext();
  var named = !!stripCtx.name;
  var dogDataAvailable = named;

  var stripScope = document.getElementById('personalizedDogGrid') || document.querySelector('.artie-personalized-strip');
  if (stripScope) {
    var stripPlaceholders = stripScope.querySelectorAll('.js-strip__card');
    for (var pi = 0; pi < stripPlaceholders.length; pi++) {
      var ph = stripPlaceholders[pi];
      if (!ph) continue;
      if (dogDataAvailable) ph.classList.add('hidden');
      else ph.classList.remove('hidden');
    }
  }

  var cards = document.querySelectorAll('.js-dog-details-card');
  if (!cards.length) return;

  var variant = getCurrentMainVariantSnapshot();
  var variantLine = artieVariantTitleForStrip(variant);
  if (!variantLine) {
    var picker = getMainVariantPicker();
    var picked = collectStripVariantLabelsFromPicker(picker);
    if (picked) variantLine = picked.replace(/\s*\/\s*/g, ' · ');
  }

  var pet = stripCtx.petForStore;
  var dog = pet ? quizProfileFromStoredPet(pet) : loadQuizDogProfile();
  var reco = recommendPortion(dog);
  var plan = reco && reco.plan;
  var servedCal = stripServedCaloriesPerDayForActiveDog(dog);
  var meals = mealsPerDayForPlan(plan);
  var supply = daySupplyForVariant(variant);

  for (var i = 0; i < cards.length; i++) {
    var card = cards[i];
    if (!card) continue;
    if (!named) {
      card.classList.add('hidden');
      continue;
    }
    card.classList.remove('hidden');

    var nm = card.querySelector('.js-dog-name');
    if (nm && nm.tagName !== 'INPUT' && nm.tagName !== 'TEXTAREA' && nm.tagName !== 'SELECT') {
      nm.textContent = stripCtx.name;
    }

    var wt = card.querySelector('.js-dog-weight');
    if (wt) {
      var wn =
        stripCtx.weight != null && stripCtx.weight !== '' && !isNaN(Number(stripCtx.weight)) && Number(stripCtx.weight) > 0
          ? Number(stripCtx.weight)
          : '';
      wt.textContent = wn !== '' ? wn + ' lbs' : '—';
    }

    // var sel = card.querySelector('.js-selected-variants');
    // if (sel) sel.textContent = variantLine || '—';

    var calStat = card.querySelector('.js-dog-calories-stat');
    var cal = card.querySelector('.js-dog-calories');
    if (calStat) {
      if (servedCal != null) {
        calStat.hidden = false;
        if (cal) cal.textContent = String(servedCal);
      } else {
        calStat.hidden = true;
      }
    } else if (cal) {
      cal.textContent = servedCal != null ? String(servedCal) : '';
    }

    var md = card.querySelector('.js-dog-meals-day');
    if (md) md.textContent = meals;

    var sup = card.querySelector('.js-dog-supply-day');
    if (sup) sup.textContent = supply;
  }
}

/** Map quiz / metafield strings to a stable tier for matching option labels. */
function portionTierFromString(p) {
  var s = String(p || '')
    .trim()
    .toLowerCase();
  if (!s) return '';
  if (s.indexOf('full') !== -1) return 'full';
  if (s.indexOf('half') !== -1) return 'half';
  if (s.indexOf('top') !== -1) return 'topper';
  return '';
}

function optionValueMatchesPortionTier(optionVal, tier) {
  if (!tier) return false;
  var o = String(optionVal || '')
    .trim()
    .toLowerCase();
  if (!o) return false;
  if (tier === 'full') return o === 'full' || (o.indexOf('full') !== -1 && o.indexOf('half') === -1);
  if (tier === 'half') return o === 'half' || (o.indexOf('half') !== -1 && o.indexOf('full') === -1);
  if (tier === 'topper') return o.indexOf('top') !== -1;
  return false;
}

function fieldsetPortionPeerCount(fieldset) {
  var peers = fieldset.querySelectorAll('input.js-variant-option-input');
  var n = 0;
  for (var i = 0; i < peers.length; i++) {
    var v = (
      peers[i].getAttribute('data-js-option-value') ||
      peers[i].value ||
      ''
    )
      .trim()
      .toLowerCase();
    if (/full|half|top/.test(v)) n++;
  }
  return n;
}

function findPortionRadioInput(picker, tier) {
  if (!picker || !tier) return null;
  var inputs = picker.querySelectorAll('input.js-variant-option-input');
  for (var i = 0; i < inputs.length; i++) {
    var inp = inputs[i];
    if (!(inp instanceof HTMLInputElement)) continue;
    if (inp.getAttribute('aria-disabled') === 'true') continue;
    if (inp.dataset.optionAvailable === 'false') continue;
    var ov = (inp.getAttribute('data-js-option-value') || inp.value || '').trim();
    if (!optionValueMatchesPortionTier(ov, tier)) continue;
    var fs = inp.closest('fieldset');
    if (fs && fieldsetPortionPeerCount(fs) >= 2) return inp;
  }
  return null;
}

function selectPortionPeerCount(selectEl) {
  var opts = selectEl.querySelectorAll('option');
  var n = 0;
  for (var i = 0; i < opts.length; i++) {
    var v = (opts[i].value || opts[i].textContent || '').trim().toLowerCase();
    if (/full|half|top/.test(v)) n++;
  }
  return n;
}

function findPortionSelect(picker, tier) {
  if (!picker || !tier) return null;
  var selects = picker.querySelectorAll('select.variant-option__select, select.js-variant-option-input');
  for (var s = 0; s < selects.length; s++) {
    var sel = selects[s];
    if (selectPortionPeerCount(sel) >= 2) return sel;
  }
  return null;
}

function findPortionOptionInSelect(selectEl, tier) {
  var opts = selectEl.querySelectorAll('option');
  for (var i = 0; i < opts.length; i++) {
    var o = opts[i];
    var label = (
      o.getAttribute('data-js-option-value') ||
      o.value ||
      o.textContent ||
      ''
    ).trim();
    if (optionValueMatchesPortionTier(label, tier)) return o;
  }
  return null;
}

function currentPickerPortionMatches(picker, tier) {
  if (!picker || !tier) return false;
  var checked = picker.querySelector('input.js-variant-option-input[type="radio"]:checked');
  if (checked) {
    var rv = (checked.getAttribute('data-js-option-value') || checked.value || '').trim();
    if (optionValueMatchesPortionTier(rv, tier)) return true;
  }
  var selects = picker.querySelectorAll('select.js-variant-option-input, select.variant-option__select');
  for (var s = 0; s < selects.length; s++) {
    var sel = selects[s];
    if (selectPortionPeerCount(sel) < 2) continue;
    if (!sel.selectedOptions || !sel.selectedOptions[0]) continue;
    var so = sel.selectedOptions[0];
    var sv = (so.getAttribute('data-js-option-value') || so.value || so.textContent || '').trim();
    if (optionValueMatchesPortionTier(sv, tier)) return true;
  }
  return false;
}

/**
 * Portion tier from the PDP variant UI (portion fieldset / select only), for when JSON snapshot lags `variant:update`.
 * @param {HTMLElement | null} [picker]
 * @returns {'full'|'half'|'topper'|''}
 */
function portionTierFromLiveVariantPicker(picker) {
  picker = picker || getMainVariantPicker();
  if (!picker || !picker.querySelector) return '';
  var form = picker.querySelector('form');
  if (!form) return '';
  var fieldsets = form.querySelectorAll('fieldset');
  var fi;
  for (fi = 0; fi < fieldsets.length; fi++) {
    var fs = fieldsets[fi];
    if (fieldsetPortionPeerCount(fs) < 2) continue;
    var checked = fs.querySelector('input.js-variant-option-input[type="radio"]:checked');
    if (checked) {
      var rv = (checked.getAttribute('data-js-option-value') || checked.value || '').trim();
      var tr = portionTierFromString(rv);
      if (tr) return tr;
    }
  }
  var sels = form.querySelectorAll('select.js-variant-option-input, select.variant-option__select');
  var si;
  for (si = 0; si < sels.length; si++) {
    var sel = sels[si];
    if (selectPortionPeerCount(sel) < 2) continue;
    if (!sel.selectedOptions || !sel.selectedOptions[0]) continue;
    var so = sel.selectedOptions[0];
    var sv = (so.getAttribute('data-js-option-value') || so.value || so.textContent || '').trim();
    var ts = portionTierFromString(sv);
    if (ts) return ts;
  }
  return '';
}

function getRecommendedPortionForActiveDog() {
  var store = readArtiePetsStore();
  var ctx = getActivePackDogContext();
  var pet = null;
  if (ctx && ctx.id != null) pet = petFromStoreForPackId(store, ctx.id);
  if (!pet) pet = resolvePersonalizedStripContext().petForStore;
  if (!pet) pet = primaryPetFromStore();
  if (!pet || !pet.attributes) return '';
  var rp = pet.attributes.recommended_portion;
  return rp != null && String(rp).trim() !== '' ? String(rp).trim() : '';
}

/**
 * Per-dog recipe + portion for restoring the PDP after a pack-dog switch.
 * Prefers `multiple-dog-atc` (last live/cart sync), then `artie_pets_store` attributes.
 * @returns {{ recipe: string, portion: string }}
 */
function getActiveDogStoredVariantSelection() {
  var ctx = getActivePackDogContext();
  var recipe = '';
  var portion = '';
  if (!ctx || ctx.id == null) return { recipe: '', portion: '' };

  try {
    var dogId = artieCustomerDogIdFromPackRowId(ctx.id);
    if (dogId) {
      var rows = readMultipleDogAtcStore();
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        if (!row || String(row.dogId || '') !== dogId) continue;
        if (row.selectedRecipe) recipe = String(row.selectedRecipe).trim();
        if (row.portionSize) portion = String(row.portionSize).trim();
        break;
      }
    }
  } catch (eAtc) {}

  if (!portion) portion = getRecommendedPortionForActiveDog();
  if (!recipe) recipe = artieRecipeLineForPackContext(ctx);
  return { recipe: recipe, portion: portion };
}

/** Apply quiz portion to PDP variant UI (radios with data-js-option-value or portion select). */
function applyQuizPortionToVariantPicker(portion) {
  var tier = portionTierFromString(portion);
  if (!tier) return;
  var picker = getMainVariantPicker();
  if (!picker) return;

  var radio = findPortionRadioInput(picker, tier);
  if (radio) {
    if (radio.checked) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    return;
  }

  var selectEl = findPortionSelect(picker, tier);
  if (!selectEl) return;
  var opt = findPortionOptionInSelect(selectEl, tier);
  if (!opt) return;
  if (selectEl.value === opt.value) return;
  selectEl.value = opt.value;
  selectEl.dispatchEvent(new Event('change', { bubbles: true }));
}

function artieNormalizeRecipeLabel(s) {
  return String(s || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}

/**
 * @param {string} a
 * @param {string} b
 * @returns {boolean}
 */
function artieRecipeLinesMatch(a, b) {
  var x = artieNormalizeRecipeLabel(a);
  var y = artieNormalizeRecipeLabel(b);
  if (!x || !y) return !x && !y;
  if (x === y) return true;
  return x.indexOf(y) !== -1 || y.indexOf(x) !== -1;
}

/**
 * @param {string} optionVal
 * @param {string} recipeLine
 * @returns {boolean}
 */
function optionValueMatchesRecipeLine(optionVal, recipeLine) {
  var o = artieNormalizeRecipeLabel(optionVal);
  var r = artieNormalizeRecipeLabel(recipeLine);
  if (!o || !r) return false;
  if (artieOptionValueIsPortionOnly(optionVal)) return false;
  return artieRecipeLinesMatch(o, r);
}

/**
 * @param {Element} fieldset
 * @returns {number}
 */
function fieldsetRecipePeerCount(fieldset) {
  var peers = fieldset.querySelectorAll('input.js-variant-option-input');
  var n = 0;
  for (var i = 0; i < peers.length; i++) {
    var v = (peers[i].getAttribute('data-js-option-value') || peers[i].value || '').trim();
    if (v && !artieOptionValueIsPortionOnly(v)) n++;
  }
  return n;
}

/**
 * @param {HTMLElement} picker
 * @param {string} recipeLine
 * @returns {HTMLInputElement | null}
 */
function findRecipeRadioInput(picker, recipeLine) {
  if (!picker || !recipeLine) return null;
  var inputs = picker.querySelectorAll('input.js-variant-option-input');
  for (var i = 0; i < inputs.length; i++) {
    var inp = inputs[i];
    if (!(inp instanceof HTMLInputElement)) continue;
    if (inp.getAttribute('aria-disabled') === 'true') continue;
    if (inp.dataset.optionAvailable === 'false') continue;
    var ov = (inp.getAttribute('data-js-option-value') || inp.value || '').trim();
    if (!optionValueMatchesRecipeLine(ov, recipeLine)) continue;
    var fs = inp.closest('fieldset');
    if (fs && fieldsetRecipePeerCount(fs) >= 2) return inp;
  }
  return null;
}

/**
 * @param {HTMLSelectElement} selectEl
 * @returns {number}
 */
function selectRecipePeerCount(selectEl) {
  var opts = selectEl.querySelectorAll('option');
  var n = 0;
  for (var i = 0; i < opts.length; i++) {
    var v = (
      opts[i].getAttribute('data-js-option-value') ||
      opts[i].value ||
      opts[i].textContent ||
      ''
    ).trim();
    if (v && !artieOptionValueIsPortionOnly(v)) n++;
  }
  return n;
}

/**
 * @param {HTMLElement} picker
 * @param {string} recipeLine
 * @returns {HTMLSelectElement | null}
 */
function findRecipeSelect(picker, recipeLine) {
  if (!picker || !recipeLine) return null;
  var selects = picker.querySelectorAll('select.variant-option__select, select.js-variant-option-input');
  for (var s = 0; s < selects.length; s++) {
    var sel = selects[s];
    if (!(sel instanceof HTMLSelectElement)) continue;
    if (selectRecipePeerCount(sel) >= 2) return sel;
  }
  return null;
}

/**
 * @param {HTMLSelectElement} selectEl
 * @param {string} recipeLine
 * @returns {HTMLOptionElement | null}
 */
function findRecipeOptionInSelect(selectEl, recipeLine) {
  var opts = selectEl.querySelectorAll('option');
  for (var i = 0; i < opts.length; i++) {
    var o = opts[i];
    var label = (
      o.getAttribute('data-js-option-value') ||
      o.value ||
      o.textContent ||
      ''
    ).trim();
    if (optionValueMatchesRecipeLine(label, recipeLine)) return o;
  }
  return null;
}

/**
 * @param {HTMLElement} picker
 * @param {string} recipeLine
 * @returns {boolean}
 */
function currentPickerRecipeMatches(picker, recipeLine) {
  if (!picker || !recipeLine) return false;
  return artieRecipeLinesMatch(artieRecipeLineFromLiveVariantPicker(picker), recipeLine);
}

/** Apply stored recipe (Choose Your Recipe) to the PDP variant UI. */
function applyRecipeToVariantPicker(recipeLine) {
  var recipe = String(recipeLine || '').trim();
  if (!recipe) return;
  var picker = getMainVariantPicker();
  if (!picker) return;
  if (currentPickerRecipeMatches(picker, recipe)) return;

  var radio = findRecipeRadioInput(picker, recipe);
  if (radio) {
    if (radio.checked) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    return;
  }

  var selectEl = findRecipeSelect(picker, recipe);
  if (!selectEl) return;
  var opt = findRecipeOptionInSelect(selectEl, recipe);
  if (!opt) return;
  if (selectEl.value === opt.value) return;
  selectEl.value = opt.value;
  selectEl.dispatchEvent(new Event('change', { bubbles: true }));
}

/**
 * @param {{ forceFromStore?: boolean }} [opts]
 */
function syncVariantPickerFromQuizStore(opts) {
  opts = opts || {};
  var picker = getMainVariantPicker();
  if (!picker) return;

  var portion = getRecommendedPortionForActiveDog();
  if (!portion) return;
  var tier = portionTierFromString(portion);
  if (!tier) return;
  if (currentPickerPortionMatches(picker, tier)) return;

  if (!opts.forceFromStore) {
    var liveTier = portionTierFromLiveVariantPicker(picker);
    if (liveTier && liveTier !== tier) {
      var ctx = getActivePackDogContext();
      var row = ctx ? findRecommendedPortionRowForPackContext(ctx) : null;
      var weightUnavail = row
        ? parseUnavailablePortionTiersMap(row.unavailable)
        : { full: false, half: false, topper: false };
      if (!weightUnavail[liveTier]) return;
    }
  }

  applyQuizPortionToVariantPicker(portion);
}

/**
 * After switching the active pack dog, restore recipe + portion on the PDP from per-dog storage.
 */
function syncActiveDogVariantPickerFromStore() {
  var picker = getMainVariantPicker();
  if (!picker) return;
  var ctx = getActivePackDogContext();
  if (!ctx || ctx.id == null) return;

  var stored = getActiveDogStoredVariantSelection();
  var recipeStr = String(stored.recipe || '').trim();
  var portionStr = String(stored.portion || '').trim();
  if (!recipeStr && !portionStr) return;

  var recipeMismatch = recipeStr && !currentPickerRecipeMatches(picker, recipeStr);
  var tier = portionTierFromString(portionStr);
  var portionMismatch = tier && !currentPickerPortionMatches(picker, tier);
  if (!recipeMismatch && !portionMismatch) return;

  artieApplyingDogSwitchVariantSync = true;
  artiePendingDogSwitchPortionApply = portionMismatch ? portionStr : '';

  if (recipeMismatch) {
    setArtieCurrentRecipeVariantName(recipeStr);
    applyRecipeToVariantPicker(recipeStr);
    return;
  }

  if (portionMismatch) {
    applyQuizPortionToVariantPicker(portionStr);
  }
  artiePendingDogSwitchPortionApply = '';
  artieApplyingDogSwitchVariantSync = false;
}

/**
 * @param {string | null | undefined} unavailableRaw - comma list from `recommended_portion[].unavailable`
 * @returns {{ full: boolean, half: boolean, topper: boolean }} true = tier unavailable for this dog
 */
function parseUnavailablePortionTiersMap(unavailableRaw) {
  var map = { full: false, half: false, topper: false };
  var s = String(unavailableRaw || '').trim().toLowerCase();
  if (!s) return map;
  var parts = s.split(',');
  for (var i = 0; i < parts.length; i++) {
    var t = portionTierFromString(parts[i].trim());
    if (t === 'full' || t === 'half' || t === 'topper') map[t] = true;
  }
  return map;
}

/**
 * @param {string|null|undefined} mealPlanId
 * @returns {number}
 */
function mealPlanNumberFromId(mealPlanId) {
  var m = String(mealPlanId || '').match(/^MealPlan(\d+)$/i);
  return m && m[1] ? parseInt(m[1], 10) : 0;
}

/**
 * Mirrors the legacy plan-template visibility rules, but marks portion variants unavailable
 * so the Shopify picker disables them instead of removing their DOM nodes.
 * @param {{ full: boolean, half: boolean, topper: boolean }} unavailableMap
 * @param {string} mealPlanId
 * @param {string} tier
 * @returns {{ full: boolean, half: boolean, topper: boolean }}
 */
function applyMealPlanPortionAvailabilityRules(unavailableMap, mealPlanId, tier) {
  var n = mealPlanNumberFromId(mealPlanId);
  if (!n) return unavailableMap;

  if (tier === 'full' && n >= 1 && n <= 4) {
    unavailableMap.half = true;
    unavailableMap.topper = true;
  } else if (tier === 'full' && n >= 5 && n <= 10) {
    unavailableMap.topper = true;
  } else if (tier === 'half' && n >= 13 && n <= 23) {
    unavailableMap.full = true;
  }

  return unavailableMap;
}

/**
 * Normalize persisted / JSON meal plan ids (`MealPlan13`, `MealPlan 7`) to `MealPlan{n}`.
 * @param {string | null | undefined} raw
 * @returns {string}
 */
function normalizeMainMealPlanId(raw) {
  var s = String(raw || '').trim();
  if (!s) return '';
  var m = s.match(/meal\s*plan\s*(\d+)/i);
  if (m && m[1]) return 'MealPlan' + parseInt(m[1], 10);
  return s;
}

/**
 * @param {any} val - `meal_plans*.json` variants entry
 * @returns {boolean}
 */
function mealPlanVariantEntryHasCommerceIds(val) {
  if (!val || typeof val !== 'object' || Array.isArray(val)) return false;
  return val.variant_id != null && String(val.variant_id).trim() !== '';
}

/**
 * Which recommended tier produced `Main_recommanded_meal` (matches one of `*_meal_plan` cells).
 * @param {Record<string, any> | null} row
 * @param {string} mainNorm - `normalizeMainMealPlanId` output
 * @returns {'full'|'half'|'topper'|''}
 */
function inferMainRecommendedTierForMainPlanId(row, mainNorm) {
  if (!row || !mainNorm) return '';
  if (row.full_meal_plan != null && normalizeMainMealPlanId(row.full_meal_plan) === mainNorm) return 'full';
  if (row.half_meal_plan != null && normalizeMainMealPlanId(row.half_meal_plan) === mainNorm) return 'half';
  if (row.topper_meal_plan != null && normalizeMainMealPlanId(row.topper_meal_plan) === mainNorm) return 'topper';
  return '';
}

function restoreArtiePortionBlocksOnPicker(picker) {
  if (!picker || !picker.querySelectorAll) return;
  var blockedRadios = picker.querySelectorAll('input.js-variant-option-input[data-artie-portion-blocked="true"]');
  for (var br = 0; br < blockedRadios.length; br++) {
    restoreArtiePortionRadioFromDogBlock(/** @type {HTMLInputElement} */ (blockedRadios[br]));
  }
  var blockedOpts = picker.querySelectorAll('option[data-artie-portion-blocked="true"]');
  for (var bo = 0; bo < blockedOpts.length; bo++) {
    restoreArtiePortionOptionFromDogBlock(/** @type {HTMLOptionElement} */ (blockedOpts[bo]));
  }
}

/**
 * @param {HTMLElement} picker
 * @param {{ full: boolean, half: boolean, topper: boolean }} unavailableMap
 */
function applyArtiePortionUnavailableMapToPicker(picker, unavailableMap) {
  restoreArtiePortionBlocksOnPicker(picker);
  var form = picker.querySelector('form');
  if (!form) {
    artieSyncPdpAddToCartDisabledForPortions(picker);
    artieRehydrateCurrentPortionOptionPriceSubtitles();
    return;
  }

  var fieldsets = form.querySelectorAll('fieldset');
  var fi;
  for (fi = 0; fi < fieldsets.length; fi++) {
    var fs = fieldsets[fi];
    if (fieldsetPortionPeerCount(fs) < 2) continue;
    var inputs = fs.querySelectorAll('input.js-variant-option-input[type="radio"]');
    var ri;
    for (ri = 0; ri < inputs.length; ri++) {
      artieApplyDogBlockToPortionRadio(/** @type {HTMLInputElement} */ (inputs[ri]), unavailableMap);
    }
  }

  var sels = form.querySelectorAll('select.js-variant-option-input, select.variant-option__select');
  var si;
  for (si = 0; si < sels.length; si++) {
    var sel = sels[si];
    if (selectPortionPeerCount(sel) < 2) continue;
    var opts = sel.querySelectorAll('option');
    var oi;
    for (oi = 0; oi < opts.length; oi++) {
      artieApplyDogBlockToPortionOption(/** @type {HTMLOptionElement} */ (opts[oi]), unavailableMap);
    }
  }

  var curTier = portionTierFromLiveVariantPicker(picker);
  if (curTier && unavailableMap[curTier] && !artieApplyingDogSwitchVariantSync && !artiePendingDogSwitchPortionApply) {
    var ctx = getActivePackDogContext();
    var row = ctx ? findRecommendedPortionRowForPackContext(ctx) : null;
    var weightUnavail = row
      ? parseUnavailablePortionTiersMap(row.unavailable)
      : { full: false, half: false, topper: false };
    if (!weightUnavail[curTier]) {
      artieSyncPdpAddToCartDisabledForPortions(picker);
      artieRehydrateCurrentPortionOptionPriceSubtitles();
      return;
    }
    var order = ['full', 'half', 'topper'];
    var pick = '';
    var pi;
    for (pi = 0; pi < order.length; pi++) {
      if (!unavailableMap[order[pi]] && !weightUnavail[order[pi]]) {
        pick = order[pi];
        break;
      }
    }
    if (pick) {
      var portionLabel = pick === 'full' ? 'Full' : pick === 'half' ? 'Half' : 'Topper';
      applyQuizPortionToVariantPicker(portionLabel);
    }
  }
  artieSyncPdpAddToCartDisabledForPortions(picker);
  artieRehydrateCurrentPortionOptionPriceSubtitles();
}

/**
 * Radios/options that represent Full/Half/Topper within the PDP variant picker’s portion control(s).
 * @param {HTMLElement | null | undefined} picker
 * @returns {Array<{ kind: 'radio' | 'option', el: HTMLInputElement | HTMLOptionElement }>}
 */
function artieCollectPortionPeersFromPicker(picker) {
  var peers = [];
  if (!picker || !picker.querySelector) return peers;
  var form = picker.querySelector('form');
  if (!form) return peers;

  var fieldsets = form.querySelectorAll('fieldset');
  var fi;
  for (fi = 0; fi < fieldsets.length; fi++) {
    var fs = fieldsets[fi];
    if (fieldsetPortionPeerCount(fs) < 2) continue;
    var inputs = fs.querySelectorAll('input.js-variant-option-input[type="radio"]');
    var ri;
    for (ri = 0; ri < inputs.length; ri++) {
      var inp = inputs[ri];
      var ovRadio = (inp.getAttribute('data-js-option-value') || inp.value || '').trim();
      if (!portionTierFromString(ovRadio)) continue;
      peers.push({ kind: 'radio', el: inp });
    }
  }

  var sels = form.querySelectorAll('select.js-variant-option-input, select.variant-option__select');
  var si;
  for (si = 0; si < sels.length; si++) {
    var sel = sels[si];
    if (selectPortionPeerCount(sel) < 2) continue;
    var opts = sel.querySelectorAll('option');
    var oi;
    for (oi = 0; oi < opts.length; oi++) {
      var opt = opts[oi];
      var ovOpt = (opt.getAttribute('data-js-option-value') || opt.value || '').trim();
      if (!ovOpt) continue;
      if (!portionTierFromString(ovOpt)) continue;
      peers.push({ kind: 'option', el: opt });
    }
  }
  return peers;
}

/**
 * @param {{ kind: 'radio' | 'option', el: HTMLInputElement | HTMLOptionElement }} peer
 * @returns {boolean}
 */
function artiePortionPeerElementUnavailable(peer) {
  if (peer.kind === 'radio') {
    var inp = /** @type {HTMLInputElement} */ (peer.el);
    return (
      inp.disabled ||
      inp.getAttribute('aria-disabled') === 'true' ||
      inp.getAttribute('data-option-available') === 'false'
    );
  }
  return /** @type {HTMLOptionElement} */ (peer.el).disabled === true;
}

/**
 * True when every portion-tier choice (Full/Half/Topper peers on this PDP) is disabled/unavailable.
 * @param {HTMLElement | null | undefined} picker
 * @returns {boolean}
 */
function artieAllPortionOptionsUnavailableForPicker(picker) {
  if (!picker || !(picker instanceof HTMLElement)) return false;
  var peers = artieCollectPortionPeersFromPicker(picker);
  if (peers.length === 0) return false;
  for (var i = 0; i < peers.length; i++) {
    if (!artiePortionPeerElementUnavailable(peers[i])) return false;
  }
  return true;
}

/** @returns {boolean} */
function artieMainVariantSellableSnapshot() {
  var v = artieLastMainVariant || getCurrentMainVariantSnapshot();
  return !!(v && v.id != null && v.available !== false);
}

function artieTopperCommerceBlocksAddToCart(picker) {
  if (!picker || !(picker instanceof HTMLElement)) return false;
  if (portionTierFromLiveVariantPicker(picker) !== 'topper') return false;
  try {
    var getter = /** @type {any} */ (window).getArtieMealPlanCommerceIds;
    if (typeof getter === 'function') {
      var ids = getter();
      return !!(ids && (ids.variant_id == null || ids.variant_id === ''));
    }
  } catch (eIds) {}
  return false;
}

/** Apply weight-routed portion availability map to the PDP picker. */
function artieApplyPortionMapWithMealTopperGate(picker, unavailableMap, epoch) {
  if (epoch !== artiePortionAvailabilityApplyEpoch) return;
  applyArtiePortionUnavailableMapToPicker(picker, unavailableMap);
}

/**
 * Keeps main PDP add-to-cart + sticky/sync puppet buttons aligned when Artie disables every portion tier.
 * @param {HTMLElement | null | undefined} [optPicker]
 */
function artieSyncPdpAddToCartDisabledForPortions(optPicker) {
  var picker = optPicker || getMainVariantPicker();
  if (!picker || !(picker instanceof HTMLElement)) return;
  if (picker.dataset.templateProductMatch !== 'true') return;
  if (picker.closest('product-card') || picker.closest('quick-add-dialog')) return;

  var productId = picker.getAttribute('data-product-id');
  if (!productId) return;

  var allPortionsUnavailable = artieAllPortionOptionsUnavailableForPicker(picker);

  var productForm = document.querySelector('product-form-component[data-product-id="' + productId + '"]');
  var addContainer = /** @type {HTMLElement & { disable?: () => void; enable?: () => void } | null} */ (
    productForm ? productForm.querySelector('add-to-cart-component') : null
  );

  var puppetRoots = document.querySelectorAll(
    'sticky-add-to-cart[data-product-id="' + productId + '"], sync-add-to-cart[data-product-id="' + productId + '"]'
  );

  /** @param {boolean} stickyAvail */
  function patchPuppetRoots(stickyAvail) {
    var pj;
    for (pj = 0; pj < puppetRoots.length; pj++) {
      var rootj = /** @type {HTMLElement & { updateButtonText?: () => void }} */ (puppetRoots[pj]);
      rootj.dataset.variantAvailable = stickyAvail ? 'true' : 'false';
      var stickyBtn = rootj.querySelector('[ref="addToCartButton"]');
      if (stickyBtn instanceof HTMLButtonElement) stickyBtn.disabled = !stickyAvail;
      if (typeof rootj.updateButtonText === 'function') rootj.updateButtonText();
    }
  }

  /**
   * Disable puppet ATC only — do not set `data-variant-available="false"` or the theme CSS hides the sticky bar.
   * @param {boolean} disabled
   */
  function patchPuppetButtonsDisabledOnly(disabled) {
    var pk;
    for (pk = 0; pk < puppetRoots.length; pk++) {
      var root = /** @type {HTMLElement & { updateButtonText?: () => void }} */ (puppetRoots[pk]);
      var btnOnly = root.querySelector('[ref="addToCartButton"]');
      if (btnOnly instanceof HTMLButtonElement) btnOnly.disabled = disabled;
      if (typeof root.updateButtonText === 'function') root.updateButtonText();
    }
  }

  if (allPortionsUnavailable) {
    if (addContainer && typeof addContainer.disable === 'function') addContainer.disable();
    else if (productForm) {
      var btnForce = productForm.querySelector('[ref="addToCartButton"]');
      if (btnForce instanceof HTMLButtonElement) btnForce.disabled = true;
    }
    patchPuppetButtonsDisabledOnly(true);
    return;
  }

  if (artieTopperCommerceBlocksAddToCart(picker)) {
    if (addContainer && typeof addContainer.disable === 'function') addContainer.disable();
    else if (productForm) {
      var btnTopper = productForm.querySelector('[ref="addToCartButton"]');
      if (btnTopper instanceof HTMLButtonElement) btnTopper.disabled = true;
    }
    patchPuppetButtonsDisabledOnly(true);
    return;
  }

  var variantAvail = artieMainVariantSellableSnapshot();
  if (addContainer && typeof addContainer.disable === 'function' && typeof addContainer.enable === 'function') {
    if (variantAvail) addContainer.enable();
    else addContainer.disable();
  } else if (productForm) {
    var btn = productForm.querySelector('[ref="addToCartButton"]');
    if (btn instanceof HTMLButtonElement) btn.disabled = !variantAvail;
  }
  patchPuppetRoots(variantAvail);
}

function restoreArtiePortionRadioFromDogBlock(inp) {
  if (!(inp instanceof HTMLInputElement)) return;
  if (inp.getAttribute('data-artie-portion-blocked') !== 'true') return;
  inp.removeAttribute('data-artie-portion-blocked');
  var nat = inp.getAttribute('data-artie-portion-native-available');
  inp.removeAttribute('data-artie-portion-native-available');
  inp.disabled = false;
  if (nat === 'true') {
    inp.removeAttribute('aria-disabled');
    inp.setAttribute('data-option-available', 'true');
  } else {
    inp.setAttribute('aria-disabled', 'true');
    inp.setAttribute('data-option-available', 'false');
  }
}

function restoreArtiePortionOptionFromDogBlock(opt) {
  if (!(opt instanceof HTMLOptionElement)) return;
  if (opt.getAttribute('data-artie-portion-blocked') !== 'true') return;
  opt.removeAttribute('data-artie-portion-blocked');
  var nd = opt.getAttribute('data-artie-portion-native-disabled');
  opt.removeAttribute('data-artie-portion-native-disabled');
  opt.disabled = nd === 'true';
}

function artieApplyDogBlockToPortionRadio(inp, unavailableMap) {
  if (!(inp instanceof HTMLInputElement)) return;
  var ov = (inp.getAttribute('data-js-option-value') || inp.value || '').trim();
  var tier = portionTierFromString(ov);
  if (!tier || !unavailableMap[tier]) return;
  if (!inp.hasAttribute('data-artie-portion-native-available')) {
    var natAvail = inp.getAttribute('data-option-available');
    if (natAvail != null) inp.setAttribute('data-artie-portion-native-available', natAvail);
    else inp.setAttribute('data-artie-portion-native-available', inp.disabled ? 'false' : 'true');
  }
  inp.setAttribute('data-artie-portion-blocked', 'true');
  inp.setAttribute('aria-disabled', 'true');
  inp.setAttribute('data-option-available', 'false');
  inp.disabled = true;
}

function artieApplyDogBlockToPortionOption(opt, unavailableMap) {
  if (!(opt instanceof HTMLOptionElement)) return;
  var ov = (opt.getAttribute('data-js-option-value') || opt.value || '').trim();
  var tier = portionTierFromString(ov);
  if (!tier || !unavailableMap[tier]) return;
  if (!opt.hasAttribute('data-artie-portion-native-disabled')) {
    opt.setAttribute('data-artie-portion-native-disabled', opt.disabled ? 'true' : 'false');
  }
  opt.setAttribute('data-artie-portion-blocked', 'true');
  opt.disabled = true;
}

/** Bumped at the start of each portion-availability sync so stale callbacks cannot repaint the picker. */
var artiePortionAvailabilityApplyEpoch = 0;

/**
 * Disable Full/Half/Topper on the PDP using weight-routed `recommended_portion.unavailable` (see `computePlan`).
 */
function syncArtiePortionVariantAvailabilityFromRecommendedStore() {
  artiePortionAvailabilityApplyEpoch++;
  var epoch = artiePortionAvailabilityApplyEpoch;

  var picker = getMainVariantPicker();
  if (!picker || !(picker instanceof HTMLElement)) return;
  if (picker.dataset.templateProductMatch !== 'true') return;
  if (picker.closest('product-card') || picker.closest('quick-add-dialog')) return;

  restoreArtiePortionBlocksOnPicker(picker);

  var ctx = getActivePackDogContext();
  var row = ctx ? findRecommendedPortionRowForPackContext(ctx) : null;
  var unavailableMap = row
    ? parseUnavailablePortionTiersMap(row.unavailable)
    : { full: false, half: false, topper: false };
  if (epoch !== artiePortionAvailabilityApplyEpoch) return;
  applyArtiePortionUnavailableMapToPicker(picker, unavailableMap);
}

var artiePortionAvailabilityTimer = null;

function scheduleArtiePortionVariantAvailabilitySync() {
  if (artiePortionAvailabilityTimer != null) {
    clearTimeout(artiePortionAvailabilityTimer);
  }
  artiePortionAvailabilityTimer = setTimeout(function() {
    artiePortionAvailabilityTimer = null;
    syncArtiePortionVariantAvailabilityFromRecommendedStore();
  }, 0);
}

/** Map a variant option string to quiz/store labels Full | Half | Topper. */
function extractCanonicalPortionFromVariant(variant) {
  if (!variant) return '';
  var opts = Array.isArray(variant.options)
    ? variant.options
    : [variant.option1, variant.option2, variant.option3].filter(function(x) {
        return x != null && String(x).trim() !== '';
      });
  for (var i = 0; i < opts.length; i++) {
    var opt = String(opts[i]).trim();
    if (!artieOptionValueIsPortionOnly(opt)) continue;
    var tier = portionTierFromString(opt);
    if (tier === 'full') return 'Full';
    if (tier === 'half') return 'Half';
    if (tier === 'topper') return 'Topper';
  }
  return '';
}

/**
 * After `variant:update` morph, align the portion control with `pet.attributes.recommended_portion`
 * when the server HTML lags the variant JSON we just persisted (common Half → Full with recipe names containing "Half").
 */
function artieReconcilePortionPickerAfterVariantUpdate() {
  if (artieApplyingDogSwitchVariantSync || artiePendingDogSwitchPortionApply) return;
  var picker = getMainVariantPicker();
  if (!picker) return;
  var stored = getRecommendedPortionForActiveDog();
  var storeTier = portionTierFromString(stored);
  if (!storeTier) return;
  if (currentPickerPortionMatches(picker, storeTier)) return;
  var ctx = getActivePackDogContext();
  var row = ctx ? findRecommendedPortionRowForPackContext(ctx) : null;
  var weightUnavail = row ? parseUnavailablePortionTiersMap(row.unavailable) : { full: false, half: false, topper: false };
  if (weightUnavail[storeTier]) return;
  var label = storeTier === 'full' ? 'Full' : storeTier === 'half' ? 'Half' : 'Topper';
  applyQuizPortionToVariantPicker(label);
}

function artiePrefersReducedMotion() {
  try {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {
    return false;
  }
}

/**
 * Crossfade static meal hero when `src` changes (CSS transition on `.meal-information__first-image-img`).
 * @param {HTMLImageElement} img
 * @param {string} src
 * @param {{ fast?: boolean }} [opts] - `fast: true` skips fade (variant changes: lower latency).
 */
function artieFadeSwapStaticHeroImg(img, src, opts) {
  if (!img || !src) return;
  var cur = img.currentSrc || img.src || '';
  if (cur && cur.split('?')[0] === String(src).split('?')[0]) return;

  if ((opts && opts.fast) || artiePrefersReducedMotion()) {
    img.src = src;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    return;
  }

  var settled = false;
  var reveal = function() {
    if (settled) return;
    settled = true;
    requestAnimationFrame(function() {
      img.style.opacity = '1';
      window.setTimeout(function() {
        img.style.opacity = '';
      }, 360);
    });
  };

  img.style.opacity = '0';
  img.addEventListener('load', reveal, { once: true });
  img.addEventListener('error', reveal, { once: true });
  img.src = src;
  img.removeAttribute('srcset');
  img.removeAttribute('sizes');
  if (img.complete) requestAnimationFrame(reveal);
}

/**
 * Largest candidate URL from a picker thumbnail `<img>` (srcset-aware).
 * @param {HTMLImageElement | null | undefined} img
 * @returns {string}
 */
function artieBestImageUrlFromThumbImg(img) {
  if (!img || !(img instanceof HTMLImageElement)) return '';
  var attr = img.getAttribute('srcset');
  if (attr && String(attr).trim()) {
    var bestUrl = '';
    var bestW = 0;
    var parts = String(attr).split(',');
    for (var pi = 0; pi < parts.length; pi++) {
      var rawSeg = parts[pi];
      if (rawSeg == null) continue;
      var seg = String(rawSeg).trim();
      var sp = seg.lastIndexOf(' ');
      if (sp === -1) continue;
      var url = seg.slice(0, sp).trim();
      var wPart = seg.slice(sp + 1).trim();
      var m = wPart.match(/^(\d+)w$/i);
      if (!m || m[1] == null) continue;
      var w = parseInt(String(m[1]), 10);
      if (w > bestW) {
        bestW = w;
        bestUrl = url;
      }
    }
    if (bestUrl) return bestUrl;
  }
  var raw = img.getAttribute('src') || img.src || '';
  return raw ? String(raw) : '';
}

/**
 * Thumbnail `<img>` next to the selected radio (variant media preferred, then option icon).
 * @param {HTMLInputElement | HTMLOptionElement | null | undefined} selectedEl
 * @returns {HTMLImageElement | null}
 */
function artieVariantPickerThumbImgFromSelected(selectedEl) {
  if (!selectedEl) return null;
  if (selectedEl instanceof HTMLInputElement && selectedEl.type === 'radio') {
    var lab = selectedEl.closest('label');
    if (!lab) return null;
    return (
      /** @type {HTMLImageElement | null} */ (lab.querySelector('.variant-option__variant-icon img')) ||
      /** @type {HTMLImageElement | null} */ (lab.querySelector('.variant-option__icon img'))
    );
  }
  return null;
}

/**
 * Update the static meal-information hero by URL (skips if the node sits inside `<media-gallery>`).
 * @param {string} src
 */
function artieSyncMealInformationHeroFromUrl(src) {
  if (!src) return;
  var root = document.querySelector('.js-meal-information-first-image');
  if (!root || root.closest('media-gallery')) return;
  var img =
    root.querySelector('img.meal-information__first-image-img') || root.querySelector('img');
  if (!(img instanceof HTMLImageElement)) return;
  artieFadeSwapStaticHeroImg(img, src, { fast: true });
}

/**
 * Runs on `variant:selected` (before fetch): swaps hero from the clicked option’s thumbnail for instant feedback.
 * @param {any} ev
 */
function onArtieVariantSelectedMealHero(ev) {
  var res = ev.detail && ev.detail.resource;
  var oid = res && res.id;
  if (oid == null || String(oid) === '') return;
  var t = ev.target;
  if (!(t instanceof Element)) return;
  var picker = t.closest('variant-picker');
  if (!(picker instanceof HTMLElement)) return;
  if (picker.dataset.templateProductMatch !== 'true') return;
  if (picker.closest('product-card') || picker.closest('quick-add-dialog')) return;

  var sid = String(oid).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  var selectedEl =
    picker.querySelector('input.js-variant-option-input[data-option-value-id="' + sid + '"]') ||
    picker.querySelector('option[data-option-value-id="' + sid + '"]');
  var thumb = artieVariantPickerThumbImgFromSelected(
    /** @type {HTMLInputElement | HTMLOptionElement | null} */ (selectedEl)
  );
  if (!thumb) return;
  var url = artieBestImageUrlFromThumbImg(thumb);
  if (!url) return;
  artieSyncMealInformationHeroFromUrl(url);
}

/**
 * `variant:selected` fires after the live picker state changes and before the slower section fetch/morph.
 * Use that picker state for per-meal price + commerce lookup so the UI does not wait on `variant:update`.
 * @param {any} ev
 */
function onArtieVariantSelectedMealPlanSync(ev) {
  var t = ev.target;
  if (!(t instanceof Element)) return;
  var picker = t.closest('variant-picker');
  if (!(picker instanceof HTMLElement)) return;
  if (picker.dataset.templateProductMatch !== 'true') return;
  if (picker.closest('product-card') || picker.closest('quick-add-dialog')) return;
  var liveRecipe = artieRecipeLineFromLiveVariantPicker(picker);
  if (liveRecipe) setArtieCurrentRecipeVariantName(liveRecipe);
  syncArtieMealPlanContextNow();
}

/**
 * Theme already wires variant changes: `variant-picker` fetches HTML and dispatches `variant:update`;
 * `media-gallery` listens and replaces itself from `event.detail.data.html`.
 * Meal-information can render a static hero (no `<media-gallery>`); this syncs that image from the variant JSON.
 * When a carousel exists, also jump the slideshow to the slide that contains the variant’s featured media id.
 *
 * @param {any} variant - Shopify variant from `variant:update` `detail.resource`
 */
function syncProductPageMediaFromArtieVariant(variant) {
  if (!variant) return;
  var fm = variant.featured_media;
  var preview = fm && fm.preview_image;
  var src = preview && preview.src ? String(preview.src) : '';
  if (src) {
    artieSyncMealInformationHeroFromUrl(src);
  }

  if (!fm || fm.id == null || fm.id === '') return;
  var mid = String(fm.id);
  var galleries = document.querySelectorAll('media-gallery');
  var slideAnimate = !artiePrefersReducedMotion();
  for (var gi = 0; gi < galleries.length; gi++) {
    var mg = galleries[gi];
    var sc = mg.querySelector('slideshow-component');
    if (!sc || typeof sc.select !== 'function') continue;
    var slides = mg.querySelectorAll('slideshow-slide');
    var idx = -1;
    for (var sj = 0; sj < slides.length; sj++) {
      if (slides[sj].querySelector('[data-media-id="' + mid + '"]')) {
        idx = sj;
        break;
      }
    }
    if (idx >= 0) sc.select(idx, undefined, { animate: slideAnimate });
  }
}

/**
 * Persist the live portion tier as soon as the shopper clicks (before slow `variant:update` morph).
 * @param {any} ev
 */
function onArtieVariantSelectedPersistPortion(ev) {
  if (artieApplyingDogSwitchVariantSync || artiePendingDogSwitchPortionApply) return;
  if (!artieIsMainPdpVariantPickerEventTarget(ev.target)) return;
  var picker = getMainVariantPicker();
  if (!picker) return;
  var tier = portionTierFromLiveVariantPicker(picker);
  if (!tier) return;
  var portion = tier === 'full' ? 'Full' : tier === 'half' ? 'Half' : 'Topper';
  var ctx = getActivePackDogContext();
  if (!ctx || ctx.id == null) return;
  var store = readArtiePetsStore();
  var pet = petFromStoreForPackId(store, ctx.id);
  if (!pet) return;
  if (!pet.attributes) pet.attributes = {};
  var prev = pet.attributes.recommended_portion != null ? String(pet.attributes.recommended_portion).trim() : '';
  if (prev === portion) return;
  pet.attributes.recommended_portion = portion;
  writeArtiePetsStore(store);
  scheduleSyncMultipleDogAtcStore();
}

/**
 * When the shopper picks a different variant on the PDP, persist portion on the active dog’s pet
 * so we never fight the UI by re-applying an old quiz portion on variant:update.
 */
function onArtieShopifyVariantUpdated(ev) {
  if (artieApplyingDogSwitchVariantSync || artiePendingDogSwitchPortionApply) return;
  var variant = ev.detail && ev.detail.resource;
  if (!variant) return;
  var portion = extractCanonicalPortionFromVariant(variant);
  if (!portion) return;
  var ctx = getActivePackDogContext();
  if (!ctx || ctx.id == null) return;
  var store = readArtiePetsStore();
  var pet = petFromStoreForPackId(store, ctx.id);
  if (!pet) return;
  if (!pet.attributes) pet.attributes = {};
  var prev = pet.attributes.recommended_portion != null ? String(pet.attributes.recommended_portion).trim() : '';
  if (prev === portion) return;
  pet.attributes.recommended_portion = portion;
  writeArtiePetsStore(store);
}

var artieVariantQuizSyncBound = false;

/**
 * Theme variant-picker morphs fresh HTML from the server after each variant change, which resets
 * `.js-dog-name` nodes to Liquid defaults. Re-sync names from pack / quiz context after every update.
 */
function onArtieVariantUpdateAfterMorph(ev) {
  var v = ev.detail && ev.detail.resource;
  if (v) artieLastMainVariant = v;
  // Image first: no localStorage; improves perceived latency vs bundle + pets writes.
  syncProductPageMediaFromArtieVariant(v);

  artieBeginLsReadBundle();
  try {
    onArtieShopifyVariantUpdated(ev);
    if (v && !artieApplyingDogSwitchVariantSync && !artiePendingDogSwitchPortionApply) {
      syncArtieCurrentRecipeFromPdpVariant(v);
    }
    if (artiePendingDogSwitchPortionApply) {
      var pendingPortion = artiePendingDogSwitchPortionApply;
      artiePendingDogSwitchPortionApply = '';
      applyQuizPortionToVariantPicker(pendingPortion);
      artieApplyingDogSwitchVariantSync = false;
    } else if (!artieApplyingDogSwitchVariantSync) {
      artieReconcilePortionPickerAfterVariantUpdate();
    } else {
      artieApplyingDogSwitchVariantSync = false;
    }
    syncJsDogNameDisplays();
    syncArtiePersonalizedStrip();
    artieReapplyCurrentMealPlanPriceToPlacements();
    artieRehydrateCurrentPortionOptionPriceSubtitles();
    scheduleArtiePortionVariantAvailabilitySync();
    scheduleSyncMultipleDogAtcStore();
  } finally {
    artieEndLsReadBundle();
  }
}

function bindArtieVariantQuizSyncOnce() {
  if (artieVariantQuizSyncBound) return;
  artieVariantQuizSyncBound = true;
  document.addEventListener('variant:update', onArtieVariantUpdateAfterMorph);
  document.addEventListener('variant:selected', onArtieVariantSelectedMealHero);
  document.addEventListener('variant:selected', onArtieVariantSelectedMealPlanSync);
  document.addEventListener('variant:selected', onArtieVariantSelectedPersistPortion);
  document.addEventListener('variant:selected', function() {
    syncArtiePersonalizedStrip();
  });
}

// ── Structured pets store (customer_id + pets[]) ──
var ARTIE_PETS_STORE_KEY = 'artie_pets_store';
var ARTIE_CALC_REDIRECT_DOG_KEY = 'artie_calc_redirect_dog';

/**
 * Per-dog computed plan snapshot (one row per pet in `artie_pets_store`).
 * Mirrors `computePlan` output: dynamic `<tier>_cal/day` / `<tier>_breakfast` / `<tier>_dinner` keys
 * for every available tier (full / half / topper), `<tier>_meal_plan` (MealPlan id from weight-range routing),
 * `Main_recommanded_meal` (MealPlan id for the tier matching computePlan's recommended portion), plus a comma-joined `unavailable` string.
 * Rebuilt on every `writeArtiePetsStore` / `writeArtiePetsStoreForced` so it always reflects the latest
 * dog edits, calculator submits, weight changes, and metafield hydration.
 */
var ARTIE_RECOMMENDED_PORTION_KEY = 'recommended_portion';

/**
 * Set when dog/profile data was edited in this browser and may not be reflected in customer metafields yet.
 * While set, Liquid bootstrap hydration is skipped so local edits are not overwritten by a stale snapshot.
 * Cleared after a successful `syncArtiePetsToBackend()` POST (metafields updated server-side).
 */
var ARTIE_DOG_DATA_LOCAL_DIRTY_KEY = 'artie_dog_data_local_dirty';

function markArtieDogDataLocalDirty() {
  try {
    localStorage.setItem(ARTIE_DOG_DATA_LOCAL_DIRTY_KEY, '1');
  } catch (e) {}
}

function clearArtieDogDataLocalDirty() {
  try {
    localStorage.removeItem(ARTIE_DOG_DATA_LOCAL_DIRTY_KEY);
  } catch (e) {}
}

function isArtieDogDataLocalDirty() {
  try {
    return localStorage.getItem(ARTIE_DOG_DATA_LOCAL_DIRTY_KEY) === '1';
  } catch (e) {
    return false;
  }
}

/** Drops cached `readArtiePetsStore()` snapshot so the next read parses fresh JSON from localStorage. */
function invalidateArtiePetsStoreReadCache() {
  if (artieLsReadBundle) {
    artieLsReadBundle.petsReady = false;
    artieLsReadBundle.pets = null;
  }
}

function persistCalculatorRedirectDogContext(meta) {
  if (!meta || meta.packDogId == null) return;
  var payload = {
    packDogId: String(meta.packDogId),
    petId: meta.petId != null ? String(meta.petId) : '',
    createdAt: new Date().toISOString(),
    source: 'calculator_page'
  };
  try {
    localStorage.setItem(ARTIE_CALC_REDIRECT_DOG_KEY, JSON.stringify(payload));
  } catch (e) {}
}

function readCalculatorRedirectDogContext() {
  try {
    var raw = localStorage.getItem(ARTIE_CALC_REDIRECT_DOG_KEY);
    if (!raw || !String(raw).trim()) return null;
    var parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    if (String(parsed.source || '') !== 'calculator_page') return null;
    var packDogId = String(parsed.packDogId || '').trim();
    if (!packDogId) return null;
    var createdAt = String(parsed.createdAt || '').trim();
    if (!createdAt) return null;
    var ts = Date.parse(createdAt);
    if (isNaN(ts)) return null;
    // Guard stale redirects from old sessions.
    if (Date.now() - ts > 60 * 60 * 1000) return null;
    return {
      packDogId: packDogId,
      petId: String(parsed.petId || '').trim()
    };
  } catch (e) {
    return null;
  }
}

function clearCalculatorRedirectDogContext() {
  try {
    localStorage.removeItem(ARTIE_CALC_REDIRECT_DOG_KEY);
  } catch (e) {}
}

function setActivePackDogById(packDogId) {
  if (packDogId == null || packDogId === '') return false;
  try {
    var sid = String(packDogId);
    var raw = localStorage.getItem('artie-dogs');
    if (!raw || !String(raw).trim()) return false;
    var dogs = JSON.parse(raw);
    if (!Array.isArray(dogs) || !dogs.length) return false;
    var idx = -1;
    for (var i = 0; i < dogs.length; i++) {
      var row = dogs[i];
      if (row && String(row.id) === sid) {
        idx = i;
        break;
      }
    }
    if (idx < 0) return false;
    localStorage.setItem('artie-dogs-active', String(idx));
    localStorage.setItem('artie_active_pack_dog_id', sid);
    return true;
  } catch (e) {
    return false;
  }
}

function forceActivatePackDogById(packDogId) {
  if (setActivePackDogById(packDogId)) return true;
  try {
    var store = readArtiePetsStore();
    if (syncPackDogsLocalStorageFromPetsStore(store)) {
      return setActivePackDogById(packDogId);
    }
  } catch (e) {}
  return false;
}

function tryApplyCalculatorRedirectDogContextOnPdp() {
  var ctx = readCalculatorRedirectDogContext();
  if (!ctx) {
    clearCalculatorRedirectDogContext();
    return false;
  }
  var hasPdpUi = !!(getMainVariantPicker() || document.querySelector('.js-dog-details-card'));
  if (!hasPdpUi) return false;
  var applied = forceActivatePackDogById(ctx.packDogId);
  if (applied) {
    document.dispatchEvent(
      new CustomEvent('artie:active-dog-changed', {
        bubbles: true,
        detail: { source: 'calculator_redirect' }
      })
    );
    clearCalculatorRedirectDogContext();
  }
  return applied;
}

/** Plain string: selected recipe only (Choose Your Recipe), e.g. `Chicken Harvest Bowl` — no portion tier. Mirrored on active pet `attributes.current_recipe` in `artie_pets_store`. */
var ARTIE_CURRENT_RECIPE_KEY = 'current_recipe';

/**
 * Write `current_recipe` localStorage and the active pack dog in `artie_pets_store` → `attributes.current_recipe` (recipe name only).
 * @param {string} name - recipe string; empty clears both
 */
function setArtieCurrentRecipeVariantName(name) {
  var trimmed = String(name || '').trim();
  if (!trimmed) {
    var hadKey = false;
    try {
      hadKey = !!localStorage.getItem(ARTIE_CURRENT_RECIPE_KEY);
    } catch (e) {}
    if (hadKey) {
      try {
        localStorage.removeItem(ARTIE_CURRENT_RECIPE_KEY);
      } catch (e2) {}
    }
    syncCurrentRecipeIntoActivePetAttributes('');
    scheduleSyncMultipleDogAtcStore();
    return;
  }
  var prevKey = '';
  try {
    prevKey = localStorage.getItem(ARTIE_CURRENT_RECIPE_KEY) || '';
  } catch (e3) {}
  var ctx = getActivePackDogContext();
  var petRecipe = '';
  if (ctx && ctx.id != null) {
    var storePeek = readArtiePetsStore();
    var petPeek = petFromStoreForPackId(storePeek, ctx.id);
    if (petPeek && petPeek.attributes) petRecipe = String(petPeek.attributes.current_recipe || '');
  }
  if (prevKey === trimmed && petRecipe === trimmed) {
    return;
  }
  if (prevKey !== trimmed) {
    try {
      localStorage.setItem(ARTIE_CURRENT_RECIPE_KEY, trimmed);
    } catch (e4) {}
  }
  syncCurrentRecipeIntoActivePetAttributes(trimmed);
  scheduleSyncMultipleDogAtcStore();
}

function syncCurrentRecipeIntoActivePetAttributes(name) {
  try {
    var ctx = getActivePackDogContext();
    if (!ctx || ctx.id == null) return;
    var store = readArtiePetsStore();
    var pet = petFromStoreForPackId(store, ctx.id);
    if (!pet) return;
    if (!pet.attributes) pet.attributes = {};
    var nm = String(name || '').trim();
    if (nm) {
      if (pet.attributes.current_recipe === nm) return;
      pet.attributes.current_recipe = nm;
    } else {
      if (!pet.attributes.current_recipe) return;
      delete pet.attributes.current_recipe;
    }
    writeArtiePetsStore(store);
  } catch (e) {}
}

/**
 * Read one line-item property from Shopify cart JSON (object or legacy array of {name,value}).
 * @param {any} item
 * @param {string} key
 * @returns {string}
 */
function getCartLineProperty(item, key) {
  var p = item && item.properties;
  if (p == null) return '';
  if (Array.isArray(p)) {
    for (var i = 0; i < p.length; i++) {
      var row = p[i];
      if (row && String(row.name) === key) return String(row.value == null ? '' : row.value);
    }
    return '';
  }
  if (typeof p === 'object' && p[key] != null) return String(p[key]);
  return '';
}

/** Artie system/secondary bundle rows (never treat as main meal). */
function isArtieAddonCartLine(it) {
  var role = getCartLineProperty(it, '_artie_line');
  return role === 'system' || role === 'secondary';
}

/**
 * Artie main meal row: `_artie_line: main`, or `dog` (PDP add), or `_artie_sync_main` === this line’s `variant_id`
 * (cart/change payloads sometimes omit `_artie_line` but keep sync id — matches main line only, not system/secondary).
 */
function isArtieMainCartLine(it) {
  if (isArtieAddonCartLine(it)) return false;
  var role = getCartLineProperty(it, '_artie_line');
  if (role === 'main') return true;
  if (Boolean(String(getCartLineProperty(it, 'Dog') || getCartLineProperty(it, 'dog') || '').trim())) return true;
  var syncMain = String(getCartLineProperty(it, '_artie_sync_main') || '').trim();
  var vid = String(it.variant_id != null ? it.variant_id : '').trim();
  if (syncMain && vid && syncMain === vid) return true;
  return false;
}

/**
 * Persist selected recipe from PDP variant (Choose Your Recipe only — no Full/Half/Topper).
 * @param {any} variant - Shopify variant from `variant:update` detail.resource
 */
function syncArtieCurrentRecipeFromPdpVariant(variant) {
  if (!variant || variant.id == null) return;
  var recipe = artieRecipeOnlyFromVariant(variant);
  if (!recipe) return;
  setArtieCurrentRecipeVariantName(recipe);
}

/**
 * Authoritative cart JSON (some `cart:update` payloads omit `items` when sections-only).
 * @returns {Promise<void>}
 */
function syncCurrentRecipeAfterCartFetch() {
  return fetch('/cart.js')
    .then(function (r) {
      return r.json();
    })
    .then(function (cart) {
      syncArtieCurrentRecipeFromCartResource(cart, true);
    })
    .catch(function () {});
}

/**
 * @param {any} resource - Shopify cart JSON (`items`, `item_count`, …) from `cart:update` or `/cart.js`
 * @param {boolean} [fromRefetch] - true when this run used `/cart.js` (avoid refetch loop; then clear if still no main)
 */
function syncArtieCurrentRecipeFromCartResource(resource, fromRefetch) {
  if (!resource) return;
  if (!Array.isArray(resource.items)) {
    void syncCurrentRecipeAfterCartFetch();
    return;
  }
  try {
    if (!resource.items.length || resource.item_count === 0) {
      setArtieCurrentRecipeVariantName('');
      return;
    }
    var mains = resource.items.filter(isArtieMainCartLine);
    if (!mains.length) {
      if (!fromRefetch) {
        void syncCurrentRecipeAfterCartFetch();
        return;
      }
      setArtieCurrentRecipeVariantName('');
      return;
    }
    var first = mains[0];
    var vt = first.variant_title != null ? String(first.variant_title).trim() : '';
    var lineTitle = String(first.title || '').trim();
    var recipe = artieRecipeOnlyFromCartLineTitle(vt) || artieRecipeOnlyFromCartLineTitle(lineTitle);
    if (recipe) setArtieCurrentRecipeVariantName(recipe);
  } catch (e) {}
}

/** @param {any} ev */
function onArtieCartUpdateSyncCurrentRecipe(ev) {
  var d = ev.detail || {};
  if (d.data && d.data.didError) return;
  scheduleSyncJsDogNameDisplaysAfterCartDomRefresh();
  var resource = d.resource;
  if (!resource) return;
  syncArtieCurrentRecipeFromCartResource(resource);
  scheduleArtieCartOrderDataSyncFromCartChange();
}

var artieCartCurrentRecipeBound = false;
function bindArtieCartCurrentRecipeListenerOnce() {
  if (artieCartCurrentRecipeBound) return;
  artieCartCurrentRecipeBound = true;
  document.addEventListener('cart:update', onArtieCartUpdateSyncCurrentRecipe);
}

function getArtieCustomerId() {
  var el = document.getElementById('artieCustomerId');
  if (el && el.value) return String(el.value).trim();
  var attr = document.documentElement.getAttribute('data-artie-customer-id');
  if (attr) return String(attr).trim();
  return '';
}

/** Shopify cart attribute values are capped (~5000 chars); chunk above this to stay under the limit. */
var ARTIE_PETS_STORE_ATTR_CHUNK = 4800;

/** Debounce cart → attributes + API so rapid line changes coalesce (avoids redundant `/cart/update.js`). */
var ARTIE_CART_ORDER_SYNC_MS = 350;
var artieCartOrderSyncTimer = null;

/**
 * Remove prior Artie checkout snapshot keys so a new write does not leave stale chunks.
 * @param {Record<string, string>} attrs
 */
function stripArtiePetsStoreCartAttributeKeys(attrs) {
  var out = {};
  for (var k in attrs) {
    if (!Object.prototype.hasOwnProperty.call(attrs, k)) continue;
    if (/^artie_pets_store/.test(k)) continue;
    out[k] = attrs[k];
  }
  return out;
}

/**
 * True when the cart has no line items (treat missing `items` as non-empty so we do not strip attributes on partial payloads).
 * @param {any} cart
 */
function artieCartHasNoLineItems(cart) {
  if (!cart) return true;
  if (cart.item_count != null && Number(cart.item_count) === 0) return true;
  if (!Array.isArray(cart.items)) return false;
  return cart.items.length === 0;
}

/**
 * Merge `localStorage.artie_pets_store` into Shopify cart attributes (order attributes in admin).
 * - **Empty cart:** strips all `artie_pets_store*` keys so checkout is not carrying stale quiz data.
 * - **Non-empty cart:** writes snapshot (chunked when large).
 * Runs from `cart:update` (add / change / remove), not from checkout click.
 * @returns {Promise<void>}
 */
function syncArtiePetsStoreIntoCartAttributes() {
  return fetch('/cart.js')
    .then(function (r) {
      return r.json();
    })
    .then(function (cart) {
      var base = {};
      if (cart && cart.attributes && typeof cart.attributes === 'object') {
        for (var k in cart.attributes) {
          if (Object.prototype.hasOwnProperty.call(cart.attributes, k)) base[k] = String(cart.attributes[k] == null ? '' : cart.attributes[k]);
        }
      }
      var attrs = stripArtiePetsStoreCartAttributeKeys(base);
      var raw = '';
      try {
        raw = String(localStorage.getItem(ARTIE_PETS_STORE_KEY) || '').trim();
      } catch (e0) {}
      var emptyCart = artieCartHasNoLineItems(cart);
      if (!emptyCart && raw) {
        if (raw.length <= ARTIE_PETS_STORE_ATTR_CHUNK) {
          attrs.artie_pets_store = raw;
        } else {
          var n = Math.ceil(raw.length / ARTIE_PETS_STORE_ATTR_CHUNK);
          attrs.artie_pets_store_parts = String(n);
          for (var i = 0, p = 0; p < n; p++, i += ARTIE_PETS_STORE_ATTR_CHUNK) {
            attrs['artie_pets_store_' + p] = raw.slice(i, i + ARTIE_PETS_STORE_ATTR_CHUNK);
          }
        }
      }
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).then(function (res) {
        if (!res.ok) throw new Error('cart attributes update failed');
      });
    });
}

/**
 * After cart mutations: refresh cart attributes, then POST pets to the Artie API (failures are non-blocking).
 * @returns {Promise<void>}
 */
function runArtieCartOrderDataSync() {
  return syncArtiePetsStoreIntoCartAttributes()
    .then(function () {
      return syncArtiePetsToBackend();
    })
    .catch(function () {});
}

function scheduleArtieCartOrderDataSyncFromCartChange() {
  try {
    clearTimeout(artieCartOrderSyncTimer);
  } catch (e) {}
  artieCartOrderSyncTimer = window.setTimeout(function () {
    artieCartOrderSyncTimer = null;
    void runArtieCartOrderDataSync();
  }, ARTIE_CART_ORDER_SYNC_MS);
}

/** App proxy / storefront path for persisting quiz pets before checkout. */
var ARTIE_PETS_SYNC_PATH = '/apps/artie-api/v1/pets/sync';

/**
 * POST `artie_pets_store` payload to Artie API. Uses `readArtiePetsStore()` + `getArtieCustomerId()` fallback.
 * Failures are logged only. Invoked after cart line changes (with cart attribute sync), not on checkout click.
 * @returns {Promise<void>}
 */
function syncArtiePetsToBackend() {
  var store = readArtiePetsStore();
  var pets = store.pets || [];
  if (!pets.length) {
    try {
      console.warn('[Artie] Pets sync skipped: no pets in artie_pets_store');
    } catch (e0) {}
    return Promise.resolve();
  }
  var customerId = String(store.customer_id || '').trim() || getArtieCustomerId();
  if (!customerId) {
    try {
      console.warn('[Artie] Pets sync skipped: no customer_id (log in or set customer_id on store)');
    } catch (e1) {}
    return Promise.resolve();
  }
  return fetch(ARTIE_PETS_SYNC_PATH, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ customer_id: customerId, pets: pets })
  })
    .then(function (res) {
      if (!res.ok) throw new Error('pets sync HTTP ' + res.status);
      return res.json().catch(function () {
        return {};
      });
    })
    .then(function (data) {
      clearArtieDogDataLocalDirty();
      invalidateArtiePetsStoreReadCache();
    })
    .catch(function (err) {
      try {
        console.error('[Artie] Pets sync error:', err);
      } catch (e3) {}
    });
}

function readArtiePetsStore() {
  if (artieLsReadBundle && artieLsReadBundle.petsReady) {
    return artieLsReadBundle.pets;
  }
  try {
    var raw = localStorage.getItem(ARTIE_PETS_STORE_KEY);
    var out;
    if (!raw) {
      out = { customer_id: '', pets: [] };
    } else {
      var d = JSON.parse(raw);
      out = {
        customer_id: d && d.customer_id != null ? String(d.customer_id) : '',
        pets: Array.isArray(d && d.pets) ? d.pets : []
      };
    }
    if (artieLsReadBundle) {
      artieLsReadBundle.pets = out;
      artieLsReadBundle.petsReady = true;
    }
    return out;
  } catch (err) {
    var empty = { customer_id: '', pets: [] };
    if (artieLsReadBundle) {
      artieLsReadBundle.pets = empty;
      artieLsReadBundle.petsReady = true;
    }
    return empty;
  }
}

function writeArtiePetsStore(store) {
  var next = '';
  try {
    next = JSON.stringify(store);
  } catch (e) {
    return;
  }
  try {
    if (localStorage.getItem(ARTIE_PETS_STORE_KEY) === next) return;
  } catch (e2) {}
  try {
    localStorage.setItem(ARTIE_PETS_STORE_KEY, next);
  } catch (e3) {}
  invalidateArtiePetsStoreReadCache();
  syncRecommendedPortionFromPetsStore(store);
  scheduleArtieMealPlanContext();
  scheduleArtiePortionVariantAvailabilitySync();
}

/**
 * Same as `writeArtiePetsStore` but always persists (used when applying authoritative customer metafield snapshot).
 * @param {any} store
 */
function writeArtiePetsStoreForced(store) {
  var next = '';
  try {
    next = JSON.stringify(store);
  } catch (e) {
    return;
  }
  try {
    localStorage.setItem(ARTIE_PETS_STORE_KEY, next);
  } catch (e3) {}
  invalidateArtiePetsStoreReadCache();
  syncRecommendedPortionFromPetsStore(store);
  scheduleArtieMealPlanContext();
  scheduleArtiePortionVariantAvailabilitySync();
}

/**
 * Read the per-dog `recommended_portion` rows persisted by `syncRecommendedPortionFromPetsStore`.
 * @returns {Array<Record<string, any>>}
 */
function readRecommendedPortionStore() {
  try {
    var raw = localStorage.getItem(ARTIE_RECOMMENDED_PORTION_KEY);
    if (!raw) return [];
    var parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}

/**
 * Build a single `recommended_portion` row from a stored pet record.
 * Dynamic per-tier attributes are added for every viable plan tier (full / half / topper);
 * `Main_recommanded_meal` is the `<tier>_meal_plan` for the tier in computePlan.recommended (Full / Half / Topper);
 * tiers without a viable plan are listed (comma-joined) under `unavailable`.
 * @param {any} pet - row from `artie_pets_store.pets`
 * @returns {Record<string, any> | null}
 */
function buildRecommendedPortionEntryFromPet(pet) {
  if (!pet || typeof pet !== 'object') return null;
  var attrs = pet.attributes || {};
  var dog = quizProfileFromStoredPet(pet);
  if (!dog) return null;

  var packId = pet.pack_dog_id;
  var dogId = packId !== null && packId !== undefined && packId !== '' ? packId : pet.id || '';
  var dogKey =
    (pet.dog_key && String(pet.dog_key)) ||
    (attrs.dog_key && String(attrs.dog_key)) ||
    dogKeyFromNameAndId(pet.name, dogId);

  var entry = {
    dog_name: String(pet.name || '').trim(),
    dog_id: dogId,
    dog_key: dogKey
  };

  var tiers = ['topper', 'full', 'half'];
  var plan = computePlan(dog);
  var planUsable = !!(plan && plan.blocked !== 'puppy' && plan.blocked !== 'weight');
  var unavailable = [];

  for (var i = 0; i < tiers.length; i++) {
    var tier = tiers[i];
    var p = planUsable ? plan[tier] : null;
    if (p && p.cal != null) {
      entry[tier + '_cal/day'] = p.cal;
      entry[tier + '_breakfast'] = p.bk;
      entry[tier + '_dinner'] = p.dn;
    } else {
      unavailable.push(tier);
    }
  }
  for (var ti = 0; ti < tiers.length; ti++) {
    var tt = tiers[ti];
    var tierPlan = planUsable ? plan[tt] : null;
    if (tierPlan && tierPlan.mp != null) {
      entry[tt + '_meal_plan'] = 'MealPlan' + tierPlan.mp;
    }
  }
  if (planUsable && plan && plan.recommended) {
    var mainTier = String(plan.recommended).toLowerCase();
    if (mainTier === 'full' || mainTier === 'half' || mainTier === 'topper') {
      var mainMealPlan = entry[mainTier + '_meal_plan'];
      if (mainMealPlan) entry['Main_recommanded_meal'] = mainMealPlan;
    }
  }
  entry.unavailable = unavailable.join(',');
  return entry;
}

/**
 * Rebuild `localStorage.recommended_portion` from the current `artie_pets_store` snapshot.
 * Idempotent: always overwrites so removed dogs disappear, edits propagate, and duplicates collapse
 * (deduped by `dog_id` / `dog_key`). Skips the write when the serialized result is unchanged.
 * @param {{ pets?: any[] } | null} [storeOpt] - if omitted, reads the latest store snapshot
 */
function syncRecommendedPortionFromPetsStore(storeOpt) {
  try {
    var store = storeOpt || readArtiePetsStore();
    var pets = store && Array.isArray(store.pets) ? store.pets : [];
    var rows = [];
    var seen = {};
    for (var i = 0; i < pets.length; i++) {
      var entry = buildRecommendedPortionEntryFromPet(pets[i]);
      if (!entry) continue;
      var dedupeKey =
        entry.dog_id !== '' && entry.dog_id != null
          ? 'id:' + String(entry.dog_id)
          : 'key:' + String(entry.dog_key || '');
      if (seen[dedupeKey]) continue;
      seen[dedupeKey] = true;
      rows.push(entry);
    }
    var next = JSON.stringify(rows);
    var prev = '';
    try {
      prev = localStorage.getItem(ARTIE_RECOMMENDED_PORTION_KEY) || '';
    } catch (e0) {}
    if (prev === next) return;
    try {
      localStorage.setItem(ARTIE_RECOMMENDED_PORTION_KEY, next);
    } catch (e1) {}
    scheduleSyncMultipleDogAtcStore();
  } catch (e) {}
}

/**
 * Normalize `customer.metafields.artie.pets` (JSON) to the same shape as `artie_pets_store`.
 * Accepts either `{ customer_id?, pets: [...] }` or a bare `pets` array.
 */
function normalizeArtieCustomerPetsMetafield(parsed, customerId) {
  var cid = String(customerId || '').trim();
  if (!cid) return null;
  if (parsed == null) return null;
  var pets;
  if (Array.isArray(parsed)) {
    pets = parsed;
  } else if (typeof parsed === 'object' && Array.isArray(parsed.pets)) {
    pets = parsed.pets;
    if (parsed.customer_id != null && String(parsed.customer_id).trim() !== '') {
      cid = String(parsed.customer_id).trim();
    }
  } else {
    return null;
  }
  if (!pets.length) return null;
  try {
    pets = JSON.parse(JSON.stringify(pets));
  } catch (e) {
    return null;
  }
  return { customer_id: cid, pets: pets };
}

/** Build `artie-dogs` / `artie-dogs-active` from pets that have a numeric pack row id (not `solo`). */
function syncPackDogsLocalStorageFromPetsStore(store) {
  if (!store || !Array.isArray(store.pets) || !store.pets.length) return false;
  var rows = [];
  for (var i = 0; i < store.pets.length; i++) {
    var p = store.pets[i];
    if (!p || typeof p !== 'object') continue;
    var pid = p.pack_dog_id;
    if (pid === 'solo' || pid === null || pid === undefined || pid === '') continue;
    var numId = artieNumericPackRowId(pid);
    if (isNaN(numId)) continue;
    var w = p.attributes && p.attributes.weight != null ? p.attributes.weight : 20;
    var weight = typeof w === 'number' ? w : parseInt(String(w), 10);
    if (isNaN(weight) || weight <= 0) weight = 20;
    rows.push({
      id: numId,
      name: String(p.name || '').trim(),
      weight: weight,
      _primary: !!p.is_primary
    });
  }
  if (!rows.length) return false;

  var primaryRows = rows.filter(function(r) {
    return r._primary;
  });
  var otherRows = rows.filter(function(r) {
    return !r._primary;
  });
  primaryRows.sort(function(a, b) {
    return a.id - b.id;
  });
  otherRows.sort(function(a, b) {
    return a.id - b.id;
  });
  var ordered = primaryRows.length ? primaryRows.concat(otherRows) : rows.slice().sort(function(a, b) {
    return a.id - b.id;
  });

  /** @type {Record<string, boolean>} */
  var prevUserCreatedById = {};
  var prevActiveIdx = 0;
  var prevId = '';
  /** @type {any[] | null} */
  var prevDogs = null;
  var pi = 0;
  try {
    var aidFirst = localStorage.getItem('artie_active_pack_dog_id');
    if (aidFirst != null && String(aidFirst).trim() !== '') prevId = String(aidFirst).trim();

    var prevRaw = localStorage.getItem('artie-dogs');
    var prevActiveStr = localStorage.getItem('artie-dogs-active');
    pi = prevActiveStr != null ? parseInt(prevActiveStr, 10) : 0;
    if (isNaN(pi) || pi < 0) pi = 0;
    if (prevRaw && prevRaw.trim()) {
      prevDogs = JSON.parse(prevRaw);
      if (Array.isArray(prevDogs)) {
        for (var pk = 0; pk < prevDogs.length; pk++) {
          if (prevDogs[pk] && prevDogs[pk].id != null && prevDogs[pk].userCreated === true) {
            prevUserCreatedById[String(prevDogs[pk].id)] = true;
          }
        }
      }
      if (!prevId && Array.isArray(prevDogs) && prevDogs[pi] != null && prevDogs[pi].id != null) {
        prevId = String(prevDogs[pi].id);
      }
    }
  } catch (ePrev) {}

  var dogs = ordered.map(function(r) {
    var dog = /** @type {any} */ ({ id: r.id, name: r.name, weight: r.weight });
    if (prevUserCreatedById[String(r.id)]) dog.userCreated = true;
    return dog;
  });

  try {
    if (prevId) {
      var found = -1;
      for (var j = 0; j < dogs.length; j++) {
        if (String(dogs[j].id) === prevId) {
          found = j;
          break;
        }
      }
      if (found >= 0) {
        prevActiveIdx = found;
      } else if (Array.isArray(prevDogs) && pi >= 0 && pi < dogs.length && prevDogs[pi] != null && dogs[pi] != null) {
        if (String(prevDogs[pi].id) === String(dogs[pi].id)) prevActiveIdx = pi;
      }
    }
    var byAid = artiePackRowIndexFromLocalStorage(dogs);
    if (byAid >= 0 && byAid < dogs.length) prevActiveIdx = byAid;
  } catch (ePrevActive) {}

  try {
    localStorage.setItem('artie-dogs', JSON.stringify(dogs));
    if (prevActiveIdx < 0 || prevActiveIdx >= dogs.length) prevActiveIdx = 0;
    localStorage.setItem('artie-dogs-active', String(prevActiveIdx));
    var active = dogs[prevActiveIdx];
    if (active && active.id != null) {
      localStorage.setItem('artie_active_pack_dog_id', String(active.id));
    }
  } catch (e2) {
    return false;
  }
  return true;
}

/**
 * Logged-in customers: load `customer.metafields.artie.pets` from `#artieCustomerPetsBootstrap` into localStorage.
 * Metafields win over localStorage unless `artie_dog_data_local_dirty` is set (unsynced edits still being POSTed).
 * @returns {boolean} true if data was applied
 */
function hydrateLocalStorageFromCustomerPetsMetafield() {
  var customerId = getArtieCustomerId();
  if (!customerId) return false;
  if (isArtieDogDataLocalDirty()) return false;
  var el = document.getElementById('artieCustomerPetsBootstrap');
  if (!el) return false;
  var raw = el.textContent;
  if (!raw || !String(raw).trim()) return false;
  var parsed;
  try {
    parsed = JSON.parse(raw);
  } catch (e) {
    return false;
  }
  var store = normalizeArtieCustomerPetsMetafield(parsed, customerId);
  if (!store || !Array.isArray(store.pets) || !store.pets.length) return false;
  store.customer_id = customerId;
  writeArtiePetsStoreForced(store);
  syncPackDogsLocalStorageFromPetsStore(store);
  clearArtieDogDataLocalDirty();
  document.dispatchEvent(
    new CustomEvent('artie:customer-pets-hydrated', {
      bubbles: true,
      detail: { customerId: customerId }
    })
  );
  onArtieActiveDogOrStorageChanged();
  return true;
}

function mapActivityToStore(activity) {
  var m = {
    lightly_active: 'light',
    moderately_active: 'moderate',
    very_active: 'very_active',
    working_dog: 'working'
  };
  return m[activity] || activity || 'moderate';
}

function mapActivityFromStore(s) {
  var m = {
    light: 'lightly_active',
    moderate: 'moderately_active',
    very_active: 'very_active',
    working: 'working_dog'
  };
  return m[s] || s || 'moderately_active';
}

function mapBodyConditionToStore(bcs) {
  var n = String(bcs == null ? '3' : bcs).replace(/\D/g, '') || '3';
  if (n < '1' || n > '5') n = '3';
  return 'type' + n;
}

function mapBodyConditionFromStore(body_condition) {
  var m = String(body_condition || '').match(/^type(\d)$/i);
  return m ? m[1] : '3';
}

function mapTreatToStore(treats) {
  var m = { hardly_ever: 'rare', sometimes: 'sometimes', a_lot: 'often' };
  return m[treats] || treats || 'sometimes';
}

function mapTreatFromStore(tf) {
  var m = { rare: 'hardly_ever', sometimes: 'sometimes', often: 'a_lot' };
  return m[tf] || tf || 'sometimes';
}

function primaryPetFromStore() {
  var store = readArtiePetsStore();
  if (!store.pets || !store.pets.length) return null;
  var primary = null;
  for (var i = 0; i < store.pets.length; i++) {
    if (store.pets[i].is_primary) {
      primary = store.pets[i];
      break;
    }
  }
  return primary || store.pets[0];
}

function quizProfileFromStoredPet(pet) {
  if (!pet || !pet.attributes) return null;
  var a = pet.attributes;
  var w = typeof a.weight === 'number' ? a.weight : parseInt(a.weight, 10);
  var age = typeof a.age === 'number' ? a.age : parseFloat(a.age);
  return {
    name: (pet.name || '').trim(),
    breed: a.breed || '',
    weight: !isNaN(w) && w > 0 ? w : null,
    age: !isNaN(age) ? age : 3,
    gender: a.gender || '',
    spayed: a.spayed_neutered ? 'yes' : 'no',
    activity: mapActivityFromStore(a.activity),
    bcs: mapBodyConditionFromStore(a.body_condition),
    sensitive: a.sensitive_tummy ? 'yes' : 'no',
    pickiness: a.pickiness || 'not_picky',
    treats: mapTreatFromStore(a.treat_frequency)
  };
}

function buildPetRecordFromQuiz(dog, reco, petId, ctx, quizSource) {
  var plan = reco && reco.plan;
  var dailyCal = plan ? (plan.der != null ? plan.der : plan.totalCal) : null;
  var packId = ctx && ctx.id != null ? ctx.id : null;
  var dk = packId != null ? dogKeyFromNameAndId(dog.name, packId) : normalizeDogKey(dog.name);
  var qsrc = quizSource || 'perfect_plan_overlay';
  return {
    id: petId,
    pack_dog_id: packId,
    dog_key: dk,
    name: dog.name || '',
    is_primary: true,
    attributes: {
      breed: dog.breed,
      gender: dog.gender || null,
      spayed_neutered: String(dog.spayed || 'yes').toLowerCase() === 'yes',
      age: dog.age,
      weight: dog.weight,
      activity: mapActivityToStore(dog.activity),
      body_condition: mapBodyConditionToStore(dog.bcs),
      sensitive_tummy: String(dog.sensitive || 'no').toLowerCase() === 'yes',
      pickiness: dog.pickiness || 'not_picky',
      treat_frequency: mapTreatToStore(dog.treats),
      daily_calories: dailyCal,
      dog_key: dk,
      recommended_portion: reco ? reco.portion : null,
      meal_price_per_meal: reco ? reco.price : null,
      meal_calories_per_day: plan ? plan.mealCal : null,
      treat_calories_per_day: plan ? plan.treatCal : null,
      last_quiz_at: new Date().toISOString(),
      quiz_source: qsrc
    }
  };
}

function saveQuizToArtiePetsStore(dog, reco, opts) {
  opts = opts || {};
  var ctx = getActivePackDogContext();
  var customerId = getArtieCustomerId();
  var store = readArtiePetsStore();
  store.customer_id = customerId || store.customer_id || '';
  var packId = ctx && ctx.id != null ? ctx.id : 'solo';
  var petId = 'pet_' + (customerId || 'guest') + '_' + packId;
  var newPet = buildPetRecordFromQuiz(dog, reco, petId, ctx);

  var pets = store.pets.slice();
  var idx = -1;
  for (var i = 0; i < pets.length; i++) {
    if (String(pets[i].pack_dog_id) === String(packId) || pets[i].id === petId) {
      idx = i;
      break;
    }
  }
  var existingPrimaryIdx = -1;
  for (var p = 0; p < pets.length; p++) {
    if (pets[p] && pets[p].is_primary) {
      existingPrimaryIdx = p;
      break;
    }
  }
  if (idx >= 0) {
    newPet.is_primary = !!pets[idx].is_primary;
    if (opts.preserveUserVariantSelection) {
      var prevAttrs = pets[idx].attributes || {};
      if (prevAttrs.recommended_portion != null && String(prevAttrs.recommended_portion).trim() !== '') {
        newPet.attributes.recommended_portion = String(prevAttrs.recommended_portion).trim();
      }
      if (prevAttrs.current_recipe != null && String(prevAttrs.current_recipe).trim() !== '') {
        newPet.attributes.current_recipe = String(prevAttrs.current_recipe).trim();
      }
    }
    pets[idx] = newPet;
  } else {
    // Keep the current primary dog stable; only first-ever pet becomes primary.
    newPet.is_primary = existingPrimaryIdx < 0;
    pets.push(newPet);
  }
  var primaryCount = 0;
  for (var k = 0; k < pets.length; k++) if (pets[k] && pets[k].is_primary) primaryCount++;
  if (primaryCount === 0 && pets.length) pets[0].is_primary = true;
  if (primaryCount > 1) {
    var keepIdx = -1;
    if (existingPrimaryIdx >= 0 && existingPrimaryIdx < pets.length) keepIdx = existingPrimaryIdx;
    if (keepIdx < 0 && idx >= 0 && pets[idx] && pets[idx].is_primary) keepIdx = idx;
    if (keepIdx < 0) keepIdx = 0;
    for (var m = 0; m < pets.length; m++) pets[m].is_primary = m === keepIdx;
  }
  store.pets = pets;
  markArtieDogDataLocalDirty();
  writeArtiePetsStore(store);
}

/**
 * Dedicated calculator page: append a new pet row without changing is_primary on existing pack dogs.
 */
function appendCalculatorPagePetToStore(dog, reco) {
  var store = readArtiePetsStore();
  store.customer_id = getArtieCustomerId() || store.customer_id || '';
  var syntheticPackId = Date.now();
  var petsExisting = store.pets || [];
  for (var tryI = 0; tryI < 100; tryI++) {
    var candidate = syntheticPackId + tryI;
    var clash = false;
    for (var y = 0; y < petsExisting.length; y++) {
      var ex = petsExisting[y];
      if (ex && String(ex.pack_dog_id) === String(candidate)) {
        clash = true;
        break;
      }
    }
    if (!clash) {
      syntheticPackId = candidate;
      break;
    }
  }
  var customerId = getArtieCustomerId();
  var petId = 'pet_' + (customerId || 'guest') + '_' + String(syntheticPackId);
  var ctx = { id: syntheticPackId, name: dog.name, weight: dog.weight };
  var newPet = buildPetRecordFromQuiz(dog, reco, petId, ctx, 'calculator_page');
  newPet.is_primary = false;
  var pets = store.pets.slice();
  pets.push(newPet);
  store.pets = pets;
  markArtieDogDataLocalDirty();
  writeArtiePetsStore(store);
  invalidateArtiePetsStoreReadCache();
  var storeFresh = readArtiePetsStore();
  if (syncPackDogsLocalStorageFromPetsStore(storeFresh)) {
    dispatchArtiePackDogsFromStoreEvent(true);
  }
  return { packDogId: syntheticPackId, petId: petId };
}

/** Profile: per-dog flat keys artie_dog_quiz_<packId>_*, artie_pets_store pet, or legacy artie_dog_0_*. */
function loadQuizDogProfile() {
  var ctx = getActivePackDogContext();
  var keyBase = getQuizKeyBase(ctx);
  function ls(k, def) {
    var v = localStorage.getItem(keyBase + k);
    return v != null && v !== '' ? v : def;
  }
  var hidden = document.getElementById('dogName');
  var nameLs = ls('name', '');
  if (!ctx) {
    nameLs = nameLs || localStorage.getItem('artie_dog_0_name') || localStorage.getItem('artie_dog_name') || '';
  }
  var name = nameLs.trim() || stripPossessive(hidden && hidden.value);
  var weightR = ls('weight', '');
  if (!weightR && ctx && ctx.weight != null) weightR = String(ctx.weight);
  if (!weightR) weightR = localStorage.getItem('artie_dog_weight') || '';
  var w = parseInt(weightR, 10);
  var ageLs = parseFloat(ls('age', '3'));
  var fromFlat = {
    name: name,
    breed: ls('breed', localStorage.getItem('artie_dog_breed') || ''),
    weight: !isNaN(w) && w > 0 ? w : null,
    age: !isNaN(ageLs) ? ageLs : 3,
    gender: ls('gender', ''),
    spayed: ls('spayed', 'yes'),
    activity: ls('activity', 'moderately_active'),
    bcs: ls('bcs', '3'),
    sensitive: ls('sensitive', 'no'),
    pickiness: ls('pickiness', 'not_picky'),
    treats: ls('treats', 'sometimes')
  };

  var store = readArtiePetsStore();
  var pet = ctx ? petFromStoreForPackId(store, ctx.id) : primaryPetFromStore();
  var fromPet = pet ? quizProfileFromStoredPet(pet) : null;
  if (fromPet) {
    if (ctx && ctx.name) fromPet.name = (fromPet.name && fromPet.name.trim()) || ctx.name;
    else fromPet.name = nameLs.trim() || fromPet.name || stripPossessive(hidden && hidden.value);
    if (ctx && ctx.weight > 0) fromPet.weight = ctx.weight;
    return fromPet;
  }

  if (ctx && ctx.weight > 0 && (fromFlat.weight == null || fromFlat.weight <= 0)) {
    fromFlat.weight = ctx.weight;
  }
  if (ctx && ctx.name && !fromFlat.name) fromFlat.name = ctx.name;
  return fromFlat;
}

// ── Portion info (Escape: calculator only) ──
document.addEventListener('keydown', function(e) {
  if (e.key !== 'Escape') return;
  var calc = document.querySelector('#calcOverlay[role="dialog"]');
  if (calc && calc.style.display === 'block') closeCalculator();
});

var CALC_BCS_INFO =
  'Type 1 (Very Thin): ribs, spine, hip bones visible.\n' +
  'Type 2 (Underweight): ribs easily felt, no fat cover.\n' +
  'Type 3 (Ideal): ribs felt with thin fat layer.\n' +
  'Type 4 (Overweight): ribs hard to feel, fat layer.\n' +
  'Type 5 (Obese): ribs not palpable, heavy fat.';

var artieGlobalDocListenersBound = false;
function bindArtieGlobalDocumentListenersOnce() {
  if (artieGlobalDocListenersBound) return;
  artieGlobalDocListenersBound = true;
  document.addEventListener('click', onArtieJsQuizPopupClick);
  document.addEventListener('artie:active-dog-changed', onArtieActiveDogOrStorageChanged);
  document.addEventListener('artie:dog-name-changed', onArtieDogNameChanged);
  window.addEventListener('storage', function(ev) {
    if (
      ev.key === 'artie-dogs' ||
      ev.key === 'artie-dogs-active' ||
      ev.key === 'artie_active_pack_dog_id' ||
      ev.key === ARTIE_PETS_STORE_KEY ||
      ev.key === ARTIE_RECOMMENDED_PORTION_KEY ||
      ev.key === 'artie-dogs'
    ) {
      onArtieActiveDogOrStorageChanged();
    }
  });
}

/** Variant picker “quiz” suffix: `.js-quiz-popup` opens the Perfect Plan overlay (`#calcOverlay`). */
function onArtieJsQuizPopupClick(e) {
  var trigger = e.target.closest('.js-quiz-popup');
  if (!trigger) return;
  if (!getQuizDialogOverlay()) return;
  e.preventDefault();
  e.stopPropagation();
  openCalculator();
}

var artieCalcStepperBound = false;
function bindCalcStepperButtonsOnce() {
  if (artieCalcStepperBound) return;
  artieCalcStepperBound = true;
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.calc-stepper-btn');
    if (!btn) return;
    var stepper = btn.closest('.calc-stepper');
    if (!stepper) return;
    var input = stepper.querySelector('#calcWeight');
    if (!(input instanceof HTMLInputElement) || input.type !== 'number') return;
    var delta = parseInt(btn.getAttribute('data-step') || '0', 10);
    if (!delta) return;
    e.preventDefault();
    var bounds = getCalcWeightBounds(input);
    var min = bounds.min;
    var max = bounds.max;
    var v = parseInt(input.value, 10);
    if (isNaN(v)) v = 20;
    v = Math.min(max, Math.max(min, v + delta));
    input.value = String(v);
    updateCalcWeight(String(v), input);
    hideCalcWeightError(input.closest('#calcQuizForm'), input);
    var dlg = input.closest('#calcOverlay[role="dialog"]');
    if (dlg) {
      var ctx = getActivePackDogContext();
      if (ctx && ctx.id != null) {
        document.dispatchEvent(
          new CustomEvent('artie:dog-weight-changed', {
            bubbles: true,
            detail: { packDogId: ctx.id, weightNum: v, immediate: true }
          })
        );
      }
    }
  });
}

function bindCalcDogNameFieldUI(form) {
  if (!(form instanceof HTMLFormElement)) return;
  var input = form.querySelector('#dogName');
  if (!input) return;
  input.addEventListener('input', function() {
    var err = form.querySelector('#dogNameError');
    if (err) {
      err.hidden = true;
      err.textContent = '';
    }
    input.removeAttribute('aria-invalid');
  });
}

function bindCalcEmailFieldUI(form) {
  if (!(form instanceof HTMLFormElement)) return;
  var input = form.querySelector('#calcEmail');
  if (!input) return;
  input.addEventListener('input', function() {
    var err = form.querySelector('#calcEmailError');
    if (err) {
      err.hidden = true;
      err.textContent = '';
    }
    input.removeAttribute('aria-invalid');
  });
}

var ARTIE_DOG_WEIGHT_MIN_LB = 4;
var ARTIE_DOG_WEIGHT_MAX_LB = 200;

/** @returns {{ min: number, max: number }} */
function getCalcWeightBounds(inputEl) {
  var min = ARTIE_DOG_WEIGHT_MIN_LB;
  var max = ARTIE_DOG_WEIGHT_MAX_LB;
  if (inputEl) {
    var attrMin = parseInt(inputEl.getAttribute('min') || '', 10);
    var attrMax = parseInt(inputEl.getAttribute('max') || '', 10);
    if (!isNaN(attrMin)) min = attrMin;
    if (!isNaN(attrMax)) max = attrMax;
  }
  return { min: min, max: max };
}

/** @param {number} n */
function isArtieDogWeightInRange(n) {
  return typeof n === 'number' && !isNaN(n) && n >= ARTIE_DOG_WEIGHT_MIN_LB && n <= ARTIE_DOG_WEIGHT_MAX_LB;
}

/**
 * Strict weight parse for submit / blur validation (whole pounds only).
 * @returns {{ valid: boolean, value: number|null, reason: 'blank'|'invalid'|'low'|'high'|null }}
 */
function parseQuizWeightInputStrict(val) {
  var raw = String(val != null ? val : '').trim();
  if (!raw) return { valid: false, value: null, reason: 'blank' };
  if (!/^\d+$/.test(raw)) return { valid: false, value: null, reason: 'invalid' };
  var n = parseInt(raw, 10);
  if (n < ARTIE_DOG_WEIGHT_MIN_LB) return { valid: false, value: n, reason: 'low' };
  if (n > ARTIE_DOG_WEIGHT_MAX_LB) return { valid: false, value: n, reason: 'high' };
  return { valid: true, value: n, reason: null };
}

/** @param {HTMLFormElement | null | undefined} form @param {'blank'|'invalid'|'low'|'high'} reason */
function calcWeightValidationMessage(form, reason) {
  return (
    (form && form.getAttribute('data-artie-calc-weight-error')) ||
    'Please enter a valid weight between 4lbs and 200lbs.'
  );
}

function hideCalcWeightError(form, input) {
  var errEl = form ? form.querySelector('#calcWeightError') : document.getElementById('calcWeightError');
  if (errEl) {
    errEl.hidden = true;
    errEl.textContent = '';
  }
  if (input) input.removeAttribute('aria-invalid');
}

/** @param {HTMLFormElement | null | undefined} form @param {string} text @param {HTMLElement | null} [input] */
function showCalcWeightError(form, text, input) {
  var errEl = form ? form.querySelector('#calcWeightError') : document.getElementById('calcWeightError');
  var weightInput = input || (form ? form.querySelector('#calcWeight') : document.getElementById('calcWeight'));
  if (errEl) {
    errEl.textContent = text;
    errEl.hidden = false;
  }
  if (weightInput) {
    weightInput.setAttribute('aria-invalid', 'true');
    try {
      weightInput.focus();
    } catch (errFocus) {}
  }
}

function sanitizeCalcWeightInputValue(input) {
  if (!(input instanceof HTMLInputElement)) return;
  var raw = String(input.value || '');
  var cleaned = raw.replace(/[^\d]/g, '');
  if (cleaned !== raw) input.value = cleaned;
  if (!cleaned) return;
  var bounds = getCalcWeightBounds(input);
  var n = parseInt(cleaned, 10);
  if (!isNaN(n) && n > bounds.max) input.value = String(bounds.max);
}

function bindCalcWeightFieldUI(form) {
  if (!(form instanceof HTMLFormElement)) return;
  var input = form.querySelector('#calcWeight');
  if (!input) return;
  input.addEventListener('keydown', function(e) {
    if (e.key === '-' || e.key === '+' || e.key === 'e' || e.key === 'E' || e.key === '.') {
      e.preventDefault();
    }
  });
  input.addEventListener('input', function() {
    sanitizeCalcWeightInputValue(input);
    var parsed = parseQuizWeightInputStrict(input.value);
    if (parsed.valid) hideCalcWeightError(form, input);
  });
}

/** @returns {boolean} */
function validateCalcWeight(form) {
  var input = form ? form.querySelector('#calcWeight') : document.getElementById('calcWeight');
  if (!input) return true;
  var parsed = parseQuizWeightInputStrict(input.value);
  if (parsed.valid) {
    hideCalcWeightError(form, input);
    return true;
  }
  showCalcWeightError(form, calcWeightValidationMessage(form, parsed.reason || 'invalid'), input);
  return false;
}

/** @returns {boolean} */
function validateCalcDogNameIfRequired(form) {
  if (!(form instanceof HTMLFormElement)) return true;
  var errEl = form.querySelector('#dogNameError');
  if (!errEl) return true;
  var input = form.querySelector('#dogName');
  if (!input || input.getAttribute('type') === 'hidden') return true;
  var blankMsg =
    form.getAttribute('data-artie-calc-dog-name-error-blank') || "Please enter your dog's name.";
  function showErr(text) {
    if (errEl) {
      errEl.textContent = text;
      errEl.hidden = false;
    }
    input.setAttribute('aria-invalid', 'true');
    try {
      input.focus();
    } catch (errFocus) {}
    return false;
  }
  function hideErr() {
    if (errEl) {
      errEl.hidden = true;
      errEl.textContent = '';
    }
    input.removeAttribute('aria-invalid');
  }
  var v = String(input.value || '').trim();
  if (!stripPossessive(v)) return showErr(blankMsg);
  hideErr();
  return true;
}

/** @returns {boolean} */
function validateCalcEmailIfPresent(form) {
  if (!(form instanceof HTMLFormElement)) return true;
  var input = form.querySelector('#calcEmail');
  if (!input) return true;
  var errEl = form.querySelector('#calcEmailError');
  var blankMsg =
    form.getAttribute('data-artie-calc-email-error-blank') || 'Please enter your email address.';
  var invalidMsg =
    form.getAttribute('data-artie-calc-email-error-invalid') || 'Please enter a valid email address.';
  function hideErr() {
    if (errEl) {
      errEl.hidden = true;
      errEl.textContent = '';
    }
    input.removeAttribute('aria-invalid');
  }
  function showErr(text) {
    if (errEl) {
      errEl.textContent = text;
      errEl.hidden = false;
    }
    input.setAttribute('aria-invalid', 'true');
    try {
      input.focus();
    } catch (errFocus) {}
    return false;
  }
  var v = String(input.value || '').trim();
  var isRequired = false;
  try {
    isRequired = input.required || input.hasAttribute('required');
  } catch (errReq) {
    isRequired = input.hasAttribute('required');
  }
  if (!v) {
    if (!isRequired) {
      hideErr();
      return true;
    }
    return showErr(blankMsg);
  }
  input.value = v;
  if (typeof input.checkValidity === 'function' && !input.checkValidity()) return showErr(invalidMsg);
  hideErr();
  return true;
}

var quizOverlayUiBound = false;
function initQuizOverlayUI() {
  if (quizOverlayUiBound) return;
  var backdrop = document.getElementById('calcBackdrop');
  var overlays = document.querySelectorAll('#calcOverlay');
  if (!overlays.length || !backdrop) return;
  quizOverlayUiBound = true;

  // Portal the overlay (backdrop + panel) to <body>: ancestors inside the buy
  // box form stacking contexts (e.g. .product-details z-index lift) that trap
  // the fixed panel's z-index below the sticky header.
  var quizWrap = backdrop.closest('.artie-quiz-overlay');
  if (quizWrap && quizWrap.parentElement !== document.body && !(window.Shopify && window.Shopify.designMode)) {
    document.body.appendChild(quizWrap);
  }

  var cta = document.getElementById('pdpCalcCta');
  if (cta) {
    cta.addEventListener('click', function(e) {
      e.preventDefault();
      openCalculator();
    });
  }

  backdrop.addEventListener('click', closeCalculator);

  overlays.forEach(function(overlay) {
    var closeBtn = overlay.querySelector('.calc-close');
    if (closeBtn) closeBtn.addEventListener('click', function() { closeCalculator(); });

    var form = overlay.querySelector('#calcQuizForm');
    if (form) {
      form.addEventListener('submit', submitCalculator);
      bindCalcDogNameFieldUI(form);
      bindCalcEmailFieldUI(form);
      bindCalcWeightFieldUI(form);
    }

    var wrongDog = overlay.querySelector('.calc-wrong-dog-link');
    if (wrongDog) {
      wrongDog.addEventListener('click', function(e) {
        e.preventDefault();
        closeCalculator();
        var pack = document.querySelector('pack-builder') || document.querySelector('.artie-pack-builder__dogs');
        if (pack) pack.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    var ageEl = overlay.querySelector('#calcAge');
    if (ageEl) {
      // Allow free-form typing on `input`; only mirror the raw value to the
      // optional sidecar display. Normalization (clamping / defaults) happens
      // on `blur` and on submit so we don't clobber what the user is typing.
      ageEl.addEventListener('input', function() {
        var sidecar = document.getElementById('calcAgeVal');
        if (sidecar) sidecar.textContent = String(this.value || '').trim();
      });
      ageEl.addEventListener('blur', function() { updateCalcAge(this.value, this); });
    }
    var weightEl = overlay.querySelector('#calcWeight');
    if (weightEl) {
      weightEl.addEventListener('input', function() {
        // Don't overwrite the input mid-typing — that's what was blocking
        // manual entry. Just keep the sidecar display in sync and only
        // notify pack-builder when the typed value is already a usable
        // number within the allowed range.
        sanitizeCalcWeightInputValue(this);
        var raw = String(this.value || '').trim();
        var sidecar = document.getElementById('calcWeightVal');
        if (sidecar) sidecar.textContent = raw;
        if (overlay.getAttribute('role') !== 'dialog') return;
        var ctx = getActivePackDogContext();
        if (!ctx || ctx.id == null) return;
        if (!raw) return;
        var strict = parseQuizWeightInputStrict(raw);
        if (!strict.valid || strict.value == null) return;
        document.dispatchEvent(
          new CustomEvent('artie:dog-weight-changed', {
            bubbles: true,
            detail: { packDogId: ctx.id, weightNum: strict.value, immediate: false }
          })
        );
      });
      weightEl.addEventListener('blur', function() {
        var form = this.closest('#calcQuizForm');
        var strict = parseQuizWeightInputStrict(this.value);
        if (strict.valid && strict.value != null) {
          updateCalcWeight(String(strict.value), this);
          hideCalcWeightError(form, this);
        } else if (strict.reason) {
          showCalcWeightError(form, calcWeightValidationMessage(form, strict.reason), this);
        }
        if (overlay.getAttribute('role') !== 'dialog') return;
        var ctx = getActivePackDogContext();
        if (!ctx || ctx.id == null) return;
        if (!strict.valid || strict.value == null) return;
        document.dispatchEvent(
          new CustomEvent('artie:dog-weight-changed', {
            bubbles: true,
            detail: { packDogId: ctx.id, weightNum: strict.value, immediate: true }
          })
        );
      });
    }

    overlay.addEventListener('click', function(e) {
      var info = e.target.closest('.calc-info-trigger');
      if (info) {
        e.preventDefault();
        alert(CALC_BCS_INFO);
        return;
      }
      var successIcon = e.target.closest('.success-icon');
      if (successIcon) {
        e.preventDefault();
        closeCalculator();
        return;
      }
      var pill = e.target.closest('.quiz-pill');
      if (pill && pill.closest('#calcOverlay')) selectCalcPill(pill);
    });
    overlay.addEventListener('keydown', function(e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var info = e.target.closest('.calc-info-trigger');
      if (info) {
        e.preventDefault();
        alert(CALC_BCS_INFO);
        return;
      }
      var successIcon = e.target.closest('.success-icon');
      if (successIcon) {
        e.preventDefault();
        closeCalculator();
      }
    });
  });

  window.openCalculator = openCalculator;
  window.closeCalculator = closeCalculator;
}

function resetQuizOverlayPanels() {
  var quizForm = document.getElementById('quizForm');
  var quizSuccess = document.getElementById('quizSuccess');
  if (quizForm) quizForm.style.display = '';
  if (quizSuccess) quizSuccess.classList.remove('active');
}

function showQuizSuccessState(dog, reco) {
  var hidden = document.getElementById('dogName');
  var display = displayNameFromSources(dog.name, hidden && hidden.value);
  var quizForm = document.getElementById('quizForm');
  var quizSuccess = document.getElementById('quizSuccess');
  var successDetail = document.getElementById('successDetail');
  if (quizForm) quizForm.style.display = 'none';
  if (quizSuccess) quizSuccess.classList.add('active');
  if (successDetail) {
    if (reco) {
      var who = display === 'your dog' ? 'Your' : display + '\u2019s';
      successDetail.textContent =
        who + ' plan now uses a ' + reco.portion + ' portion based on this quiz.';
    } else {
      successDetail.textContent =
        'We\u2019ve saved your answers. If portions look off, try adjusting weight or body condition.';
    }
  }
}

function getQuizDialogOverlay() {
  return document.querySelector('#calcOverlay[role="dialog"]');
}

function openCalculator() {
  resetQuizOverlayPanels();
  syncJsDogNameDisplays();
  var dog = loadQuizDogProfile();

  var dlg = getQuizDialogOverlay();
  var root = dlg || document.getElementById('calcOverlay');
  if (!root) return;

  var hidden = root.querySelector('#dogName') || document.getElementById('dogName');
  var display = displayNameFromSources(dog.name, hidden && hidden.value);
  var possessive = possessiveLabel(display);
  var calcDogName = root.querySelector('#calcDogName') || document.getElementById('calcDogName');
  var calcSubmitName = root.querySelector('#calcSubmitName') || document.getElementById('calcSubmitName');
  if (calcDogName) calcDogName.textContent = display;
  if (calcSubmitName) calcSubmitName.textContent = possessive;

  var breedEl = root.querySelector('#calcBreed');
  if (breedEl) breedEl.value = dog.breed || '';
  var ageInput = root.querySelector('#calcAge');
  var weightInput = root.querySelector('#calcWeight');
  if (ageInput) {
    var a0 = dog.age != null && !isNaN(dog.age) ? Number(dog.age) : 3;
    ageInput.value = formatAgeInputValue(a0);
    updateCalcAge(ageInput.value);
  }
  if (weightInput) {
    var w0 = dog.weight != null && isArtieDogWeightInRange(Number(dog.weight)) ? dog.weight : 20;
    weightInput.value = String(w0);
    updateCalcWeight(weightInput.value, weightInput);
    hideCalcWeightError(root.querySelector('#calcQuizForm'), weightInput);
  }

  setCalcPill('gender', dog.gender || '');
  setCalcPill('spayed', dog.spayed || 'yes');
  setCalcPill('activity', dog.activity || 'moderately_active');
  setCalcPill('bcs', dog.bcs || '3');
  setCalcPill('sensitive', dog.sensitive || 'no');
  setCalcPill('pickiness', dog.pickiness || 'not_picky');
  setCalcPill('treats', dog.treats || 'sometimes');

  document.getElementById('calcBackdrop').style.display = 'block';
  if (dlg) {
    dlg.style.display = 'block';
  } else if (root) {
    root.style.display = 'block';
  }
  document.body.style.overflow = 'hidden';
  setTimeout(function() {
    var breed = root.querySelector('#calcBreed');
    if (breed) breed.focus();
  }, 40);
}

function closeCalculator(e) {
  if (e && e.target && e.currentTarget && e.target !== e.currentTarget) return;
  var backdrop = document.getElementById('calcBackdrop');
  if (backdrop) backdrop.style.display = 'none';
  var dlg = getQuizDialogOverlay();
  if (dlg) dlg.style.display = 'none';
  document.body.style.overflow = '';
  resetQuizOverlayPanels();
}

function normalizeQuizAge(val) {
  var num = parseFloat(String(val != null ? val : '').trim());
  if (isNaN(num)) num = 3;
  return Math.min(25, Math.max(0, num));
}

function formatAgeInputValue(num) {
  var n = normalizeQuizAge(num);
  var r = Math.round(n * 10) / 10;
  if (Math.abs(r - Math.round(r)) < 1e-9) return String(Math.round(r));
  return String(r);
}

function updateCalcAge(val, inputEl) {
  var n = normalizeQuizAge(val);
  var str = formatAgeInputValue(n);
  var input = inputEl || document.getElementById('calcAge');
  if (input) input.value = str;
  var el = document.getElementById('calcAgeVal');
  if (el) el.textContent = str;
}

function normalizeQuizWeight(val) {
  var strict = parseQuizWeightInputStrict(val);
  if (strict.valid && strict.value != null) return strict.value;
  var n = parseInt(String(val != null ? val : '').trim(), 10);
  if (isNaN(n)) n = 20;
  return Math.min(ARTIE_DOG_WEIGHT_MAX_LB, Math.max(ARTIE_DOG_WEIGHT_MIN_LB, n));
}

function updateCalcWeight(val, inputEl) {
  var n = normalizeQuizWeight(val);
  var str = String(n);
  var input = inputEl || document.getElementById('calcWeight');
  if (input) input.value = str;
  var el = document.getElementById('calcWeightVal');
  if (el) el.textContent = str;
  paintCalcSlider(input && input.type === 'range' ? input : null);
}

function paintCalcSlider(slider) {
  if (!slider || slider.type !== 'range') return;
  var pct = ((slider.value - slider.min) / (slider.max - slider.min)) * 100;
  slider.style.background =
    'linear-gradient(to right, var(--champagne) 0%, var(--champagne) ' + pct + '%, rgba(250,247,242,0.12) ' + pct + '%, rgba(250,247,242,0.12) 100%)';
}

function selectCalcPill(btn) {
  var group = btn.parentElement;
  if (!group) return;
  group.querySelectorAll('.quiz-pill').forEach(function(p) { p.classList.remove('active'); });
  btn.classList.add('active');
}

function getCalcPill(field, root) {
  var scope = root && root.querySelector ? root : document;
  var group = scope.querySelector('[data-calc-group="' + field + '"]');
  if (!group) return null;
  var active = group.querySelector('.quiz-pill.active');
  return active ? active.getAttribute('data-value') : null;
}

function setCalcPill(field, value) {
  var group = document.querySelector('[data-calc-group="' + field + '"]');
  if (!group) return;
  group.querySelectorAll('.quiz-pill').forEach(function(p) {
    if (p.getAttribute('data-value') === value) p.classList.add('active');
    else p.classList.remove('active');
  });
}

// ── Weight → meal plan routing (MEAL_PLAN_BUCKETS / Full Half Topper Plan Map) ──
var ARTIE_FULL_ROUTING_TABLE = [
  { min: 1, max: 3, mp: null },
  { min: 4, max: 6, mp: 3, cal: 162 },
  { min: 7, max: 9, mp: 5, cal: 216 },
  { min: 10, max: 15, mp: 7, cal: 324 },
  { min: 16, max: 20, mp: 9, cal: 432 },
  { min: 21, max: 26, mp: 11, cal: 540 },
  { min: 27, max: 34, mp: 13, cal: 648 },
  { min: 35, max: 42, mp: 15, cal: 756 },
  { min: 43, max: 50, mp: 17, cal: 854 },
  { min: 51, max: 55, mp: 19, cal: 972 },
  { min: 56, max: 65, mp: 21, cal: 1080 },
  { min: 66, max: 75, mp: 23, cal: 1188 },
  { min: 76, max: 999, mp: null }
];
var ARTIE_HALF_ROUTING_TABLE = [
  { min: 1, max: 9, mp: null },
  { min: 10, max: 14, mp: 3, cal: 162 },
  { min: 15, max: 24, mp: 5, cal: 216 },
  { min: 25, max: 36, mp: 7, cal: 324 },
  { min: 37, max: 51, mp: 9, cal: 432 },
  { min: 52, max: 69, mp: 11, cal: 540 },
  { min: 70, max: 84, mp: 13, cal: 648 },
  { min: 85, max: 100, mp: 15, cal: 756 },
  { min: 101, max: 117, mp: 17, cal: 854 },
  { min: 118, max: 144, mp: 19, cal: 972 },
  { min: 145, max: 160, mp: 21, cal: 1080 },
  { min: 161, max: 200, mp: 23, cal: 1188 },
  { min: 201, max: 999, mp: null }
];
var ARTIE_TOPPER_ROUTING_TABLE = [
  { min: 1, max: 29, mp: null },
  { min: 30, max: 42, mp: 3, cal: 162 },
  { min: 43, max: 70, mp: 5, cal: 216 },
  { min: 71, max: 110, mp: 7, cal: 324 },
  { min: 111, max: 164, mp: 9, cal: 432 },
  { min: 165, max: 200, mp: 11, cal: 540 },
  { min: 201, max: 999, mp: null }
];

/** 15-Day Intro Box prices by MP × recipe (Artie Pricing May 2026). */
var ARTIE_PRICES_15DAY = {
  3: { chicken_hb: 75, beef_hb: 75, chicken_xp: 85 },
  5: { chicken_hb: 82.5, beef_hb: 82.5, chicken_xp: 97.5 },
  7: { chicken_hb: 95, beef_hb: 95, chicken_xp: 115 },
  9: { chicken_hb: 105, beef_hb: 105, chicken_xp: 135 },
  11: { chicken_hb: 122.5, beef_hb: 122.5, chicken_xp: 162.5 },
  13: { chicken_hb: 135, beef_hb: 135, chicken_xp: 182.5 },
  15: { chicken_hb: 150, beef_hb: 150, chicken_xp: 205 },
  17: { chicken_hb: 165, beef_hb: 165, chicken_xp: 225 },
  19: { chicken_hb: 185, beef_hb: 185, chicken_xp: 250 },
  21: { chicken_hb: 195, beef_hb: 195, chicken_xp: 272.5 },
  23: { chicken_hb: 207.5, beef_hb: 207.5, chicken_xp: 292.5 }
};

var ARTIE_MEAL_PLAN_DER_FACTOR = 1.29;
var ARTIE_15_DAY_MEAL_PLANS_JSON_FILE = '15-day-meal-plans.json';

/**
 * @param {'full'|'half'|'topper'|string} tier
 * @returns {{ min: number, max: number, mp: number|null, cal?: number }[]}
 */
function artieMealPlanRoutingTableForTier(tier) {
  if (tier === 'full') return ARTIE_FULL_ROUTING_TABLE;
  if (tier === 'half') return ARTIE_HALF_ROUTING_TABLE;
  if (tier === 'topper') return ARTIE_TOPPER_ROUTING_TABLE;
  return [];
}

/**
 * @param {{ min: number, max: number, mp: number|null, cal?: number }[]} table
 * @param {number} weightLb
 * @returns {{ min: number, max: number, mp: number|null, cal?: number } | null}
 */
function artieLookupMealPlanRoutingRow(table, weightLb) {
  var wt = Math.round(Number(weightLb));
  if (isNaN(wt) || wt <= 0) return null;
  for (var i = 0; i < table.length; i++) {
    var row = table[i];
    if (wt >= row.min && wt <= row.max) return row;
  }
  return null;
}

/**
 * @param {string} recipeLine
 * @returns {'chicken_hb'|'beef_hb'|'chicken_xp'}
 */
function artieMealPlanRecipeKeyFor15DayPrice(recipeLine) {
  var suf = artieMealPlanRecipeSuffixForJson(recipeLine);
  if (suf === 'beef') return 'beef_hb';
  if (suf === 'chicken_xp') return 'chicken_xp';
  return 'chicken_hb';
}

/**
 * @param {{ mp?: number|null }|null|undefined} planPart
 * @param {string} [recipeLine]
 * @returns {number|null}
 */
function artie15DayBoxPriceForPlanPart(planPart, recipeLine) {
  if (!planPart || planPart.mp == null) return null;
  var row = ARTIE_PRICES_15DAY[planPart.mp];
  if (!row) return null;
  var key = artieMealPlanRecipeKeyFor15DayPrice(recipeLine || '');
  var price = row[key];
  return price == null ? null : Number(price);
}

/**
 * @returns {Promise<Record<string, any>>}
 */
function getArtie15DayMealPlansJsonData() {
  return getArtieMealPlanJsonData(ARTIE_15_DAY_MEAL_PLANS_JSON_FILE);
}

/**
 * @param {'full'|'half'|'topper'|string} tier
 * @returns {string}
 */
function artiePortionTierToPlanLabel(tier) {
  if (tier === 'full') return 'Full Plan';
  if (tier === 'half') return 'Half Plan';
  if (tier === 'topper') return 'Topper Plan';
  return '';
}

/**
 * @param {string} recipeLine
 * @param {string} variantName
 * @returns {boolean}
 */
function artieRecipeMatchesVariantName(recipeLine, variantName) {
  var rl = String(recipeLine || '').trim().toLowerCase();
  var vn = String(variantName || '').trim().toLowerCase();
  if (!rl || !vn) return false;
  if (rl === vn) return true;
  var rlCore = rl.split(/\s*[·|/]\s*/)[0].trim();
  var vnCore = vn.split(/\s*[·|/]\s*/)[0].trim();
  return rlCore === vnCore || rl.indexOf(vnCore) >= 0 || vnCore.indexOf(rlCore) >= 0;
}

/**
 * Resolve a meal plan node under a tier in `15-day-meal-plans.json`.
 * JSON keys use `"MealPlan 9"` (spaced); internal ids are often `MealPlan9`.
 * @param {Record<string, any>|null|undefined} tierNode
 * @param {string} mealPlanId
 * @returns {Record<string, any>|null}
 */
function artieLookup15DayMealPlanNode(tierNode, mealPlanId) {
  if (!tierNode || typeof tierNode !== 'object') return null;
  var normId = normalizeMainMealPlanId(mealPlanId);
  if (!normId) return null;
  if (tierNode[normId]) return tierNode[normId];
  var n = mealPlanNumberFromId(normId);
  if (n) {
    var spaced = 'MealPlan ' + n;
    if (tierNode[spaced]) return tierNode[spaced];
  }
  var k;
  for (k in tierNode) {
    if (!Object.prototype.hasOwnProperty.call(tierNode, k)) continue;
    if (normalizeMainMealPlanId(k) === normId) return tierNode[k];
  }
  return null;
}

/**
 * Resolve variant + selling plan from `15-day-meal-plans.json` by tier, meal plan id, and recipe.
 * @param {Record<string, any>} planData
 * @param {'full'|'half'|'topper'|string} tier
 * @param {string} mealPlanId
 * @param {string} recipeLine
 * @returns {{ variant_id: number|string, selling_plan_id: number, variant_name: string } | null}
 */
function artieLookup15DayMealPlanCommerceIds(planData, tier, mealPlanId, recipeLine) {
  var label = artiePortionTierToPlanLabel(tier);
  if (!label || !mealPlanId) return null;
  var tierNode = planData && planData[label];
  var plan = artieLookup15DayMealPlanNode(tierNode, mealPlanId);
  if (!plan || !Array.isArray(plan.variants)) return null;
  var recipeForMatch = artieRecipeOnlyFromCartLineTitle(recipeLine) || String(recipeLine || '').trim();
  var variants = plan.variants;
  var i;
  for (i = 0; i < variants.length; i++) {
    var v = variants[i];
    if (!v || v.variant_id == null) continue;
    if (artieRecipeMatchesVariantName(recipeForMatch, v.variant_name)) {
      return {
        variant_id: v.variant_id,
        selling_plan_id: v.selling_plan_id,
        variant_name: v.variant_name
      };
    }
  }
  return null;
}

/**
 * @param {number|null|undefined} boxPrice
 * @returns {string}
 */
function artiePerMealPriceFrom15DayBox(boxPrice) {
  if (boxPrice == null || isNaN(Number(boxPrice))) return '';
  return artieNormalizeMealPlanPriceText((Number(boxPrice) / 30).toFixed(2));
}

/**
 * Portion tier for meal-plan bucketing: live picker (fresh on `variant:selected`) → variant JSON → persisted quiz portion.
 * @returns {'full'|'half'|'topper'|''}
 */
function getActivePortionTierForMealPlanResolution() {
  var tier = portionTierFromLiveVariantPicker(null);
  if (tier) return tier;
  var v = getCurrentMainVariantSnapshot();
  var fromVar = extractCanonicalPortionFromVariant(v);
  tier = portionTierFromString(fromVar);
  if (tier) return tier;
  return portionTierFromString(getRecommendedPortionForActiveDog());
}

/**
 * @param {any} ctx - from `getActivePackDogContext()`
 * @returns {Record<string, any> | null}
 */
function findRecommendedPortionRowForPackContext(ctx) {
  if (!ctx) return null;
  var rows = readRecommendedPortionStore();
  if (!rows.length) return null;
  var idStr = ctx.id != null ? String(ctx.id) : '';
  var keyStr = ctx.dogKey ? String(ctx.dogKey) : '';
  var i;
  for (i = 0; i < rows.length; i++) {
    var r = rows[i];
    if (!r) continue;
    if (idStr && String(r.dog_id) === idStr) return r;
  }
  if (keyStr) {
    for (i = 0; i < rows.length; i++) {
      var r2 = rows[i];
      if (r2 && String(r2.dog_key || '') === keyStr) return r2;
    }
  }
  return null;
}

/**
 * @param {any} ctx - from `getActivePackDogContext()`
 * @param {{ useLiveState?: boolean }} [opts] - active dog: live picker + commerce; others: persisted pet attributes
 * @returns {ReturnType<typeof resolveMealPlanForActiveShoppingContext>}
 */
function resolveMealPlanForPackContext(ctx, opts) {
  opts = opts || {};
  if (!ctx || ctx.id == null) return null;

  var tier = '';
  if (opts.useLiveState) {
    tier = getActivePortionTierForMealPlanResolution();
  } else {
    var storeForTier = readArtiePetsStore();
    var petForTier = petFromStoreForPackId(storeForTier, ctx.id);
    var storedPortion =
      petForTier && petForTier.attributes && petForTier.attributes.recommended_portion != null
        ? String(petForTier.attributes.recommended_portion).trim()
        : '';
    tier = portionTierFromString(storedPortion);
  }
  if (!tier) return null;

  var row = findRecommendedPortionRowForPackContext(ctx);
  if (!row) return null;

  var weightLb = ctx.weight != null && !isNaN(Number(ctx.weight)) && Number(ctx.weight) > 0 ? Number(ctx.weight) : null;
  if (opts.useLiveState) {
    var commerceWeight = artieResolveDogWeightLbForCommerce();
    if (commerceWeight != null && !isNaN(Number(commerceWeight)) && Number(commerceWeight) > 0) {
      weightLb = Number(commerceWeight);
    }
  }
  if (weightLb == null || isNaN(Number(weightLb)) || Number(weightLb) <= 0) {
    var store = readArtiePetsStore();
    var pet = petFromStoreForPackId(store, ctx.id);
    var dog = pet ? quizProfileFromStoredPet(pet) : null;
    if (dog && dog.weight > 0) weightLb = Number(dog.weight);
  }
  if (weightLb == null || isNaN(Number(weightLb)) || Number(weightLb) <= 0) return null;

  var routingRow = artieLookupMealPlanRoutingRow(artieMealPlanRoutingTableForTier(tier), weightLb);

  var tierMealPlanKey = tier + '_meal_plan';
  var mealPlanId = normalizeMainMealPlanId(row[tierMealPlanKey]);
  if (!mealPlanId && routingRow && routingRow.mp != null) {
    mealPlanId = 'MealPlan' + routingRow.mp;
  }
  if (!mealPlanId || /^n\/a$/i.test(mealPlanId)) return null;

  var calKey = tier + '_cal/day';
  var rawCal = row[calKey];
  var calNum = null;
  if (rawCal != null && String(rawCal).trim() !== '' && !isNaN(parseFloat(String(rawCal)))) {
    calNum = typeof rawCal === 'number' ? rawCal : parseFloat(String(rawCal));
  } else if (routingRow && routingRow.cal != null) {
    calNum = routingRow.cal;
  }
  if (calNum == null || isNaN(calNum)) return null;

  var recipeLine = opts.useLiveState ? artieRecipeLineForMealPlanMapping() : artieRecipeLineForPackContext(ctx);
  var mpNum = mealPlanNumberFromId(mealPlanId);
  var boxPrice = artie15DayBoxPriceForPlanPart({ mp: mpNum }, recipeLine);

  return {
    tier: tier,
    calories: calNum,
    mealPlanId: mealPlanId,
    planCal: calNum,
    weightLb: Number(weightLb),
    boxPrice: boxPrice,
    dog_id: String(ctx.id),
    dog_name: row.dog_name != null ? String(row.dog_name) : undefined
  };
}

function resolveMealPlanForActiveShoppingContext() {
  var ctx = getActivePackDogContext();
  if (!ctx || ctx.id == null) return null;
  return resolveMealPlanForPackContext(ctx, { useLiveState: true });
}

// ── Multiple-dog add to cart (`localStorage.multiple-dog-atc`) ──
var ARTIE_MULTIPLE_DOG_ATC_KEY = 'multiple-dog-atc';

/** @type {ReturnType<typeof setTimeout> | null} */
var artieMultipleDogAtcSyncTimer = null;
var ARTIE_MULTIPLE_DOG_ATC_SYNC_DEBOUNCE_MS = 50;

/**
 * @returns {Array<Record<string, string>>}
 */
function readMultipleDogAtcStore() {
  try {
    var raw = localStorage.getItem(ARTIE_MULTIPLE_DOG_ATC_KEY);
    if (!raw || !String(raw).trim()) return [];
    var parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}

/**
 * @param {Array<Record<string, string>>} rows
 */
function writeMultipleDogAtcStore(rows) {
  try {
    localStorage.setItem(ARTIE_MULTIPLE_DOG_ATC_KEY, JSON.stringify(rows || []));
  } catch (e) {}
}

/**
 * @param {number|string} packRowId
 * @returns {string}
 */
function artieCustomerDogIdFromPackRowId(packRowId) {
  var packRowIdStr = packRowId != null ? String(packRowId).trim() : '';
  if (!packRowIdStr) return '';
  var customerSegment = getArtieCustomerId() || 'guest';
  return ('pet_' + customerSegment + '_' + packRowIdStr).slice(0, 250);
}

/**
 * @param {'full'|'half'|'topper'|string} tier
 * @returns {string}
 */
function artiePortionLabelFromTier(tier) {
  if (tier === 'full') return 'Full';
  if (tier === 'half') return 'Half';
  if (tier === 'topper') return 'Topper';
  return '';
}

/**
 * @param {Record<string, string>} entry - row from `multiple-dog-atc`
 * @returns {any|null}
 */
function artiePackContextFromMultipleDogAtcEntry(entry) {
  var want = entry && entry.dogId != null ? String(entry.dogId).trim() : '';
  if (!want) return null;
  var dogs = [];
  try {
    var raw = localStorage.getItem('artie-dogs');
    if (raw) dogs = JSON.parse(raw);
  } catch (e) {}
  if (!Array.isArray(dogs)) return null;
  var i;
  for (i = 0; i < dogs.length; i++) {
    var d = dogs[i];
    if (!d || d.id == null) continue;
    if (artieCustomerDogIdFromPackRowId(d.id) !== want) continue;
    return {
      id: d.id,
      name: String(d.name == null ? '' : d.name).trim(),
      weight: d.weight != null && d.weight !== '' ? Number(d.weight) : null,
      dogKey: dogKeyFromNameAndId(d.name, d.id)
    };
  }
  return null;
}

/**
 * Cart line-item properties only (not stored on `multiple-dog-atc`).
 * @param {Record<string, string>} entry
 * @param {boolean} [isActiveDog]
 * @returns {{ permeal_price: string }}
 */
function artieCartLinePricePropertiesFromPackEntry(entry, isActiveDog) {
  /** @type {{ permeal_price: string }} */
  var out = { permeal_price: '' };
  var ctx = artiePackContextFromMultipleDogAtcEntry(entry);
  if (!ctx) return out;
  var res = resolveMealPlanForPackContext(ctx, { useLiveState: !!isActiveDog });
  if (res && res.boxPrice != null && !isNaN(Number(res.boxPrice))) {
    out.permeal_price = artiePerMealPriceFrom15DayBox(res.boxPrice);
  }
  if (isActiveDog) {
    try {
      var getter = /** @type {any} */ (window).getArtieMealPlanCommerceIds;
      if (typeof getter === 'function') {
        var commerce = getter();
        if (commerce && commerce.permeal_price != null && String(commerce.permeal_price).trim() !== '') {
          out.permeal_price = String(commerce.permeal_price).trim();
        }
      }
    } catch (eCommerce) {}
  }
  return out;
}

/**
 * Meal commerce ids from an open cart drawer row (`data-dog-id` / `data-variant-id`).
 * @param {string} dogId - `properties._dog_id` value
 * @returns {{ variantId: string, sellingPlanId: string, permeal_price: string } | null}
 */
function artieCartMealCommerceFromDomByDogId(dogId) {
  var want = String(dogId || '').trim();
  if (!want) return null;
  var rows = document.querySelectorAll('cart-items-component tr.cart-items__table-row[data-dog-id]');
  var i;
  for (i = 0; i < rows.length; i++) {
    var row = rows[i];
    if (!row || String(row.getAttribute('data-dog-id') || '').trim() !== want) continue;
    var variantId = String(row.getAttribute('data-variant-id') || '').trim();
    if (!variantId) return null;
    return {
      variantId: variantId,
      sellingPlanId: '',
      permeal_price: ''
    };
  }
  return null;
}

/**
 * @param {any} ctx
 * @param {Record<string, any>|null} planData
 * @param {boolean} isActive
 * @returns {Record<string, string>}
 */
function buildMultipleDogAtcEntry(ctx, planData, isActive) {
  var dogId = artieCustomerDogIdFromPackRowId(ctx.id);
  var store = readArtiePetsStore();
  var pet = petFromStoreForPackId(store, ctx.id);
  var dogName = ctx.name || (pet && pet.name ? String(pet.name).trim() : '');
  var recipeLine = isActive ? artieRecipeLineForMealPlanMapping() : artieRecipeLineForPackContext(ctx);
  // Dogs that were never the active pack row have no stored per-dog recipe, which
  // left variantId empty and silently dropped them from multi-dog add-to-cart.
  // Fall back to the recipe currently selected on the PDP; an explicit per-dog
  // recipe from the pets store still wins.
  if (!recipeLine) recipeLine = artieRecipeLineForMealPlanMapping();
  var res = resolveMealPlanForPackContext(ctx, { useLiveState: !!isActive });

  /** @type {Record<string, string>} */
  var entry = {
    dogId: dogId,
    dogName: dogName,
    selectedRecipe: recipeLine || '',
    portionSize: '',
    calorie: '',
    mealPlan: '',
    variantId: '',
    sellingPlanId: ''
  };

  if (!res) return entry;

  entry.portionSize = artiePortionLabelFromTier(res.tier);
  entry.calorie = res.calories != null ? String(res.calories) : '';
  entry.mealPlan = res.mealPlanId || '';

  var ids = planData ? artieLookup15DayMealPlanCommerceIds(planData, res.tier, res.mealPlanId, recipeLine) : null;
  if (isActive) {
    try {
      var getter = /** @type {any} */ (window).getArtieMealPlanCommerceIds;
      if (typeof getter === 'function') {
        var commerce = getter();
        if (commerce && commerce.variant_id != null && commerce.variant_id !== '') {
          ids = {
            variant_id: commerce.variant_id,
            selling_plan_id: commerce.selling_plan_id != null ? commerce.selling_plan_id : ''
          };
        }
      }
    } catch (eCommerce) {}
  }

  if (ids && ids.variant_id != null && ids.variant_id !== '') {
    entry.variantId = String(ids.variant_id);
    entry.sellingPlanId =
      ids.selling_plan_id != null && ids.selling_plan_id !== '' ? String(ids.selling_plan_id) : '';
  }

  if (!entry.variantId && dogId) {
    var fromCartDom = artieCartMealCommerceFromDomByDogId(dogId);
    if (fromCartDom && fromCartDom.variantId) {
      entry.variantId = fromCartDom.variantId;
      if (fromCartDom.sellingPlanId) entry.sellingPlanId = fromCartDom.sellingPlanId;
    }
  }

  return entry;
}

/**
 * Rebuild `multiple-dog-atc` from `artie-dogs`, per-dog quiz data, and live PDP state for the active dog.
 * @returns {Promise<void>}
 */
function syncMultipleDogAtcStore() {
  var dogs = [];
  try {
    var raw = localStorage.getItem('artie-dogs');
    if (raw) dogs = JSON.parse(raw);
  } catch (eDogs) {}
  if (!Array.isArray(dogs) || !dogs.length) {
    writeMultipleDogAtcStore([]);
    return Promise.resolve();
  }

  var activeCtx = getActivePackDogContext();
  var activeId = activeCtx && activeCtx.id != null ? String(activeCtx.id) : '';

  return getArtie15DayMealPlansJsonData()
    .then(function(planData) {
      var rows = [];
      var i;
      for (i = 0; i < dogs.length; i++) {
        var d = dogs[i];
        if (!d || d.id == null) continue;
        var ctx = {
          id: d.id,
          name: String(d.name == null ? '' : d.name).trim(),
          weight: d.weight != null && d.weight !== '' ? Number(d.weight) : null,
          dogKey: dogKeyFromNameAndId(d.name, d.id)
        };
        var isActive = !!(activeId && String(d.id) === activeId);
        rows.push(buildMultipleDogAtcEntry(ctx, planData, isActive));
      }
      writeMultipleDogAtcStore(rows);
    })
    .catch(function() {
      var fallbackRows = [];
      var j;
      for (j = 0; j < dogs.length; j++) {
        var dogRow = dogs[j];
        if (!dogRow || dogRow.id == null) continue;
        var ctxFb = {
          id: dogRow.id,
          name: String(dogRow.name == null ? '' : dogRow.name).trim(),
          weight: dogRow.weight != null && dogRow.weight !== '' ? Number(dogRow.weight) : null,
          dogKey: dogKeyFromNameAndId(dogRow.name, dogRow.id)
        };
        var isActiveFb = !!(activeId && String(dogRow.id) === activeId);
        fallbackRows.push(buildMultipleDogAtcEntry(ctxFb, null, isActiveFb));
      }
      writeMultipleDogAtcStore(fallbackRows);
    });
}

function scheduleSyncMultipleDogAtcStore() {
  if (artieMultipleDogAtcSyncTimer != null) clearTimeout(artieMultipleDogAtcSyncTimer);
  artieMultipleDogAtcSyncTimer = setTimeout(function() {
    artieMultipleDogAtcSyncTimer = null;
    syncMultipleDogAtcStore();
  }, ARTIE_MULTIPLE_DOG_ATC_SYNC_DEBOUNCE_MS);
}

function syncMultipleDogAtcStoreNow() {
  if (artieMultipleDogAtcSyncTimer != null) {
    clearTimeout(artieMultipleDogAtcSyncTimer);
    artieMultipleDogAtcSyncTimer = null;
  }
  return syncMultipleDogAtcStore();
}

/**
 * @param {string} dogId
 */
function removeMultipleDogAtcEntryByDogId(dogId) {
  var want = String(dogId || '').trim();
  if (!want) return;
  var rows = readMultipleDogAtcStore().filter(function(row) {
    return row && String(row.dogId || '') !== want;
  });
  writeMultipleDogAtcStore(rows);
}

/** @type {Record<string, Promise<Record<string, any>> | Record<string, any>>} */
var artieMealPlanJsonCache = {};

function artieResolveThemeAssetUrl(filename) {
  var scripts = document.getElementsByTagName('script');
  var i;
  for (i = 0; i < scripts.length; i++) {
    var src = scripts[i].src || '';
    if (src.indexOf('artie-calc.js') !== -1) {
      return src.replace(/artie-calc\.js([?#].*)?$/i, filename + '$1');
    }
  }
  return filename;
}

/**
 * @param {string} fileName
 * @returns {Promise<Record<string, any>>}
 */
function getArtieMealPlanJsonData(fileName) {
  var c = artieMealPlanJsonCache[fileName];
  if (c && typeof c.then !== 'function') return Promise.resolve(c);
  if (c) return c;
  var p = fetch(artieResolveThemeAssetUrl(fileName))
    .then(function(r) {
      if (!r.ok) throw new Error('meal plan json ' + r.status);
      return r.json();
    })
    .then(function(data) {
      artieMealPlanJsonCache[fileName] = data;
      return data;
    });
  artieMealPlanJsonCache[fileName] = p;
  return p;
}

/**
 * Weight (lb) from pack-builder / pets store strip context (`resolvePersonalizedStripContext`).
 * @returns {number|null}
 */
function artieResolveDogWeightLbForCommerce() {
  var sc = resolvePersonalizedStripContext();
  if (sc.weight != null && !isNaN(Number(sc.weight)) && Number(sc.weight) > 0) return Number(sc.weight);
  return null;
}

function artieRecipeLineForMealPlanMapping() {
  var fromLivePicker = artieRecipeLineFromLiveVariantPicker(null);
  if (fromLivePicker) return fromLivePicker;
  var v = getCurrentMainVariantSnapshot();
  var fromVar = artieRecipeOnlyFromVariant(v);
  if (fromVar) return fromVar;
  try {
    var ls = localStorage.getItem(ARTIE_CURRENT_RECIPE_KEY);
    if (ls && String(ls).trim()) return String(ls).trim();
  } catch (eLs) {}
  var ctx = getActivePackDogContext();
  if (ctx && ctx.id != null) return artieRecipeLineForPackContext(ctx);
  return '';
}

/**
 * Recipe display line for a pack dog from `artie_pets_store` (not the live PDP picker).
 * @param {any} ctx - from `getActivePackDogContext()` shape
 * @returns {string}
 */
function artieRecipeLineForPackContext(ctx) {
  if (!ctx || ctx.id == null) return '';
  try {
    var store = readArtiePetsStore();
    var pet = petFromStoreForPackId(store, ctx.id);
    if (pet && pet.attributes && pet.attributes.current_recipe) {
      return String(pet.attributes.current_recipe).trim();
    }
  } catch (e) {}
  return '';
}

/**
 * Maps recipe display line to JSON variant suffix: `chicken` | `chicken_xp` | `beef` | `pork`.
 * Uses the selected product copy (e.g. Power / digest-friendly), not quiz `sensitive`, so PDP
 * prices and variant ids match the variant the shopper actually chose.
 * @param {string} recipeLine
 */
function artieMealPlanRecipeSuffixForJson(recipeLine) {
  var s = String(recipeLine || '').toLowerCase();
  if (/\bpork\b/.test(s)) return 'pork';
  if (/\bbeef\b/.test(s)) return 'beef';
  if (/\bchicken\b/.test(s) || /\bturkey\b/.test(s)) {
    if (/\bpower\b/.test(s) || /\bxp\b/.test(s) || /\bextra\b/.test(s) || /\bdigest/i.test(s)) return 'chicken_xp';
    return 'chicken';
  }
  return 'chicken';
}

/**
 * @param {string} tier
 * @param {string} recipeSuffix
 */
function artieMealPlanVariantKeyForLookup(tier, recipeSuffix) {
  var pref;
  if (tier === 'full') pref = 'full-portions';
  else if (tier === 'half') pref = 'half-portions';
  else if (tier === 'topper') pref = 'topper';
  else return '';
  return pref + '_' + recipeSuffix;
}

/**
 * @param {string|null|undefined} value
 * @returns {string}
 */
function artieNormalizeMealPlanPriceText(value) {
  var s = String(value == null ? '' : value).trim();
  if (!s) return '';
  return s.charAt(0) === '$' ? s : '$' + s;
}

/**
 * @param {Record<string, any>} planData - root object from meal_plans JSON
 * @param {string} mealPlanId
 * @param {string} tier
 * @param {string} recipeLine
 * @returns {{ variant_id: number, selling_plan_id: number, variant_key: string } | null}
 */
function artieClearMealPlanCommerceDataset() {
  try {
    document.documentElement.removeAttribute('data-artie-meal-plan-variant-id');
    document.documentElement.removeAttribute('data-artie-meal-plan-selling-plan-id');
    document.documentElement.removeAttribute('data-artie-meal-plan-permeal-price');
    document.documentElement.removeAttribute('data-artie-meal-plan-compare-price');
  } catch (e) {}
  artieSetMealPlanCommerceWindowState(null, null, null, null);
}

/**
 * Expose resolved meal-plan / topper commerce to `product-form` and other scripts.
 * `window.getArtieMealPlanCommerceIds()` returns `{ variant_id, selling_plan_id, permeal_price, compare_price?, commerce_source?, … }`.
 * @param {number|string|null|undefined} variantId
 * @param {number|string|null|undefined} sellingPlanId
 * @param {string|null|undefined} perMealPrice
 * @param {{
 *   compare_price?: string|null,
 *   commerce_source?: string|null,
 *   meal_topper_bucket?: string|null,
 *   meal_topper_type?: string|null,
 *   weight_lb?: number|null
 * }|null} [extras]
 */
function artieSetMealPlanCommerceWindowState(variantId, sellingPlanId, perMealPrice, extras) {
  try {
    if (typeof window === 'undefined') return;
    var w = /** @type {any} */ (window);
    var parsedVariant = variantId != null && variantId !== '' ? Number(variantId) : null;
    var parsedSelling = sellingPlanId != null && sellingPlanId !== '' ? Number(sellingPlanId) : null;
    var normalizedPerMeal = artieNormalizeMealPlanPriceText(perMealPrice);
    var x = extras || {};
    var cmp =
      x.compare_price != null && String(x.compare_price).trim() !== ''
        ? artieNormalizeMealPlanPriceText(x.compare_price)
        : '';
    if (variantId != null || sellingPlanId != null || normalizedPerMeal || cmp || x.commerce_source === 'meal_topper') {
      w.__artieMealPlanCommerceIds = {
        variant_id: parsedVariant != null && !isNaN(parsedVariant) ? parsedVariant : null,
        selling_plan_id: parsedSelling != null && !isNaN(parsedSelling) ? parsedSelling : null,
        permeal_price: normalizedPerMeal || null,
        compare_price: cmp || null,
        commerce_source: x.commerce_source != null ? String(x.commerce_source) : null,
        meal_topper_bucket: x.meal_topper_bucket != null ? String(x.meal_topper_bucket) : null,
        meal_topper_type: x.meal_topper_type != null ? String(x.meal_topper_type) : null,
        weight_lb: x.weight_lb != null && !isNaN(Number(x.weight_lb)) ? Number(x.weight_lb) : null
      };
    } else {
      w.__artieMealPlanCommerceIds = {
        variant_id: null,
        selling_plan_id: null,
        permeal_price: null,
        compare_price: null,
        commerce_source: null,
        meal_topper_bucket: null,
        meal_topper_type: null,
        weight_lb: null
      };
    }
    w.getArtieMealPlanCommerceIds = function() {
      var state = w.__artieMealPlanCommerceIds || {};
      var v = state.variant_id != null ? Number(state.variant_id) : null;
      var s = state.selling_plan_id != null ? Number(state.selling_plan_id) : null;
      return {
        variant_id: v != null && !isNaN(v) ? v : null,
        selling_plan_id: s != null && !isNaN(s) ? s : null,
        permeal_price: state.permeal_price != null ? String(state.permeal_price) : null,
        compare_price: state.compare_price != null ? String(state.compare_price) : null,
        commerce_source: state.commerce_source != null ? String(state.commerce_source) : null,
        meal_topper_bucket: state.meal_topper_bucket != null ? String(state.meal_topper_bucket) : null,
        meal_topper_type: state.meal_topper_type != null ? String(state.meal_topper_type) : null,
        weight_lb: state.weight_lb != null && !isNaN(Number(state.weight_lb)) ? Number(state.weight_lb) : null
      };
    };
  } catch (eWin) {}
}
artieSetMealPlanCommerceWindowState(null, null, null, null);

try {
  if (typeof window !== 'undefined') {
    /** @type {any} */ (window).computePlan = computePlan;
    /** @type {any} */ (window).getMealPlanRecommendation = getMealPlanRecommendation;
    /** @type {any} */ (window).artieLookupMealPlanRoutingRow = artieLookupMealPlanRoutingRow;
    /** @type {any} */ (window).getArtieMultipleDogAtc = readMultipleDogAtcStore;
    /** @type {any} */ (window).syncArtieMultipleDogAtcNow = syncMultipleDogAtcStoreNow;
    /** @type {any} */ (window).syncArtieMultipleDogAtcAsync = syncMultipleDogAtcStore;
    /** @type {any} */ (window).getArtieCartLinePricePropertiesForPackEntry = artieCartLinePricePropertiesFromPackEntry;
  }
} catch (eExport) {}

/**
 * @param {Element|null} el
 * @param {boolean} isLoading
 */
function artieSetMealPlanPriceElementLoading(el, isLoading) {
  if (!(el instanceof HTMLElement)) return;
  if (isLoading) {
    el.dataset.artieMealPlanPriceLoading = 'true';
    el.textContent = '';
    el.style.visibility = '';
  } else {
    delete el.dataset.artieMealPlanPriceLoading;
    el.style.visibility = '';
    el.removeAttribute('hidden');
  }
}

/**
 * @param {boolean} isVisible
 */
function artieSetMealPlanPriceSuffixesVisible(isVisible) {
  document.querySelectorAll('[data-artie-meal-plan-price-suffix]').forEach(function(el) {
    if (!(el instanceof HTMLElement)) return;
    if (isVisible) {
      el.removeAttribute('hidden');
    } else {
      el.setAttribute('hidden', 'hidden');
    }
  });
}

/**
 * @param {boolean} isLoading
 */
function artieSetMealPlanPriceTargetsLoading(isLoading) {
  if (isLoading) artieSetMealPlanPriceSuffixesVisible(false);
  document
    .querySelectorAll('[data-artie-meal-plan-price-target], [data-artie-portion-price-subtitle]')
    .forEach(function(el) {
      artieSetMealPlanPriceElementLoading(el, isLoading);
    });
}

/**
 * @param {Element|null} container
 * @param {string} priceText
 */
function artieUpdatePriceContainerText(container, priceText) {
  if (!container || !priceText) return;
  var sale = container.querySelector('.price__sale:not(.price__hidden) .price-item--sale.price');
  var regular = container.querySelector('.price__regular:not(.price__hidden) .price');
  var fallback = container.querySelector('.price');
  var target = sale || regular || fallback;
  if (target) {
    target.textContent = priceText;
    artieSetMealPlanPriceElementLoading(target, false);
  }
}


/**
 * Intro-offer pricing config (theme settings via window.artieIntroOffer).
 * Returns null when the offer display is off, misconfigured, or past its
 * optional auto-hide date. The theme cannot read automatic discounts, so
 * this is advertised math: percent must be kept in sync with the discount.
 * @returns {{ percent: number, label: string } | null}
 */
function artieIntroOfferInfo() {
  var cfg = /** @type {{ enabled?: boolean, percent?: number, label?: string, endDate?: string }} */ (
    /** @type {any} */ (window).artieIntroOffer
  );
  if (!cfg || !cfg.enabled) return null;
  var percent = Number(cfg.percent);
  if (!isFinite(percent) || percent <= 0 || percent >= 100) return null;
  var end = cfg.endDate != null ? String(cfg.endDate).trim() : '';
  if (end) {
    // YYYY-MM-DD compared against the shopper's local date; hides from the
    // day AFTER the end date.
    var m = end.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) {
      var now = new Date();
      var today =
        now.getFullYear() * 10000 + (now.getMonth() + 1) * 100 + now.getDate();
      var endNum = Number(m[1]) * 10000 + Number(m[2]) * 100 + Number(m[3]);
      if (today > endNum) return null;
    }
  }
  return { percent: percent, label: cfg.label != null ? String(cfg.label) : '' };
}

/**
 * "$3.50" -> "$2.45" at the configured intro-offer percent (null when off).
 * @param {string|null|undefined} priceText
 * @returns {string|null}
 */
function artieIntroOfferDiscountedText(priceText) {
  var offer = artieIntroOfferInfo();
  if (!offer) return null;
  var raw = String(priceText == null ? '' : priceText);
  var m = raw.match(/([0-9][0-9.,]*)/);
  if (!m) return null;
  var value = parseFloat(m[1].replace(/,/g, ''));
  if (!isFinite(value) || value <= 0) return null;
  var discounted = value * (1 - offer.percent / 100);
  var prefix = raw.slice(0, m.index) || '$';
  return prefix + discounted.toFixed(2);
}

/**
 * PDP: keep an offer line ("$2.45/meal with first-order offer") under the
 * per-meal price block; removed when the offer is off.
 * @param {string} priceText
 */
function artieUpdatePdpIntroOfferLines(priceText) {
  var discounted = artieIntroOfferDiscountedText(priceText);
  var offer = artieIntroOfferInfo();
  document.querySelectorAll('.artie-price-per-meal .price-per-meal__container').forEach(function(container) {
    var line = container.querySelector('.price-per-meal__offer');
    if (!discounted || !offer) {
      if (line) line.remove();
      return;
    }
    if (!line) {
      line = document.createElement('div');
      line.className = 'price-per-meal__offer';
      var amount = container.querySelector('.price-per-meal__amount');
      if (amount && amount.parentNode === container) {
        amount.insertAdjacentElement('afterend', line);
      } else {
        container.appendChild(line);
      }
    }
    line.textContent = discounted + '/meal ' + (offer.label || '');
  });
}

/**
 * Cart drawer: annotate every "$X.XX/meal" line with the intro-offer price.
 * Safe to call repeatedly (used after every drawer morph).
 */
function artieAnnotateCartPerMealOffers() {
  var offer = artieIntroOfferInfo();
  document.querySelectorAll('.cart-item-price-per').forEach(function(el) {
    var next = el.nextElementSibling;
    var hasNote = next && next.classList && next.classList.contains('cart-item-price-per-offer');
    if (!offer) {
      if (hasNote) next.remove();
      return;
    }
    var discounted = artieIntroOfferDiscountedText(el.textContent);
    if (!discounted) {
      if (hasNote) next.remove();
      return;
    }
    var note = hasNote ? next : document.createElement('span');
    if (!hasNote) {
      note.className = 'cart-item-price-per-offer';
      el.insertAdjacentElement('afterend', note);
    }
    var text = (discounted + '/meal ' + (offer.label || '')).trim();
    if (note.textContent !== text) note.textContent = text;
  });
}
/**
 * The drawer re-renders its contents on open and on every cart morph, which
 * wipes injected notes - watch it and re-annotate after any change settles.
 */
function artieBindCartPerMealOfferObserver() {
  var scheduled = false;
  var obs = new MutationObserver(function(muts) {
    var relevant = false;
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (!(t instanceof Element) || !t.classList.contains('cart-item-price-per-offer')) {
        relevant = true;
        break;
      }
    }
    if (!relevant || scheduled) return;
    scheduled = true;
    setTimeout(function() {
      scheduled = false;
      artieAnnotateCartPerMealOffers();
    }, 120);
  });
  var roots = document.querySelectorAll('cart-drawer, .cart-drawer__dialog, cart-items-component');
  if (roots.length) {
    roots.forEach(function(r) { obs.observe(r, { childList: true, subtree: true }); });
  } else {
    obs.observe(document.body, { childList: true, subtree: true });
  }
}
try {
  /** @type {any} */ (window).artieAnnotateCartPerMealOffers = artieAnnotateCartPerMealOffers;
  var artieOfferBoot = function() {
    artieAnnotateCartPerMealOffers();
    artieBindCartPerMealOfferObserver();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', artieOfferBoot);
  } else {
    artieOfferBoot();
  }
} catch (eOfferBoot) {}

/**
 * @param {string|null|undefined} priceText
 */
function artieApplyMealPlanPriceToPlacements(priceText) {
  var price = artieNormalizeMealPlanPriceText(priceText);
  if (!price) return;
  try {
    document.documentElement.dataset.artieMealPlanPermealPrice = price;
  } catch (eDs) {}

  document.querySelectorAll('.artie-price-per-meal .price-per-meal__value, .js-price').forEach(function(el) {
    el.textContent = price;
    artieSetMealPlanPriceElementLoading(el, false);
  });
  artieSetMealPlanPriceSuffixesVisible(true);

  document
    .querySelectorAll(
      'main product-price[data-product-id]:not(.artie-price-per-meal):not([data-artie-static-price]) [ref="priceContainer"], .sticky-add-to-cart__price'
    )
    .forEach(function(container) {
      artieUpdatePriceContainerText(container, price);
    });
  artieUpdatePdpIntroOfferLines(price);

  try {
    document.documentElement.dataset.artieMealPlanPriceReady = 'true';
  } catch (eReady) {}
}

function artieReapplyCurrentMealPlanPriceToPlacements() {
  var price = '';
  try {
    price = document.documentElement.dataset.artieMealPlanPermealPrice || '';
  } catch (eDs) {}
  if (!price) {
    try {
      var getter = /** @type {any} */ (window).getArtieMealPlanCommerceIds;
      if (typeof getter === 'function') {
        var state = getter();
        price = state && state.permeal_price ? String(state.permeal_price) : '';
      }
    } catch (eWin) {}
  }
  if (price) artieApplyMealPlanPriceToPlacements(price);
}

/**
 * @param {Record<string, any>|null} row
 * @param {string} tier
 * @returns {{ mealPlanId: string, bucketMealPlanId: string, lookupMealPlanId: string, lookupJsonTier: string } | null}
 */
function artieMealPlanPriceContextForTier(row, tier) {
  if (!row || !tier) return null;
  var weightLb = artieResolveDogWeightLbForCommerce();
  var mealPlanId = normalizeMainMealPlanId(row[tier + '_meal_plan']);
  if (!mealPlanId && weightLb != null) {
    var routingRow = artieLookupMealPlanRoutingRow(artieMealPlanRoutingTableForTier(tier), weightLb);
    if (routingRow && routingRow.mp != null) mealPlanId = 'MealPlan' + routingRow.mp;
  }
  if (!mealPlanId) return null;
  return { mealPlanId: mealPlanId, tier: tier };
}

/**
 * Portion option subtitles use Shopify variant prices as a no-JS fallback, but the live PDP
 * should only reveal them after `price_per_meal` from the selected dog's meal plan is ready.
 * @param {Record<string, any>|null} row
 * @param {string} recipeLine
 * @param {number} commerceEpoch
 */
function artieHydratePortionOptionPriceSubtitles(row, recipeLine, commerceEpoch) {
  var picker = getMainVariantPicker();
  if (!picker || !(picker instanceof HTMLElement)) return;
  var labels = picker.querySelectorAll('label.variant-option__button-label');
  labels.forEach(function(label) {
    var subtitle = label.querySelector('[data-artie-portion-price-subtitle]');
    if (!(subtitle instanceof HTMLElement)) return;
    artieSetMealPlanPriceElementLoading(subtitle, true);
    var input = label.querySelector('input.js-variant-option-input');
    if (!(input instanceof HTMLInputElement)) {
      artieSetMealPlanPriceElementLoading(subtitle, false);
      return;
    }
    if (input.getAttribute('data-artie-portion-blocked') === 'true') {
      subtitle.textContent = 'Not Available';
      artieSetMealPlanPriceElementLoading(subtitle, false);
      return;
    }
    var tier = portionTierFromString(input.getAttribute('data-js-option-value') || input.value || '');
    var subtitleEl = /** @type {HTMLElement} */ (subtitle);

    var priceCtx = artieMealPlanPriceContextForTier(row, tier);
    if (!priceCtx) {
      artieSetMealPlanPriceElementLoading(subtitle, false);
      return;
    }
    var mpNum = mealPlanNumberFromId(priceCtx.mealPlanId);
    var boxPrice = artie15DayBoxPriceForPlanPart({ mp: mpNum }, recipeLine);
    subtitleEl.textContent = boxPrice != null ? artiePerMealPriceFrom15DayBox(boxPrice) : '';
    artieSetMealPlanPriceElementLoading(subtitleEl, false);
  });
}

function artieRehydrateCurrentPortionOptionPriceSubtitles() {
  var activeCtx = getActivePackDogContext();
  var portionRow = activeCtx ? findRecommendedPortionRowForPackContext(activeCtx) : null;
  var recipeLine = artieRecipeLineForMealPlanMapping();
  artieHydratePortionOptionPriceSubtitles(portionRow, recipeLine, artieMealPlanCommerceEpoch);
}

/**
 * Load the correct meal plan JSON, resolve variant + selling plan, log, and expose on `<html>` + event.
 * @param {NonNullable<ReturnType<typeof resolveMealPlanForActiveShoppingContext>>} res
 * @param {number} commerceEpoch - must match `artieMealPlanCommerceEpoch` when async work finishes
 */
function artieApplyMealPlanCommerceResolution(res, commerceEpoch) {
  var recipeLine = artieRecipeLineForMealPlanMapping();
  var activeCtx = getActivePackDogContext();
  var portionRow = activeCtx ? findRecommendedPortionRowForPackContext(activeCtx) : null;
  artieSetMealPlanPriceTargetsLoading(true);
  artieHydratePortionOptionPriceSubtitles(portionRow, recipeLine, commerceEpoch);

  getArtie15DayMealPlansJsonData()
    .then(function(data) {
      if (commerceEpoch !== artieMealPlanCommerceEpoch) return;
      var ids = artieLookup15DayMealPlanCommerceIds(data, res.tier, res.mealPlanId, recipeLine);
      var perMealPrice = res.boxPrice != null ? artiePerMealPriceFrom15DayBox(res.boxPrice) : '';
      if (ids || perMealPrice) {
        try {
          document.documentElement.removeAttribute('data-artie-meal-plan-compare-price');
          if (ids) {
            document.documentElement.dataset.artieMealPlanVariantId = String(ids.variant_id);
            document.documentElement.dataset.artieMealPlanSellingPlanId = String(ids.selling_plan_id);
          } else {
            document.documentElement.removeAttribute('data-artie-meal-plan-variant-id');
            document.documentElement.removeAttribute('data-artie-meal-plan-selling-plan-id');
          }
        } catch (eDs) {}
        artieSetMealPlanCommerceWindowState(ids ? ids.variant_id : null, ids ? ids.selling_plan_id : null, perMealPrice || null, {
          commerce_source: '15_day_meal_plans',
          meal_topper_bucket: null,
          meal_topper_type: null,
          weight_lb: res.weightLb != null ? res.weightLb : null,
          compare_price: null
        });
        if (perMealPrice) artieApplyMealPlanPriceToPlacements(perMealPrice);
        try {
          document.dispatchEvent(
            new CustomEvent('artie:meal-plan-commerce-ids', {
              bubbles: true,
              detail: {
                mealPlanId: res.mealPlanId,
                tier: res.tier,
                commerce_source: '15_day_meal_plans',
                compare_price: null,
                variant_name: ids ? ids.variant_name : null,
                variant_id: ids ? ids.variant_id : null,
                selling_plan_id: ids ? ids.selling_plan_id : null,
                permeal_price: perMealPrice || null,
                json_file: ARTIE_15_DAY_MEAL_PLANS_JSON_FILE,
                weight_lb: res.weightLb
              }
            })
          );
        } catch (eEv) {}
      } else {
        artieClearMealPlanCommerceDataset();
        artieSetMealPlanPriceTargetsLoading(false);
      }
      artieSetMealPlanPriceTargetsLoading(false);
      scheduleArtiePortionVariantAvailabilitySync();
      artieSyncPdpAddToCartDisabledForPortions();
      scheduleSyncMultipleDogAtcStore();
    })
    .catch(function() {
      if (commerceEpoch !== artieMealPlanCommerceEpoch) return;
      artieClearMealPlanCommerceDataset();
      artieSetMealPlanPriceTargetsLoading(false);
      scheduleArtiePortionVariantAvailabilitySync();
      artieSyncPdpAddToCartDisabledForPortions();
      scheduleSyncMultipleDogAtcStore();
    });
}

/** @type {ReturnType<typeof setTimeout> | null} */
var artieMealPlanSyncTimer = null;
/** Bumped on every `syncArtieMealPlanContext` so stale JSON fetches cannot log or write dataset after a newer sync. */
var artieMealPlanCommerceEpoch = 0;

/**
 * Debounced: switching the active dog schedules a sync, then `syncVariantPickerFromQuizStore` often fires
 * `variant:update` a moment later — without delay both run and `[Artie]` logs appear twice. Collapse bursts
 * into one trailing run (same pattern as rapid `writeArtiePetsStore` + `variant:update`).
 */
var ARTIE_MEAL_PLAN_SYNC_DEBOUNCE_MS = 55;

function scheduleArtieMealPlanContext() {
  if (artieMealPlanSyncTimer != null) {
    clearTimeout(artieMealPlanSyncTimer);
  }
  artieMealPlanSyncTimer = setTimeout(function() {
    artieMealPlanSyncTimer = null;
    syncArtieMealPlanContext();
  }, ARTIE_MEAL_PLAN_SYNC_DEBOUNCE_MS);
}

function syncArtieMealPlanContextNow() {
  if (artieMealPlanSyncTimer != null) {
    clearTimeout(artieMealPlanSyncTimer);
    artieMealPlanSyncTimer = null;
  }
  syncArtieMealPlanContext();
}

function syncArtieMealPlanContext() {
  artieMealPlanCommerceEpoch++;
  var commerceEpoch = artieMealPlanCommerceEpoch;
  var res = resolveMealPlanForActiveShoppingContext();
  if (res) {
    artieApplyMealPlanCommerceResolution(res, commerceEpoch);
  } else {
    artieClearMealPlanCommerceDataset();
    artieSetMealPlanPriceTargetsLoading(false);
  }
  try {
    if (res) {
      document.documentElement.dataset.artieMealPlan = res.mealPlanId;
      document.documentElement.dataset.artieMealPlanTier = res.tier;
    } else {
      document.documentElement.removeAttribute('data-artie-meal-plan');
      document.documentElement.removeAttribute('data-artie-meal-plan-tier');
    }
  } catch (eData) {}
  try {
    document.dispatchEvent(
      new CustomEvent('artie:meal-plan-resolved', {
        bubbles: true,
        detail: res || null
      })
    );
  } catch (eEv) {}
  artieSyncPdpAddToCartDisabledForPortions();
}

// ── Calculator plan helpers (uses weight routing above) ──

/**
 * @param {{ min: number, max: number, mp: number|null, cal?: number } | null} row
 * @param {boolean} [sensitive]
 * @returns {{ mp: number, cal: number, bk: number, dn: number, capped: boolean } | null}
 */
function artieTierPlanFromRoutingRow(row, sensitive) {
  if (!row || row.mp === null || row.cal == null) return null;
  var cal = row.cal;
  var bk;
  var dn;
  if (cal % 2 === 0) {
    bk = cal / 2;
    dn = cal / 2;
  } else {
    var lo = Math.floor(cal / 2);
    var hi = lo + (cal - lo);
    if (sensitive) {
      bk = lo;
      dn = hi;
    } else {
      bk = hi;
      dn = lo;
    }
  }
  return { mp: row.mp, cal: cal, bk: bk, dn: dn, capped: false };
}

/**
 * @param {number} weightLb
 * @returns {string}
 */
function artieWeightBoundaryMessage(weightLb) {
  var wt = Math.round(Number(weightLb));
  if (isNaN(wt)) return '';
  if (wt < 4) {
    return "Sorry, we don't have plans for dogs under 4 lb yet. (The smallest plan, MP3 at 162 cal/day, would overfeed a dog this small by more than 15%.)";
  }
  if (wt > 200) {
    return 'Above 200 lb is outside the matrix. Cap at 200 lb behavior, or confirm separately what should happen for giant breeds.';
  }
  return '';
}

/**
 * @param {string} recipeLine
 * @returns {'chicken_hb'|'beef_hb'|'chicken_xp'}
 */
function getMealPlanRecommendation(weightLb, recipeKey) {
  var wt = Math.round(Number(weightLb));
  var kg = wt * 0.453592;
  var rer = Math.round(70 * Math.pow(kg, 0.75));
  var der = Math.round(rer * ARTIE_MEAL_PLAN_DER_FACTOR);
  var recipe = recipeKey || 'chicken_hb';

  function withPrice(row) {
    if (!row || row.mp === null) return null;
    var priceRow = ARTIE_PRICES_15DAY[row.mp];
    var price = priceRow ? priceRow[recipe] : null;
    return { mp: row.mp, cal: row.cal, price: price == null ? null : price };
  }

  return {
    rer: rer,
    der: der,
    full: withPrice(artieLookupMealPlanRoutingRow(ARTIE_FULL_ROUTING_TABLE, wt)),
    half: withPrice(artieLookupMealPlanRoutingRow(ARTIE_HALF_ROUTING_TABLE, wt)),
    topper: withPrice(artieLookupMealPlanRoutingRow(ARTIE_TOPPER_ROUTING_TABLE, wt))
  };
}

/**
 * Weight-routed meal plans + RER/DER (neutered normal adult × 1.290).
 * Plan calories come from routing tables, not DER.
 * @param {any} dog
 */
function computePlan(dog) {
  if (!dog || !dog.weight || dog.weight <= 0) return null;
  var wtCheck = Math.round(Number(dog.weight));
  var weightBoundary = artieWeightBoundaryMessage(wtCheck);
  if (weightBoundary) {
    return {
      blocked: 'weight',
      boundaryMessage: weightBoundary,
      rer: 0,
      der: 0,
      totalCal: 0,
      mealCal: 0,
      treatCal: 0,
      full: null,
      half: null,
      topper: null,
      recommended: null
    };
  }
  if (dog.age != null && dog.age < 1) {
    return {
      blocked: 'puppy',
      rer: 0,
      der: 0,
      totalCal: 0,
      mealCal: 0,
      treatCal: 0,
      full: null,
      half: null,
      topper: null,
      recommended: null
    };
  }

  var wt = Math.round(Number(dog.weight));
  var kg = wt * 0.453592;
  var rer = Math.round(70 * Math.pow(kg, 0.75));
  var der = Math.round(rer * ARTIE_MEAL_PLAN_DER_FACTOR);
  var sensYes = String(dog.sensitive || 'no').toLowerCase() === 'yes';

  var fullRow = artieLookupMealPlanRoutingRow(ARTIE_FULL_ROUTING_TABLE, wt);
  var halfRow = artieLookupMealPlanRoutingRow(ARTIE_HALF_ROUTING_TABLE, wt);
  var topperRow = artieLookupMealPlanRoutingRow(ARTIE_TOPPER_ROUTING_TABLE, wt);

  var full = artieTierPlanFromRoutingRow(fullRow, sensYes);
  var half = artieTierPlanFromRoutingRow(halfRow, sensYes);
  var topper = artieTierPlanFromRoutingRow(topperRow, sensYes);

  var recTierCal = full ? full.cal : half ? half.cal : topper ? topper.cal : null;

  return {
    rer: rer,
    der: der,
    totalCal: rer,
    mealCal: der,
    treatCal: recTierCal,
    halfCal: half ? half.cal : null,
    full: full,
    half: half,
    topper: topper,
    recommended: full ? 'Full' : half ? 'Half' : topper ? 'Topper' : null,
    boundaryMessage: artieWeightBoundaryMessage(wt)
  };
}

function recommendPortion(dog) {
  var p = computePlan(dog);
  if (!p || !p.recommended) return null;
  var tierKey = String(p.recommended).toLowerCase();
  var part = p[tierKey];
  var recipeLine = artieRecipeLineForMealPlanMapping();
  var boxPrice = artie15DayBoxPriceForPlanPart(part, recipeLine);
  var perMeal = boxPrice != null ? boxPrice / 30 : null;
  return { portion: p.recommended, price: perMeal, dailyKcal: p.der, plan: p };
}

function resetCalcPillsInForm(form, field, value) {
  if (!form || !form.querySelector) return;
  var group = form.querySelector('[data-calc-group="' + field + '"]');
  if (!group) return;
  group.querySelectorAll('.quiz-pill').forEach(function(p) {
    if (p.getAttribute('data-value') === value) p.classList.add('active');
    else p.classList.remove('active');
  });
}

function renderStandaloneCalculatorResults(sectionRoot, dog, reco) {
  if (!(sectionRoot instanceof HTMLElement)) return;
  var plan = reco && reco.plan ? reco.plan : computePlan(dog);
  var results = sectionRoot.querySelector('#calcResults');
  if (!results) return;
  if (!plan || plan.blocked === 'puppy' || plan.blocked === 'weight') return;

  var displayName = (dog && dog.name && String(dog.name).trim()) || 'Your dog';
  var titleEl = sectionRoot.querySelector('#resultsTitle');
  if (titleEl) titleEl.textContent = displayName + '\u2019s Daily Nutrition';

  var recommendedCalories = sectionRoot.querySelector('#recommendedCalories');
  if (recommendedCalories) {
    recommendedCalories.textContent = plan.treatCal != null ? String(plan.treatCal) : '\u2014';
  }

  var recommendedKey = plan.recommended ? String(plan.recommended).toLowerCase() : null;
  var cards = [
    { key: 'full', data: plan.full, title: 'Full Plan', desc: 'Complete daily nutrition' },
    {
      key: 'half',
      data: plan.half,
      title: 'Half Plan',
      desc: 'Paired with half a serving of their current food'
    },
    {
      key: 'topper',
      data: plan.topper,
      title: 'Topper Plan',
      desc: 'Paired with three quarters of a serving of their current food'
    }
  ];
  var grid = sectionRoot.querySelector('#plansGrid');
  if (grid) {
    grid.innerHTML = cards
      .map(function(c) {
        var isRec = recommendedKey && c.key === recommendedKey;
        var available = c.data !== null && c.data !== undefined;
        var body = available
          ? '<div class="calc-plan-calories">' +
            c.data.cal +
            ' cal/day</div>' +
            '<div class="calc-plan-split">Breakfast ' +
            c.data.bk +
            ' &middot; Dinner ' +
            c.data.dn +
            '</div>'
          : '<div class="calc-plan-unavailable">Not available at this weight</div>';
        return (
          '<div class="calc-plan-card' +
          (isRec ? ' recommended' : '') +
          '">' +
          (isRec ? '<div class="calc-plan-badge">Most Popular</div>' : '') +
          '<div class="calc-plan-title">' +
          c.title +
          '</div>' +
          '<div class="calc-plan-desc">' +
          c.desc +
          '</div>' +
          body +
          '</div>'
        );
      })
      .join('');
  }

  var boundaryEl = sectionRoot.querySelector('#calcBoundaryMsg');
  if (!boundaryEl && grid && grid.parentNode) {
    boundaryEl = document.createElement('p');
    boundaryEl.id = 'calcBoundaryMsg';
    boundaryEl.className = 'calc-boundary-msg';
    boundaryEl.hidden = true;
    grid.parentNode.insertBefore(boundaryEl, grid.nextSibling);
  }
  if (boundaryEl) {
    var bmsg = plan.boundaryMessage || '';
    if (bmsg) {
      boundaryEl.textContent = bmsg;
      boundaryEl.hidden = false;
    } else {
      boundaryEl.textContent = '';
      boundaryEl.hidden = true;
    }
  }

  var cta = sectionRoot.querySelector('#resultsCta');
  if (cta && (cta.tagName === 'A' || cta.tagName === 'BUTTON')) {
    cta.textContent = 'Start ' + displayName + '\u2019s Plan';
  }

  results.classList.add('active');
  setTimeout(function() {
    results.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, 100);
}

function resetStandaloneCalculatorSection(sectionRoot) {
  if (!(sectionRoot instanceof HTMLElement)) return;
  var form = sectionRoot.querySelector('#calcQuizForm');
  var nameEl = sectionRoot.querySelector('#dogName');
  if (nameEl) nameEl.value = '';
  var breedEl = sectionRoot.querySelector('#calcBreed');
  if (breedEl) breedEl.value = '';
  var ageEl = sectionRoot.querySelector('#calcAge');
  if (ageEl) {
    ageEl.value = '3';
    updateCalcAge(ageEl.value, ageEl);
  }
  var weightEl = sectionRoot.querySelector('#calcWeight');
  if (weightEl) {
    weightEl.value = '20';
    updateCalcWeight(weightEl.value, weightEl);
  }
  if (form) {
    resetCalcPillsInForm(form, 'gender', 'male');
    resetCalcPillsInForm(form, 'spayed', 'yes');
    resetCalcPillsInForm(form, 'treats', 'sometimes');
    resetCalcPillsInForm(form, 'activity', 'moderately_active');
    resetCalcPillsInForm(form, 'bcs', '3');
    resetCalcPillsInForm(form, 'sensitive', 'no');
    resetCalcPillsInForm(form, 'pickiness', 'not_picky');
  }
  var emailInput = sectionRoot.querySelector('#calcEmail');
  if (emailInput) {
    emailInput.value = '';
    emailInput.removeAttribute('aria-invalid');
  }
  var emailErr = sectionRoot.querySelector('#calcEmailError');
  if (emailErr) {
    emailErr.hidden = true;
    emailErr.textContent = '';
  }
  var nameErr = sectionRoot.querySelector('#dogNameError');
  if (nameErr) {
    nameErr.hidden = true;
    nameErr.textContent = '';
  }
  if (nameEl) nameEl.removeAttribute('aria-invalid');
  var weightErr = sectionRoot.querySelector('#calcWeightError');
  if (weightErr) {
    weightErr.hidden = true;
    weightErr.textContent = '';
  }
  if (weightEl) weightEl.removeAttribute('aria-invalid');
  var results = sectionRoot.querySelector('#calcResults');
  if (results) {
    results.classList.remove('active');
    var pg = sectionRoot.querySelector('#plansGrid');
    if (pg) pg.innerHTML = '';
  }
  var panel = sectionRoot.querySelector('#calcOverlay') || sectionRoot;
  panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

var artieStandaloneCalcRefreshBound = false;
function bindStandaloneCalculatorPageOnce() {
  if (artieStandaloneCalcRefreshBound) return;
  artieStandaloneCalcRefreshBound = true;
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-artie-calc-page-refresh]');
    if (!btn) return;
    var section = btn.closest('[data-artie-calculator-standalone]');
    if (!section) return;
    e.preventDefault();
    resetStandaloneCalculatorSection(section);
  });
}

/**
 * Variant-change title/description sync (moved from separate file).
 * Uses theme default `variant:update` events dispatched by variant-picker.
 */
function findPdpTitleTextNode(root) {
  if (!root) return null;
  var block = null;
  var a = root.querySelector('a.contents, a[href], a');
  if (a) block = a.querySelector('.text-block');
  if (!block) block = root.querySelector('.text-block');
  if (!block) return null;
  var isRteRoot = block.localName === 'rte-formatter';
  var rte = isRteRoot ? block : block.querySelector('rte-formatter');
  if (rte && rte.firstElementChild) return rte.firstElementChild;
  return block.querySelector('p, h1, h2, h3, h4, h5, h6') || block.firstElementChild || null;
}

function normalizeCustomRecipeTitle(rawTitle) {
  var t = String(rawTitle || '').trim();
  if (!t) return '';
  if (t.indexOf('/') !== -1) {
    var parts = t.split('/');
    t = String(parts[parts.length - 1] || '').trim();
  }
  var lower = t.toLowerCase();
  if (lower === 'full' || lower === 'half' || lower === 'topper') return '';
  return t;
}

function bindPdpVariantHeadingElement() {
  if (!window.customElements || customElements.get('pdp-variant-heading')) return;

  class PdpVariantHeading extends HTMLElement {
    connectedCallback() {
      this._onVariantUpdate = this._onVariantUpdate || this.handleVariantUpdate.bind(this);
      document.addEventListener('variant:update', this._onVariantUpdate);
    }
    disconnectedCallback() {
      if (this._onVariantUpdate) {
        document.removeEventListener('variant:update', this._onVariantUpdate);
      }
    }
    handleVariantUpdate(event) {
      if (!this.classList.contains('JS-custom-product-title')) return;

      var detail = event && event.detail ? event.detail : null;
      var data = detail && detail.data ? detail.data : null;
      var res = detail && detail.resource ? detail.resource : null;
      if (!data || !res || !res.title) return;
      if (String(data.productId || '') !== String(this.dataset.productId || '')) return;

      var nextTitle = normalizeCustomRecipeTitle(res.title);
      if (!nextTitle) nextTitle = String(res.title || '').trim();
      if (!nextTitle) return;

      var textNode = findPdpTitleTextNode(this);
      if (textNode) textNode.textContent = nextTitle;

      var link = this.querySelector('a[href]');
      if (link && typeof res.url === 'string' && res.url) link.setAttribute('href', res.url);
    }
  }

  customElements.define('pdp-variant-heading', PdpVariantHeading);
}

function syncVariantDescriptionBodiesFromEvent(event) {
  var detail = event && event.detail ? event.detail : null;
  var data = detail && detail.data ? detail.data : null;
  var res = detail && detail.resource ? detail.resource : null;
  var vid = res && res.id != null ? res.id : null;
  if (vid == null || !data) return;

  var pid = String(data.productId || '');
  if (!pid) return;
  syncVariantDescriptionBodiesByIds(pid, vid);
}

function syncVariantDescriptionBodiesByIds(pid, vid) {
  if (!pid || vid == null) return;

  var roots = document.querySelectorAll('.js-custom-product-description');

  roots.forEach(function(root) {
    if (!(root instanceof HTMLElement)) return;
    if (String(root.dataset.productId || '') !== pid) return;

    var blockId = root.dataset.blockId;
    if (!blockId) return;

    var scope = root.parentElement;
    var script = scope && scope.querySelector(
      'script[type="application/json"][data-pdp-variant-description-map="' + CSS.escape(blockId) + '"]'
    );
    var tmpl = scope && scope.querySelector(
      'template.js-pdp-desc-initial[data-block-id="' + CSS.escape(blockId) + '"]'
    );

    var map = {};
    if (script && script.textContent && script.textContent.trim()) {
      try {
        map = JSON.parse(script.textContent);
      } catch (e) {
        map = {};
      }
    }

    var html = map[String(vid)];
    if (html != null && String(html).trim() !== '') {
      root.innerHTML = String(html);
    } else if (tmpl && tmpl.content) {
      root.replaceChildren.apply(root, tmpl.content.cloneNode(true).childNodes);
    }
  });
}

function getVariantSelectionFromPickerEvent(event) {
  var target = event && event.target ? event.target : null;
  var picker = target && target.closest ? target.closest('variant-picker') : null;
  if (!picker) return null;

  var productId = String((picker.dataset && picker.dataset.productId) || '');
  if (!productId) return null;

  var variantId = null;

  var checked = picker.querySelector('input.js-variant-option-input[data-variant-id]:checked');
  if (checked && checked.dataset && checked.dataset.variantId) {
    variantId = checked.dataset.variantId;
  }

  if (!variantId) {
    var selected = picker.querySelector('select.js-variant-option-input option[data-variant-id]:checked');
    if (selected && selected.dataset && selected.dataset.variantId) {
      variantId = selected.dataset.variantId;
    }
  }

  if (!variantId) return null;

  var titleText = '';
  if (checked) {
    var label = checked.closest('label');
    var t = label && label.querySelector ? label.querySelector('.variant-option__button-title') : null;
    titleText = (t && t.textContent ? t.textContent : '').trim();
  } else if (selected) {
    titleText = (selected.textContent || '').trim();
  }

  return {
    productId: productId,
    variantId: variantId,
    titleText: titleText
  };
}

function syncVariantHeadingTextBySelection(selection) {
  if (!selection || !selection.productId) return;
  var nextTitle = normalizeCustomRecipeTitle(selection.titleText);
  if (!nextTitle) nextTitle = String(selection.titleText || '').trim();
  if (!nextTitle) return;

  var roots = document.querySelectorAll(
    'pdp-variant-heading.JS-custom-product-title[data-product-id="' + CSS.escape(selection.productId) + '"]'
  );
  roots.forEach(function(root) {
    var textNode = findPdpTitleTextNode(root);
    if (textNode) textNode.textContent = nextTitle;
  });
}

function onVariantSelectedForPdpCopy(event) {
  var selection = getVariantSelectionFromPickerEvent(event);
  if (!selection) return;
  syncVariantDescriptionBodiesByIds(String(selection.productId), selection.variantId);
  syncVariantHeadingTextBySelection(selection);
}

var artiePdpVariantCopyBound = false;
function bindArtiePdpVariantCopyOnce() {
  if (artiePdpVariantCopyBound) return;
  artiePdpVariantCopyBound = true;
  bindPdpVariantHeadingElement();
  document.addEventListener('variant:selected', onVariantSelectedForPdpCopy);
  document.addEventListener('variant:update', syncVariantDescriptionBodiesFromEvent);
}

/**
 * Klaviyo’s recommended pre-loader: creates `window.klaviyo` Proxy so `.track` / `.identify` exist immediately
 * and queue into `_klOnsite` until the async klaviyo.js finishes loading.
 * Without this, dynamically appending only `klaviyo.js` often leaves `klaviyo.track` undefined on `script.onload`.
 * @see https://developers.klaviyo.com/en/docs/introduction_to_the_klaviyo_object
 */
function ensureArtieKlaviyoOnsiteBootstrap() {
  var w = window;
  if (w.klaviyo && typeof w.klaviyo.track === 'function') return;
  if (w.klaviyo) return;
  var snippet =
    '!function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();';
  try {
    (0, eval)(snippet);
  } catch (e) {}
}

/**
 * @param {() => void} onReady
 */
function scheduleArtieKlaviyoTrackReady(onReady) {
  var attempts = 0;
  function tick() {
    var w = /** @type {Window & { klaviyo?: { track?: Function } }} */ (window);
    if (w.klaviyo && typeof w.klaviyo.track === 'function') {
      onReady();
      return;
    }
    if (++attempts >= 100) {
      onReady();
      return;
    }
    setTimeout(tick, 50);
  }
  tick();
}

/**
 * Loads Klaviyo onsite JS once (public key / company id) and runs `onload` when calls can be queued or sent.
 * @param {string} publicKey
 * @param {() => void} onload
 */
function loadArtieKlaviyoOnsiteScript(publicKey, onload) {
  if (!publicKey || typeof onload !== 'function') return;
  ensureArtieKlaviyoOnsiteBootstrap();

  var wK = /** @type {Window & { klaviyo?: { track?: Function; identify?: Function } }} */ (window);
  var sel = 'script[data-artie-klaviyo-loader="' + publicKey.replace(/"/g, '') + '"]';
  var existing = document.querySelector(sel);

  if (wK.klaviyo && typeof wK.klaviyo.track === 'function' && existing) {
    onload();
    return;
  }

  if (!existing) {
    var s = document.createElement('script');
    s.async = true;
    s.type = 'text/javascript';
    s.setAttribute('data-artie-klaviyo-loader', publicKey);
    s.src = 'https://static.klaviyo.com/onsite/js/' + encodeURIComponent(publicKey) + '/klaviyo.js';
    s.onerror = function() {};
    (document.head || document.documentElement).appendChild(s);
    if (wK.klaviyo && typeof wK.klaviyo.track === 'function') {
      onload();
    } else {
      scheduleArtieKlaviyoTrackReady(onload);
    }
    return;
  }

  if (wK.klaviyo && typeof wK.klaviyo.track === 'function') {
    onload();
  } else {
    scheduleArtieKlaviyoTrackReady(onload);
  }
}

/**
 * @returns {boolean}
 */
function isArtieProductPageContext() {
  return !!document.querySelector('variant-picker[data-template-product-match="true"]');
}

/**
 * Email used to identify/create the Klaviyo profile (form field, then logged-in customer).
 * @param {HTMLFormElement | null | undefined} form
 * @returns {string}
 */
function getArtieKlaviyoTrackEmail(form) {
  var emailEl = form ? form.querySelector('#calcEmail') : null;
  if (emailEl && 'value' in emailEl) {
    var fromField = String(/** @type {{ value: string }} */ (emailEl).value || '').trim();
    if (fromField) return fromField;
  }
  var custEmailEl = document.getElementById('artieCustomerEmail');
  if (custEmailEl && 'value' in custEmailEl && /** @type {{ value: string }} */ (custEmailEl).value) {
    return String(/** @type {{ value: string }} */ (custEmailEl).value).trim();
  }
  var attr = document.documentElement.getAttribute('data-artie-customer-email');
  if (attr) return String(attr).trim();
  return '';
}

var ARTIE_KLAVIYO_CLIENT_API_REVISION = '2026-04-15';

/**
 * Klaviyo list ID for email marketing consent (Create Client Subscription).
 * @param {HTMLElement | null | undefined} sectionRoot
 * @returns {string}
 */
function getArtieKlaviyoListId(sectionRoot) {
  var fromRoot = sectionRoot && sectionRoot.getAttribute('data-artie-klaviyo-list-id');
  if (fromRoot) return String(fromRoot).trim();
  return '';
}

/**
 * Subscribe profile to email marketing via Klaviyo Create Client Subscription API.
 * Requires a valid Klaviyo LIST id (6 chars) — segment ids are rejected with "List not found".
 * @param {string} publicKey
 * @param {string} listId
 * @param {string} email
 * @param {string} customSource
 * @param {() => void} onComplete
 */
function subscribeArtieKlaviyoEmailMarketing(publicKey, listId, email, customSource, onComplete) {
  var done = typeof onComplete === 'function' ? onComplete : function() {};
  if (!publicKey || !listId || !email) {
    if (!listId && email) {
      console.warn(
        '[Artie Klaviyo] Email subscribe skipped: set a Klaviyo LIST id (not segment) in the Calculator / Quiz Overlay block settings.'
      );
    }
    done();
    return;
  }

  /** @type {{ data: object }} */
  var payload = {
    data: {
      type: 'subscription',
      attributes: {
        custom_source: customSource || 'Artie Nutrition Calculator',
        profile: {
          data: {
            type: 'profile',
            attributes: {
              email: email,
              subscriptions: {
                email: {
                  marketing: {
                    consent: 'SUBSCRIBED'
                  }
                }
              }
            }
          }
        }
      },
      relationships: {
        list: {
          data: {
            type: 'list',
            id: listId
          }
        }
      }
    }
  };

  /** @param {Response} res @param {string} [bodyText] */
  function logSubscribeFailure(res, bodyText) {
    var detail = '';
    try {
      var parsed = bodyText ? JSON.parse(bodyText) : null;
      if (parsed && parsed.errors && parsed.errors[0]) {
        detail = parsed.errors[0].detail || parsed.errors[0].title || '';
      }
    } catch (errParse) {}
    console.warn(
      '[Artie Klaviyo] Email subscribe failed (' +
        res.status +
        '): ' +
        (detail || bodyText || 'unknown error') +
        '. List id "' +
        listId +
        '" must be a Klaviyo LIST (Audience → Lists → open list → Settings). Segment ids do not work.'
    );
  }

  try {
    fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(publicKey),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Revision: ARTIE_KLAVIYO_CLIENT_API_REVISION
        },
        body: JSON.stringify(payload)
      }
    )
      .then(function(res) {
        if (res.ok || res.status === 202) {
          done();
          return;
        }
        return res.text().then(function(bodyText) {
          logSubscribeFailure(res, bodyText);
          done();
        });
      })
      .catch(function(errFetch) {
        console.warn('[Artie Klaviyo] Email subscribe request failed:', errFetch);
        done();
      });
  } catch (errSubscribe) {
    console.warn('[Artie Klaviyo] Email subscribe error:', errSubscribe);
    done();
  }
}

/**
 * Send one custom Klaviyo metric after a successful calculator/quiz calculation (standalone page or PDP overlay).
 * @param {HTMLElement | null} sectionRoot
 * @param {HTMLFormElement} form
 * @param {Record<string, unknown>} dog
 * @param {{ portion?: string, price?: number, dailyKcal?: number, plan?: object } | null} reco
 * @param {object | null} plan
 */
function trackArtieStandaloneCalculatorKlaviyo(sectionRoot, form, dog, reco, plan) {
  var onProductPage = isArtieProductPageContext();
  var publicKey = sectionRoot && sectionRoot.getAttribute('data-artie-klaviyo-public-key');
  if (!publicKey) {
    return;
  }
  if (!plan) {
    return;
  }
  var pl = /** @type {{ totalCal?: number; mealCal?: number; treatCal?: number; halfCal?: number; full?: object; half?: object; topper?: object; recommended?: string | null }} */ (
    plan
  );

  var ageEl = form ? form.querySelector('#calcAge') : null;
  var weightEl = form ? form.querySelector('#calcWeight') : null;
  var breedEl = form ? form.querySelector('#calcBreed') : null;
  var customerId = getArtieCustomerId();
  var email = getArtieKlaviyoTrackEmail(form);
  if (!email) {
    return;
  }
  var listId = getArtieKlaviyoListId(sectionRoot);
  var subscribeSource = onProductPage ? 'Artie product page quiz' : 'Artie calculator page';
  /** @type {{ email: string; 'Accepts Marketing': boolean; '$consent': string[] }} */
  var identifyPayload = {
    email: email,
    'Accepts Marketing': true,
    '$consent': ['email']
  };

  /** @type {Record<string, string | number | boolean | null>} */
  var properties = {
    '$email': email,
    Source: onProductPage ? 'Artie product page quiz' : 'Artie calculator page',
    Dog_name: dog && dog.name ? String(dog.name) : '',
    Breed: dog && dog.breed ? String(dog.breed) : '',
    Age_years: dog && dog.age != null && !isNaN(Number(dog.age)) ? Number(dog.age) : null,
    Age_input_display: dog && dog.age != null ? formatAgeInputValue(dog.age) : '',
    Age_raw_input: ageEl && 'value' in ageEl ? String(/** @type {{ value: string }} */ (ageEl).value || '').trim() : '',
    Weight_lbs: dog && dog.weight != null && !isNaN(Number(dog.weight)) ? Number(dog.weight) : null,
    Weight_raw_input:
      weightEl && 'value' in weightEl ? String(/** @type {{ value: string }} */ (weightEl).value || '').trim() : '',
    Breed_raw_input:
      breedEl && 'value' in breedEl ? String(/** @type {{ value: string }} */ (breedEl).value || '').trim() : '',
    Gender: dog && dog.gender ? String(dog.gender) : '',
    Spayed_neutered: dog && dog.spayed ? String(dog.spayed) : '',
    Activity_level: dog && dog.activity ? String(dog.activity) : '',
    Body_condition_score: dog && dog.bcs != null ? String(dog.bcs) : '',
    Sensitive_tummy: dog && dog.sensitive ? String(dog.sensitive) : '',
    Pickiness: dog && dog.pickiness ? String(dog.pickiness) : '',
    Treats_frequency: dog && dog.treats ? String(dog.treats) : '',
    Customer_Shopify_id: customerId || null,
    Calculator_email: email,
    Recommended_plan_tier:
      reco && reco.portion ? String(reco.portion) : pl.recommended != null ? String(pl.recommended) : '',
    Estimated_plan_price_per_day: reco && reco.price != null ? Number(reco.price) : null,
    Reco_daily_kcal: reco && reco.dailyKcal != null ? Number(reco.dailyKcal) : null,
    Daily_kcal_total: pl.totalCal != null ? Number(pl.totalCal) : null,
    Meal_calories_per_day: pl.mealCal != null ? Number(pl.mealCal) : null,
    Treat_calories_per_day: pl.treatCal != null ? Number(pl.treatCal) : null,
    Half_meal_target_calories_per_day: pl.halfCal != null ? Number(pl.halfCal) : null,
    Full_plan_snapshot_json: pl.full ? JSON.stringify(pl.full) : '',
    Half_plan_snapshot_json: pl.half ? JSON.stringify(pl.half) : '',
    Topper_plan_snapshot_json: pl.topper ? JSON.stringify(pl.topper) : '',
    Page_URL: typeof location !== 'undefined' ? String(location.href) : ''
  };

  loadArtieKlaviyoOnsiteScript(publicKey, function() {
    var kw = /** @type {Window & { klaviyo?: { track?: Function; identify?: Function; push?: Function } }} */ (
      window
    ).klaviyo;
    var ko = /** @type {Window & { _klOnsite?: { push: Function } }} */ (window)._klOnsite;

    /** @param {() => void} onComplete */
    function doIdentifyQueued(onComplete) {
      try {
        if (kw && typeof kw.push === 'function') {
          kw.push(['identify', identifyPayload, onComplete]);
          return true;
        }
        if (ko && typeof ko.push === 'function') {
          ko.push(['identify', identifyPayload, onComplete]);
          return true;
        }
      } catch (errIdentifyQ) {}
      return false;
    }

    /** @param {() => void} onComplete */
    function doIdentify(onComplete) {
      try {
        if (kw && typeof kw.identify === 'function') {
          var identifyResult = kw.identify(identifyPayload);
          if (identifyResult && typeof identifyResult.then === 'function') {
            identifyResult.then(onComplete, onComplete);
            return;
          }
          onComplete();
          return;
        }
        if (!doIdentifyQueued(onComplete)) {
          onComplete();
        }
      } catch (errIdentify) {
        if (!doIdentifyQueued(onComplete)) {
          onComplete();
        }
      }
    }

    /** @param {() => void} onComplete */
    function doSubscribe(onComplete) {
      subscribeArtieKlaviyoEmailMarketing(publicKey, listId, email, subscribeSource, onComplete);
    }

    function doTrackQueued() {
      try {
        if (kw && typeof kw.push === 'function') {
          kw.push(['track', 'Artie Nutrition Calculator Submitted', properties]);
          return;
        }
        if (ko && typeof ko.push === 'function') {
          ko.push(['track', 'Artie Nutrition Calculator Submitted', properties]);
        }
      } catch (errQ) {}
    }

    function doTrack() {
      try {
        if (kw && typeof kw.track === 'function') {
          kw.track('Artie Nutrition Calculator Submitted', properties);
          return;
        }
        doTrackQueued();
      } catch (errT) {
        doTrackQueued();
      }
    }

    // Identify → subscribe → track so the session, consent, and event all land on the same profile.
    doIdentify(function() {
      doSubscribe(function() {
        doTrack();
      });
    });
  });
}

function submitCalculator(e) {
  e.preventDefault();
  var form = e.currentTarget;
  if (!validateCalcDogNameIfRequired(form)) return;
  if (!validateCalcEmailIfPresent(form)) return;
  if (!validateCalcWeight(form)) return;
  var sectionRoot = form && form.closest('[data-artie-calculator-standalone]');
  var isStandalone = !!sectionRoot;
  // Must run before any `getActivePackDogContext` / `loadQuizDogProfile` — variant:update can leave a stale
  // bundled ctx so quiz keys + pets store would target the wrong pack row (e.g. Maltese vs ddd).
  invalidateArtiePetsStoreReadCache();
  var ctx = getActivePackDogContext();
  var submitPackDogId = ctx && ctx.id != null ? ctx.id : null;
  var keyBase = getQuizKeyBase(ctx);
  var hidden = (form && form.querySelector('#dogName')) || document.getElementById('dogName');
  var profile = loadQuizDogProfile();
  var nameFromHidden = stripPossessive(hidden && hidden.value);
  var dog = { name: profile.name || (ctx && ctx.name) || nameFromHidden || '' };

  var _ageEl = form ? form.querySelector('#calcAge') : document.getElementById('calcAge');
  if (_ageEl) {
    var _ageVal = parseFloat(_ageEl.value);
    if (!isNaN(_ageVal) && _ageVal < 1) {
      alert('Puppy plans coming soon — please contact our concierge team for a custom recommendation.');
      return;
    }
  }

  var breedField = form ? form.querySelector('#calcBreed') : document.getElementById('calcBreed');
  dog.breed = (breedField && breedField.value.trim()) || 'Unknown / Mixed Breed';
  var ageNode = form ? form.querySelector('#calcAge') : document.getElementById('calcAge');
  var weightNode = form ? form.querySelector('#calcWeight') : document.getElementById('calcWeight');
  dog.age = normalizeQuizAge(ageNode ? ageNode.value : null);
  var weightStrict = parseQuizWeightInputStrict(weightNode ? weightNode.value : null); 
  dog.weight = weightStrict.valid && weightStrict.value != null ? weightStrict.value : normalizeQuizWeight(weightNode ? weightNode.value : null);
  var pillRoot = form || document;
  if (isStandalone) {
    var entered = stripPossessive(hidden && hidden.value);
    dog.name = String(entered || '').trim();
  }
  dog.gender = getCalcPill('gender', pillRoot) || '';
  dog.spayed = getCalcPill('spayed', pillRoot) || 'yes';
  dog.activity = getCalcPill('activity', pillRoot) || 'moderately_active';
  dog.bcs = getCalcPill('bcs', pillRoot) || '3';
  dog.sensitive = getCalcPill('sensitive', pillRoot) || 'no';
  dog.pickiness = getCalcPill('pickiness', pillRoot) || 'not_picky';
  dog.treats = getCalcPill('treats', pillRoot) || 'sometimes'; 

  var reco = recommendPortion(dog);

  if (isStandalone) {
    var standaloneMeta = null;
    try {
      standaloneMeta = appendCalculatorPagePetToStore(dog, reco);
      persistCalculatorRedirectDogContext(standaloneMeta);
    } catch (errS) {}
    var planForKlaviyo = (reco && reco.plan) || computePlan(dog);
    var standaloneCalcSucceeded =
      !!(
        planForKlaviyo &&
        planForKlaviyo.blocked !== 'puppy' &&
        planForKlaviyo.blocked !== 'weight' &&
        planForKlaviyo.recommended
      );
    renderStandaloneCalculatorResults(sectionRoot, dog, reco);
    if (standaloneCalcSucceeded) {
      trackArtieStandaloneCalculatorKlaviyo(sectionRoot, form, dog, reco, planForKlaviyo);
    }
    syncArtiePersonalizedStrip();
    return;
  }

  var planForKlaviyo = (reco && reco.plan) || computePlan(dog);
  var klaviyoRoot =
    form &&
    (form.closest('[data-artie-klaviyo-public-key]') || form.closest('.artie-quiz-overlay'));
  var productQuizQualifiesForKlaviyo =
    !!(
      planForKlaviyo &&
      planForKlaviyo.blocked !== 'puppy' &&
      planForKlaviyo.blocked !== 'weight' &&
      planForKlaviyo.recommended
    );
  if (productQuizQualifiesForKlaviyo) {
    trackArtieStandaloneCalculatorKlaviyo(klaviyoRoot, form, dog, reco, planForKlaviyo);
  }

  try {
    localStorage.setItem(keyBase + 'name', dog.name || '');
    localStorage.setItem(keyBase + 'breed', dog.breed);
    localStorage.setItem(keyBase + 'weight', String(dog.weight));
    localStorage.setItem(keyBase + 'age', String(formatAgeInputValue(dog.age)));
    localStorage.setItem(keyBase + 'gender', dog.gender || '');
    localStorage.setItem(keyBase + 'spayed', dog.spayed || 'yes');
    localStorage.setItem(keyBase + 'activity', dog.activity);
    localStorage.setItem(keyBase + 'bcs', dog.bcs);
    localStorage.setItem(keyBase + 'sensitive', dog.sensitive || 'no');
    localStorage.setItem(keyBase + 'pickiness', dog.pickiness || 'not_picky');
    localStorage.setItem(keyBase + 'treats', dog.treats);
    localStorage.setItem(keyBase + 'refined', 'true');
    localStorage.setItem(keyBase + 'last_updated', new Date().toISOString());
    localStorage.setItem('artie_dog_name', dog.name || '');
    localStorage.setItem('artie_dog_breed', dog.breed);
    localStorage.setItem('artie_dog_weight', String(dog.weight));
  } catch (err) {}

  try {
    saveQuizToArtiePetsStore(dog, reco);
  } catch (err2) {}

  try {
    invalidateArtiePetsStoreReadCache();
    var stPost = readArtiePetsStore();
    if (syncPackDogsLocalStorageFromPetsStore(stPost)) {
      if (submitPackDogId != null) {
        if (!setActivePackDogById(String(submitPackDogId))) {
          forceActivatePackDogById(String(submitPackDogId));
        }
      }
      notifyPackBuilderReloadFromArtieDogs();
    }
  } catch (eSync) {}

  showQuizSuccessState(dog, reco);
  syncJsDogNameDisplays();
  if (reco && reco.portion) {
    applyQuizPortionToVariantPicker(reco.portion);
  } else {
    syncVariantPickerFromQuizStore();
  }
  syncArtiePersonalizedStrip();
}

function resolveStandaloneCalculatorCtaHref(sectionRoot, cta) {
  var href = '';
  if (cta && cta.tagName === 'A') {
    href = String(cta.getAttribute('href') || '').trim();
  }
  if (!href && sectionRoot) {
    href = String(sectionRoot.getAttribute('data-artie-calc-cta-link') || '').trim();
  }
  if (!href || href === '#') return '';
  return href;
}

var artieStandaloneCalcCtaBound = false;
function bindStandaloneCalculatorCtaRedirectOnce() {
  if (artieStandaloneCalcCtaBound) return;
  artieStandaloneCalcCtaBound = true;
  document.addEventListener('click', function(e) {
    var cta = e.target.closest('#resultsCta');
    if (!cta) return;
    var sectionRoot = cta.closest('[data-artie-calculator-standalone]');
    if (!sectionRoot) return;
    var href = resolveStandaloneCalculatorCtaHref(sectionRoot, cta);
    if (!href) return;
    var calcCtx = readCalculatorRedirectDogContext();
    if (calcCtx && calcCtx.packDogId) {
      forceActivatePackDogById(calcCtx.packDogId);
    }
    e.preventDefault();
    window.location.assign(href);
  });
}

var ARTIE_CALENDLY_WIDGET_CSS_URL = 'https://assets.calendly.com/assets/external/widget.css';
var ARTIE_CALENDLY_WIDGET_JS_URL = 'https://assets.calendly.com/assets/external/widget.js';
var ARTIE_CALENDLY_POPUP_URL = 'https://calendly.com/artie-vip/artie-express-concierge-call';
var artieCalendlyWidgetLoadPromise = null;
var artieCalendlyWidgetBound = false;

function ensureArtieCalendlyWidgetCss() {
  var existing = document.querySelector('link[data-artie-calendly-widget-css="true"]');
  if (existing) return;
  var link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = ARTIE_CALENDLY_WIDGET_CSS_URL;
  link.setAttribute('data-artie-calendly-widget-css', 'true');
  (document.head || document.documentElement).appendChild(link);
}

function ensureArtieCalendlyWidgetScript() {
  if (window.Calendly && typeof window.Calendly.initPopupWidget === 'function') {
    return Promise.resolve(window.Calendly);
  }
  if (artieCalendlyWidgetLoadPromise) return artieCalendlyWidgetLoadPromise;
  artieCalendlyWidgetLoadPromise = new Promise(function(resolve, reject) {
    var existing = document.querySelector(
      'script[data-artie-calendly-widget-js="true"], script[src*="assets.calendly.com/assets/external/widget.js"]'
    );
    if (existing) {
      existing.addEventListener('load', function() {
        resolve(window.Calendly || null);
      }, { once: true });
      existing.addEventListener('error', function() {
        reject(new Error('Calendly widget failed to load'));
      }, { once: true });
      return;
    }
    var script = document.createElement('script');
    script.src = ARTIE_CALENDLY_WIDGET_JS_URL;
    script.async = true;
    script.setAttribute('data-artie-calendly-widget-js', 'true');
    script.addEventListener('load', function() {
      resolve(window.Calendly || null);
    }, { once: true });
    script.addEventListener('error', function() {
      reject(new Error('Calendly widget failed to load'));
    }, { once: true });
    (document.head || document.documentElement).appendChild(script);
  });
  return artieCalendlyWidgetLoadPromise;
}

function openArtieCalendlyPopupWidget() {
  ensureArtieCalendlyWidgetCss();
  return ensureArtieCalendlyWidgetScript()
    .then(function() {
      if (!window.Calendly || typeof window.Calendly.initPopupWidget !== 'function') return;
      window.Calendly.initPopupWidget({ url: ARTIE_CALENDLY_POPUP_URL });
    })
    .catch(function() {});
}

function bindArtieCalendlyWidgetOnce() {
  if (artieCalendlyWidgetBound) return;
  artieCalendlyWidgetBound = true;
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('.js-Calendly-widget');
    if (!trigger) return;
    e.preventDefault();
    openArtieCalendlyPopupWidget();
  });
}

var artieDogRemovedListenerBound = false;
function bindArtieDogRemovedListenerOnce() {
  if (artieDogRemovedListenerBound) return;
  artieDogRemovedListenerBound = true;
  document.addEventListener('artie:dog-removed', onArtieDogRemoved);
}

var artiePackWeightQuizBound = false;
function bindArtiePackWeightQuizListenerOnce() {
  if (artiePackWeightQuizBound) return;
  artiePackWeightQuizBound = true;
  document.addEventListener('artie:dog-weight-changed', onArtieDogWeightChanged);
}

/**
 * Self-heal: compute + persist the recommended-portion row for any pack dog
 * that lacks one. Pack-builder's boot dispatch can fire before this script's
 * listener exists (script order follows block order in the template), which
 * left dogs without rows - and resolveMealPlanForPackContext returns null
 * for row-less dogs, silently dropping them from add-to-cart.
 */
function artieHealMissingPortionRows() {
  try {
    var dogs = JSON.parse(localStorage.getItem('artie-dogs') || '[]');
    if (!Array.isArray(dogs) || !dogs.length) return;
    var rows = readRecommendedPortionStore();
    var i, j;
    for (i = 0; i < dogs.length; i++) {
      var d = dogs[i];
      if (!d || d.id == null) continue;
      var idStr = String(d.id);
      var hasRow = false;
      for (j = 0; j < rows.length; j++) {
        if (rows[j] && String(rows[j].dog_id) === idStr) { hasRow = true; break; }
      }
      if (hasRow) continue;
      var w = Number(d.weight);
      if (!isNaN(w) && w > 0) applyPackWeightQuizSideEffects(d.id, w, {});
    }
  } catch (eHeal) {}
}

function toggleCalcInfo(id, event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }
  var el = document.getElementById('calcInfo-' + id);
  if (!el) return;
  
  var isVisible = el.style.display === 'flex';
  el.style.display = isVisible ? 'none' : 'flex';
  
  // Toggle body scroll
  if (!isVisible) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
}

function quizCalcBootstrap() {
  bindCalcStepperButtonsOnce();
  invalidateArtiePetsStoreReadCache();
  hydrateLocalStorageFromCustomerPetsMetafield();
  bindArtieDogRemovedListenerOnce();
  bindArtieVariantQuizSyncOnce();
  bindArtiePackWeightQuizListenerOnce();
  artieHealMissingPortionRows();
  bindArtieCartCurrentRecipeListenerOnce();
  bindArtieGlobalDocumentListenersOnce();
  bindArtiePdpVariantCopyOnce();
  initQuizOverlayUI();
  bindStandaloneCalculatorPageOnce();
  bindStandaloneCalculatorCtaRedirectOnce();
  bindArtieCalendlyWidgetOnce();
  try {
    var storeForPack = readArtiePetsStore();
    if (syncPackDogsLocalStorageFromPetsStore(storeForPack)) {
      dispatchArtiePackDogsFromStoreEvent(true);
    }
    syncRecommendedPortionFromPetsStore(storeForPack);
    scheduleArtieMealPlanContext();
    scheduleSyncMultipleDogAtcStore();
  } catch (ePackSync) {}
  tryApplyCalculatorRedirectDogContextOnPdp();
  tryBindArtieCartDrawerDogNameObserver();
  syncJsDogNameDisplays();

  // Paint initial state of any visible sliders (static calculator)
  document.querySelectorAll('input.quiz-slider[type="range"]').forEach(function(s) {
    paintCalcSlider(s);
  });
  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      syncArtiePortionVariantAvailabilityFromRecommendedStore();
      syncVariantPickerFromQuizStore();
      scheduleArtiePortionVariantAvailabilitySync();
      syncArtiePersonalizedStrip();
      var snap = getCurrentMainVariantSnapshot();
      if (snap && snap.id != null) syncArtieCurrentRecipeFromPdpVariant(snap);
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', quizCalcBootstrap);
} else {
  quizCalcBootstrap();
}
//cache bust 5.20.26d